import { AuthorizedApiBase } from './api-client-config.js'
import { UnauthorizedApiBase } from './api-client-config.js'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class GetUserProfileClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get() {
        let url_ = this.baseUrl + "/api/v1/userprofile";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserProfileQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateUserProfileClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateUserProfileCommand) {
        let url_ = this.baseUrl + "/api/v1/userprofile/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateUserProfileCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class StaffTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    staffLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Staff";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffLookup(_response);
        });
    }
    processStaffLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStaffLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllProjectTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    allProjectLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllProject";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAllProjectLookup(_response);
        });
    }
    processAllProjectLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllProjectLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BlockTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    blockLookup(getBlockLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Block";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getBlockLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBlockLookup(_response);
        });
    }
    processBlockLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetBlockLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BuildingBlockTypeTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    buildingBlockTypeLookup(getBuildingBlockTypeLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/BuildingBlockType";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getBuildingBlockTypeLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBuildingBlockTypeLookup(_response);
        });
    }
    processBuildingBlockTypeLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetBuildingBlockTypeLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ConstructionSiteTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    constructionSiteLookup(getConstructionSiteLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/ConstructionSite";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getConstructionSiteLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processConstructionSiteLookup(_response);
        });
    }
    processConstructionSiteLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetConstructionSiteLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class PlotTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    plotLookup(getPlotLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Plot";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPlotLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPlotLookup(_response);
        });
    }
    processPlotLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPlotLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ProjectTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    projectLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Project";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProjectLookup(_response);
        });
    }
    processProjectLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetProjectLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ProjectUsersTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    projectUsersLookup(projectId) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/ProjectUsers?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProjectUsersLookup(_response);
        });
    }
    processProjectUsersLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetProjectUsersLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ProposalCompanyLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    proposalCompanyLookup(getProposalCompanyLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/ProposalCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getProposalCompanyLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProposalCompanyLookup(_response);
        });
    }
    processProposalCompanyLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetProposalCompanyLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ScoreCardLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    scoreCardLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/ScoreCard";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processScoreCardLookup(_response);
        });
    }
    processScoreCardLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetScoreCardLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllProductForUpdateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    allProductForUpdate() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllProductForUpdate";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAllProductForUpdate(_response);
        });
    }
    processAllProductForUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllProductLookupForUpdateQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllProductTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    productLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllProduct";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductLookup(_response);
        });
    }
    processProductLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllProductLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class StockProductTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    stockProductLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/StockProduct";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockProductLookup(_response);
        });
    }
    processStockProductLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStockProductLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class WarehouseTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    warehouseLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Warehouse";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processWarehouseLookup(_response);
        });
    }
    processWarehouseLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetWarehouseLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllRoleTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    roleLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllRole";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRoleLookup(_response);
        });
    }
    processRoleLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllRoleLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UserByUserProjectTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    usersLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Users";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUsersLookup(_response);
        });
    }
    processUsersLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllUserByUserProjectLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllUserTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    userLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllUser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUserLookup(_response);
        });
    }
    processUserLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllUserLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllCompanyByProjectLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAllCompanyByProjectLookup(getAllCompanyByProjectLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/GetCompanies";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllCompanyByProjectLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAllCompanyByProjectLookup(_response);
        });
    }
    processGetAllCompanyByProjectLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllCompanyByProjectLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CompanyInformationLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getCompanyInformationLookup(getCompanyInformationLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/GetCompanyInformation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getCompanyInformationLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetCompanyInformationLookup(_response);
        });
    }
    processGetCompanyInformationLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCompanyInformationLookupQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllCompanyTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    companyLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllCompany";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCompanyLookup(_response);
        });
    }
    processCompanyLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllCompanyLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DynamicReportRoleLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    dynamicReportRoleLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllDynamicReportRole";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDynamicReportRoleLookup(_response);
        });
    }
    processDynamicReportRoleLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllDynamicReportRoleLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AccountTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    accountLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/Account";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAccountLookup(_response);
        });
    }
    processAccountLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAccountLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdvanceCheckLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAdvanceCheckLookup(getAdvanceCheckLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/GetAdvanceCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAdvanceCheckLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAdvanceCheckLookup(_response);
        });
    }
    processGetAdvanceCheckLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAdvanceCheckLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AllAccountLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    allAccountLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/AllAccount";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAllAccountLookup(_response);
        });
    }
    processAllAccountLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllAccountLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetUsableCheckTenantLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getUsableCheckLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/GetUsableCheck";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetUsableCheckLookup(_response);
        });
    }
    processGetUsableCheckLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetUsableCheckLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ExtendedAccountLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    extendedAccountLookup() {
        let url_ = this.baseUrl + "/api/v1/tenantlookup/ExtendedAccount";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExtendedAccountLookup(_response);
        });
    }
    processExtendedAccountLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetExtendedAccountLookupQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateStaffCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateSalaryCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ArchivingStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/staff/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingStaffCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/staff/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createStaffCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateStaffCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/staff/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteStaffCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStaffQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, identityNumber, projectId, hasBalance, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/staff/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (identityNumber !== undefined && identityNumber !== null)
            url_ += "IdentityNumber=" + encodeURIComponent("" + identityNumber) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (hasBalance !== undefined && hasBalance !== null)
            url_ += "HasBalance=" + encodeURIComponent("" + hasBalance) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchStaffQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, identityNumber, projectId, hasBalance, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/staff/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (identityNumber !== undefined && identityNumber !== null)
            url_ += "IdentityNumber=" + encodeURIComponent("" + identityNumber) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (hasBalance !== undefined && hasBalance !== null)
            url_ += "HasBalance=" + encodeURIComponent("" + hasBalance) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateStaffClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/staff/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateStaffCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingStaffCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createSalaryCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createSalaryCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSalaryCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteSalaryCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteSalaryCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetMonthlySalaryByYearMonthClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getMonthlySalaryByYearMonthQuery) {
        let url_ = this.baseUrl + "/api/v1/salary/GetMonthlySalaryByYearMonth";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getMonthlySalaryByYearMonthQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMonthlySalaryByYearMonthQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetMonthlySalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getMonthlySalaryQuery) {
        let url_ = this.baseUrl + "/api/v1/salary/GetMonthlySalary";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getMonthlySalaryQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMonthlySalaryQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetMonthlySalaryForPaymentClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getMonthlySalaryForPaymentQuery) {
        let url_ = this.baseUrl + "/api/v1/salary/GetMonthlySalaryForPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getMonthlySalaryForPaymentQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetMonthlySalaryForPaymentQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getMonthlySalaryForPaymentExcel(getMonthlySalaryForPaymentQuery) {
        let url_ = this.baseUrl + "/api/v1/salary/GetMonthlySalaryForPaymentExcel";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getMonthlySalaryForPaymentQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetMonthlySalaryForPaymentExcel(_response);
        });
    }
    processGetMonthlySalaryForPaymentExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/salary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSalaryQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchByStaffIdSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(staffId) {
        let url_ = this.baseUrl + "/api/v1/salary/SearchByStaffId?";
        if (staffId !== undefined && staffId !== null)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchByStaffIdQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchByStaffIdExcel(staffId) {
        let url_ = this.baseUrl + "/api/v1/salary/SearchByStaffIdExcel?";
        if (staffId !== undefined && staffId !== null)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchByStaffIdExcel(_response);
        });
    }
    processSearchByStaffIdExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchMonthlySalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(projectId, year, month, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/salary/SearchMonthlySalary?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchMonthlySalaryQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchMonthlyExcel(projectId, year, month, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/salary/SearchMonthlySalaryExcel?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchMonthlyExcel(_response);
        });
    }
    processSearchMonthlyExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchSalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    searchSalary(name, progressPaymentDate, projectId, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/salary/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (progressPaymentDate === null)
            throw new Error("The parameter 'progressPaymentDate' cannot be null.");
        else if (progressPaymentDate !== undefined)
            url_ += "ProgressPaymentDate=" + encodeURIComponent(progressPaymentDate ? "" + progressPaymentDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchSalary(_response);
        });
    }
    processSearchSalary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchSalaryQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, progressPaymentDate, projectId, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/salary/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (progressPaymentDate === null)
            throw new Error("The parameter 'progressPaymentDate' cannot be null.");
        else if (progressPaymentDate !== undefined)
            url_ += "ProgressPaymentDate=" + encodeURIComponent(progressPaymentDate ? "" + progressPaymentDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateMonthlySalaryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateStaffCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/UpdateMonthlySalary";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateStaffCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateMonthlySalaryCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateMonthlySalaryForPaymentClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateMonthlySalaryForPaymentCommand) {
        let url_ = this.baseUrl + "/api/v1/salary/UpdateMonthlySalaryForPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateMonthlySalaryForPaymentCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateMonthlySalaryForPaymentCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createEarningOvertimeCommand) {
        let url_ = this.baseUrl + "/api/v1/overtime/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createEarningOvertimeCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateOvertimeCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteOvertimeCommand) {
        let url_ = this.baseUrl + "/api/v1/overtime/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteOvertimeCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/overtime/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOvertimeQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchByStaffIdOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(staffId) {
        let url_ = this.baseUrl + "/api/v1/overtime/SearchByStaffId?";
        if (staffId !== undefined && staffId !== null)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchByStaffIdQueryResponse2.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchByStaffIdExcel(staffId) {
        let url_ = this.baseUrl + "/api/v1/overtime/SearchByStaffIdExcel?";
        if (staffId !== undefined && staffId !== null)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchByStaffIdExcel(_response);
        });
    }
    processSearchByStaffIdExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/overtime/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchOvertimeQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/overtime/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateOvertimeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateOvertimeCommand) {
        let url_ = this.baseUrl + "/api/v1/overtime/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateOvertimeCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateOvertimeCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createEarningLeaveCommand) {
        let url_ = this.baseUrl + "/api/v1/leave/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createEarningLeaveCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateLeaveCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteLeaveCommand) {
        let url_ = this.baseUrl + "/api/v1/leave/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteLeaveCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/leave/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetLeaveQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchByStaffIdLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchByStaffIdQuery) {
        let url_ = this.baseUrl + "/api/v1/leave/SearchByStaffId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchByStaffIdQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchByStaffIdQueryResponse3.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchByStaffIdExcel(staffId) {
        let url_ = this.baseUrl + "/api/v1/leave/SearchByStaffIdExcel?";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchByStaffIdExcel(_response);
        });
    }
    processSearchByStaffIdExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/leave/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchLeaveQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, staffId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/leave/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateLeaveCommand) {
        let url_ = this.baseUrl + "/api/v1/leave/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateLeaveCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateEarningLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createEarningLeaveCommand) {
        let url_ = this.baseUrl + "/api/v1/earningleave/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createEarningLeaveCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateEarningLeaveCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteEarningLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteEarningLeaveCommand) {
        let url_ = this.baseUrl + "/api/v1/earningleave/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteEarningLeaveCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllEarningLeaveByStaffIdClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllEarningLeaveByStaffIdQuery) {
        let url_ = this.baseUrl + "/api/v1/earningleave/GetAllByStaffId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllEarningLeaveByStaffIdQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllEarningLeaveByStaffIdQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetEarningLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/earningleave/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetEarningLeaveQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetBalanceEarningLeaveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(staffId) {
        let url_ = this.baseUrl + "/api/v1/earningleave/Balance?";
        if (staffId !== undefined && staffId !== null)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRemainingLeaveQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateCertificateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(staffId, name, startDate, endDate, file) {
        let url_ = this.baseUrl + "/api/v1/certificate/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (staffId !== null && staffId !== undefined)
            content_.append("StaffId", staffId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (startDate !== null && startDate !== undefined)
            content_.append("StartDate", startDate.toJSON());
        if (endDate !== null && endDate !== undefined)
            content_.append("EndDate", endDate.toJSON());
        if (file !== null && file !== undefined)
            content_.append("File", file, file.name ? file.name : "File");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateCertificateCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteCertificateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteCertificateCommand) {
        let url_ = this.baseUrl + "/api/v1/certificate/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteCertificateCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class TryOutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(invoiceId) {
        let url_ = this.baseUrl + "/api/v1/tryout/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateFirstTableClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateFirstTableCommand) {
        let url_ = this.baseUrl + "/api/v1/firsttable/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateFirstTableCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateFirstTableCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetFirstTableClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/firsttable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllFirstTableQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DeleteFirstTableClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(id) {
        let url_ = this.baseUrl + "/api/v1/firsttable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetFirstTablePdfClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/firsttable/pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetAllFirstTableExcelClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get() {
        let url_ = this.baseUrl + "/api/v1/firsttable/excel";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateFirstTableClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createFirstTableCommand) {
        let url_ = this.baseUrl + "/api/v1/firsttable/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createFirstTableCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateFirstTableCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllBookClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll() {
        let url_ = this.baseUrl + "/api/v1/book/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllBookQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetAllFirstTableClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll() {
        let url_ = this.baseUrl + "/api/v1/firsttable/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllFirstTableQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CashFlowReportContollerClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(query) {
        let url_ = this.baseUrl + "/api/v1/reporting/CashFlowReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashFlowReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetDynamicReportEntityClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getSaleInvoicePaymentPlanQueryResponse() {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoicePaymentPlan";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSaleInvoicePaymentPlanQueryResponse(_response);
        });
    }
    processGetSaleInvoicePaymentPlanQueryResponse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoicePaymentPlanQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSaleWithBalanceQueryResponse() {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleWithBalance";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSaleWithBalanceQueryResponse(_response);
        });
    }
    processGetSaleWithBalanceQueryResponse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleWithBalanceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getExpenseInvoicePaymentPlanQueryResponse() {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoicePaymentPlan";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetExpenseInvoicePaymentPlanQueryResponse(_response);
        });
    }
    processGetExpenseInvoicePaymentPlanQueryResponse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoicePaymentPlanQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getExpenseWithBalanceQueryResponse() {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseWithBalance";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetExpenseWithBalanceQueryResponse(_response);
        });
    }
    processGetExpenseWithBalanceQueryResponse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseWithBalanceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceReport() {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceReport";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceReport(_response);
        });
    }
    processExpenseInvoiceReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceReportQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceReport() {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceReport";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceReport(_response);
        });
    }
    processSaleInvoiceReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceReportQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getChecksWithExpenseInvoiceQueryResponse() {
        let url_ = this.baseUrl + "/api/v1/reporting/ChecksWithExpenseInvoice";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetChecksWithExpenseInvoiceQueryResponse(_response);
        });
    }
    processGetChecksWithExpenseInvoiceQueryResponse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ChecksWithExpenseInvoiceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceChartCategory(startDate, endDate, staffId, expenseCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceChartCategory?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "ExpenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceChartCategory(_response);
        });
    }
    processExpenseInvoiceChartCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceChartCategoryQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceChartProject(startDate, endDate, staffId, expenseCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceChartProject?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "ExpenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceChartProject(_response);
        });
    }
    processExpenseInvoiceChartProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceChartProjectQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceChartDate(startDate, endDate, staffId, expenseCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceChartDate?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "ExpenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceChartDate(_response);
        });
    }
    processExpenseInvoiceChartDate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceChartDateQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceChartMonth(startDate, endDate, staffId, expenseCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceChartMonth?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "ExpenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceChartMonth(_response);
        });
    }
    processExpenseInvoiceChartMonth(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceChartMonthQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    expenseInvoiceChartStatus(startDate, endDate, staffId, expenseCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ExpenseInvoiceChartStatus?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "ExpenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpenseInvoiceChartStatus(_response);
        });
    }
    processExpenseInvoiceChartStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExpenseInvoiceChartStatusQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceChartCategory(startDate, endDate, saleCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceChartCategory?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleCategoryId !== undefined && saleCategoryId !== null)
            url_ += "SaleCategoryId=" + encodeURIComponent("" + saleCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceChartCategory(_response);
        });
    }
    processSaleInvoiceChartCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceChartCategoryQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceChartProject(startDate, endDate, saleProjectId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceChartProject?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleProjectId !== undefined && saleProjectId !== null)
            url_ += "SaleProjectId=" + encodeURIComponent("" + saleProjectId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceChartProject(_response);
        });
    }
    processSaleInvoiceChartProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceChartProjectQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceChartDate(startDate, endDate, saleCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceChartDate?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleCategoryId !== undefined && saleCategoryId !== null)
            url_ += "SaleCategoryId=" + encodeURIComponent("" + saleCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceChartDate(_response);
        });
    }
    processSaleInvoiceChartDate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceChartDateQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceChartMonth(startDate, endDate, saleCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceChartMonth?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleCategoryId !== undefined && saleCategoryId !== null)
            url_ += "SaleCategoryId=" + encodeURIComponent("" + saleCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceChartMonth(_response);
        });
    }
    processSaleInvoiceChartMonth(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceChartMonthQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceRealEstateChartMonth(startDate, endDate, saleCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceRealEstateChartMonth?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleCategoryId !== undefined && saleCategoryId !== null)
            url_ += "SaleCategoryId=" + encodeURIComponent("" + saleCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceRealEstateChartMonth(_response);
        });
    }
    processSaleInvoiceRealEstateChartMonth(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceRealEstateChartMonthQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saleInvoiceChartStatus(startDate, endDate, saleCategoryId, paymentStatusId, projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/SaleInvoiceChartStatus?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (saleCategoryId !== undefined && saleCategoryId !== null)
            url_ += "SaleCategoryId=" + encodeURIComponent("" + saleCategoryId) + "&";
        if (paymentStatusId !== undefined && paymentStatusId !== null)
            url_ += "PaymentStatusId=" + encodeURIComponent("" + paymentStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSaleInvoiceChartStatus(_response);
        });
    }
    processSaleInvoiceChartStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleInvoiceChartStatusQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    blockCompleteRateByConstructionSite(projectId, constructionSiteId) {
        let url_ = this.baseUrl + "/api/v1/reporting/BlockCompleteRateByConstructionSite?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (constructionSiteId !== undefined && constructionSiteId !== null)
            url_ += "ConstructionSiteId=" + encodeURIComponent("" + constructionSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBlockCompleteRateByConstructionSite(_response);
        });
    }
    processBlockCompleteRateByConstructionSite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    blockCompleteRateWithConstructionSiteByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/BlockCompleteRateWithConstructionSiteByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBlockCompleteRateWithConstructionSiteByProject(_response);
        });
    }
    processBlockCompleteRateWithConstructionSiteByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BlockCompleteRateWithConstructionSiteByProjectQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    constructionSiteCompleteRateByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ConstructionSiteCompleteRateByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processConstructionSiteCompleteRateByProject(_response);
        });
    }
    processConstructionSiteCompleteRateByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    dailyTaskCompleteRateByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/DailyTaskCompleteRateByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDailyTaskCompleteRateByProject(_response);
        });
    }
    processDailyTaskCompleteRateByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    projectCompleteRateByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/ProjectCompleteRateByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProjectCompleteRateByProject(_response);
        });
    }
    processProjectCompleteRateByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    rootTaskCompleteRateByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/RootTaskCompleteRateByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRootTaskCompleteRateByProject(_response);
        });
    }
    processRootTaskCompleteRateByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    taskAndPlotCompleteRateByConstructionSite(projectId, constructionSiteId) {
        let url_ = this.baseUrl + "/api/v1/reporting/TaskAndPlotCompleteRateByConstructionSite?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (constructionSiteId !== undefined && constructionSiteId !== null)
            url_ += "ConstructionSiteId=" + encodeURIComponent("" + constructionSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTaskAndPlotCompleteRateByConstructionSite(_response);
        });
    }
    processTaskAndPlotCompleteRateByConstructionSite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    taskCompleteRateByConstructionSite(projectId, constructionSiteId) {
        let url_ = this.baseUrl + "/api/v1/reporting/TaskCompleteRateByConstructionSite?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (constructionSiteId !== undefined && constructionSiteId !== null)
            url_ += "ConstructionSiteId=" + encodeURIComponent("" + constructionSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTaskCompleteRateByConstructionSite(_response);
        });
    }
    processTaskCompleteRateByConstructionSite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    taskCompleteRateByProject(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/TaskCompleteRateByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTaskCompleteRateByProject(_response);
        });
    }
    processTaskCompleteRateByProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    monthlyPayroll(projectId) {
        let url_ = this.baseUrl + "/api/v1/reporting/MonthlyPayroll?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processMonthlyPayroll(_response);
        });
    }
    processMonthlyPayroll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    accountWithCredit(query) {
        let url_ = this.baseUrl + "/api/v1/reporting/AccountWithCredit?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAccountWithCredit(_response);
        });
    }
    processAccountWithCredit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AccountWithCreditQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    closedCredit(query) {
        let url_ = this.baseUrl + "/api/v1/reporting/ClosedCredit?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processClosedCredit(_response);
        });
    }
    processClosedCredit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ClosedCreditQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchDynamicReportContollerClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/reporting/SearchDynamicReport?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchDynamicReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ArchivingRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingRealEstateCommand) {
        let url_ = this.baseUrl + "/api/v1/realestate/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingRealEstateCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createRealEstateCommand) {
        let url_ = this.baseUrl + "/api/v1/realestate/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createRealEstateCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRealEstateCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteRealEstateCommand) {
        let url_ = this.baseUrl + "/api/v1/realestate/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteRealEstateCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/realestate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRealEstateQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, estateTypeId, estateStateId, projectId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/realestate/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (estateTypeId !== undefined && estateTypeId !== null)
            url_ += "EstateTypeId=" + encodeURIComponent("" + estateTypeId) + "&";
        if (estateStateId !== undefined && estateStateId !== null)
            url_ += "EstateStateId=" + encodeURIComponent("" + estateStateId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchRealEstateQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, estateTypeId, estateStateId, projectId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/realestate/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (estateTypeId !== undefined && estateTypeId !== null)
            url_ += "EstateTypeId=" + encodeURIComponent("" + estateTypeId) + "&";
        if (estateStateId !== undefined && estateStateId !== null)
            url_ += "EstateStateId=" + encodeURIComponent("" + estateStateId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateRealEstateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateRealEstateCommand) {
        let url_ = this.baseUrl + "/api/v1/realestate/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateRealEstateCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(command) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateTimeKeepingTemplateCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(command) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTimeKeepingTemplateQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, projectId, timeKeepingTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timeKeepingTypeId !== undefined && timeKeepingTypeId !== null)
            url_ += "TimeKeepingTypeId=" + encodeURIComponent("" + timeKeepingTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchTimeKeepingTemplateQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, projectId, timeKeepingTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timeKeepingTypeId !== undefined && timeKeepingTypeId !== null)
            url_ += "TimeKeepingTypeId=" + encodeURIComponent("" + timeKeepingTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(command) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/task/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingTaskCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/task/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createTaskCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateTaskCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/task/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteTaskCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTaskQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(projectId, constructionSiteId, blockId, plotId, taskStateId, staffId, onlyRootTask, name, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/task/Search?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (constructionSiteId !== undefined && constructionSiteId !== null)
            url_ += "ConstructionSiteId=" + encodeURIComponent("" + constructionSiteId) + "&";
        if (blockId !== undefined && blockId !== null)
            url_ += "BlockId=" + encodeURIComponent("" + blockId) + "&";
        if (plotId !== undefined && plotId !== null)
            url_ += "PlotId=" + encodeURIComponent("" + plotId) + "&";
        if (taskStateId !== undefined && taskStateId !== null)
            url_ += "TaskStateId=" + encodeURIComponent("" + taskStateId) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (onlyRootTask !== undefined && onlyRootTask !== null)
            url_ += "OnlyRootTask=" + encodeURIComponent("" + onlyRootTask) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchTaskQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(projectId, constructionSiteId, blockId, plotId, taskStateId, staffId, onlyRootTask, name, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/task/Excel?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (constructionSiteId !== undefined && constructionSiteId !== null)
            url_ += "ConstructionSiteId=" + encodeURIComponent("" + constructionSiteId) + "&";
        if (blockId !== undefined && blockId !== null)
            url_ += "BlockId=" + encodeURIComponent("" + blockId) + "&";
        if (plotId !== undefined && plotId !== null)
            url_ += "PlotId=" + encodeURIComponent("" + plotId) + "&";
        if (taskStateId !== undefined && taskStateId !== null)
            url_ += "TaskStateId=" + encodeURIComponent("" + taskStateId) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (onlyRootTask !== undefined && onlyRootTask !== null)
            url_ += "OnlyRootTask=" + encodeURIComponent("" + onlyRootTask) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateTaskCompletionClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateTaskCompletionCommand) {
        let url_ = this.baseUrl + "/api/v1/task/UpdateCompletion";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateTaskCompletionCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/task/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateTaskCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateScoreCardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createScoreCardCommand) {
        let url_ = this.baseUrl + "/api/v1/scorecard/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createScoreCardCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateScoreCardCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteScoreCardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteScoreCardCommand) {
        let url_ = this.baseUrl + "/api/v1/scorecard/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteScoreCardCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetScoreCardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/scorecard/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetScoreCardQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchScoreCardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/scorecard/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchScoreCardQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/scorecard/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateScoreCardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateScoreCardCommand) {
        let url_ = this.baseUrl + "/api/v1/scorecard/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateScoreCardCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetScoreCardDaysClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchScoreCardQuery) {
        let url_ = this.baseUrl + "/api/v1/scorecardday/Get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchScoreCardQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetScoreCardDaysQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateScoreCardDaysClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateScoreCardDaysCommand) {
        let url_ = this.baseUrl + "/api/v1/scorecardday/UpdateScoreCardDays";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateScoreCardDaysCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingPurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingPurchaseRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingPurchaseRequestCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(name, projectId, companyId, editDate, dueDate, purchaseRequestStatusId, note, relatedUserId, file, purchaseRequestItems) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (editDate !== null && editDate !== undefined)
            content_.append("EditDate", editDate.toJSON());
        if (dueDate !== null && dueDate !== undefined)
            content_.append("DueDate", dueDate.toJSON());
        if (purchaseRequestStatusId !== null && purchaseRequestStatusId !== undefined)
            content_.append("PurchaseRequestStatusId", purchaseRequestStatusId.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (relatedUserId !== null && relatedUserId !== undefined)
            content_.append("RelatedUserId", relatedUserId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file, file.name ? file.name : "File");
        if (purchaseRequestItems === null || purchaseRequestItems === undefined)
          throw new Error("The parameter 'purchaseRequestItems' cannot be null.");
        else {
          purchaseRequestItems.forEach((item, index) => {
            if (item.ProductId != null) {
              content_.append(`PurchaseRequestItems[${index}].ProductId`, item.ProductId.toString());
            }
            if (item.Amount != null) {
              content_.append(`PurchaseRequestItems[${index}].Amount`, item.Amount.toString());
            }
            if (item.ProductUnitId != null) {
              content_.append(`PurchaseRequestItems[${index}].ProductUnitId`, item.ProductUnitId.toString());
            }
	        if (item.Description != null) {
              content_.append(`PurchaseRequestItems[${index}].Description`, item.Description.toString());
            }
          });
        }
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePurchaseRequestCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeletePurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePurchaseRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePurchaseRequestCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetPurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetPurchaseRequestWithAllSubInfoClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getPurchaseRequestWithAllSubInfoQuery) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/GetPurchaseRequestWithAllSubInfo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPurchaseRequestWithAllSubInfoQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseRequestWithAllSubInfoQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, purchaseRequestStatusId, projectId, companyId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (purchaseRequestStatusId !== undefined && purchaseRequestStatusId !== null)
            url_ += "PurchaseRequestStatusId=" + encodeURIComponent("" + purchaseRequestStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPurchaseRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, purchaseRequestStatusId, projectId, companyId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (purchaseRequestStatusId !== undefined && purchaseRequestStatusId !== null)
            url_ += "PurchaseRequestStatusId=" + encodeURIComponent("" + purchaseRequestStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateEvaluationResultClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateEvaluationResultCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/UpdateEvaluationResult";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateEvaluationResultCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePurchaseRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(id, name, projectId, companyId, editDate, dueDate, purchaseRequestStatusId, note, relatedStaffId, file, purchaseRequestItems) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (editDate !== null && editDate !== undefined)
            content_.append("EditDate", editDate.toJSON());
        if (dueDate !== null && dueDate !== undefined)
            content_.append("DueDate", dueDate.toJSON());
        if (purchaseRequestStatusId !== null && purchaseRequestStatusId !== undefined)
            content_.append("PurchaseRequestStatusId", purchaseRequestStatusId.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (relatedStaffId !== null && relatedStaffId !== undefined)
            content_.append("RelatedStaffId", relatedStaffId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file, file.name ? file.name : "File");
		if (purchaseRequestItems === null || purchaseRequestItems === undefined)
		  throw new Error("The parameter 'purchaseRequestItems' cannot be null.");
		else {
		  purchaseRequestItems.forEach((item, index) => {
			if (item.Id != null) {
			  content_.append(`PurchaseRequestItems[${index}].Id`, item.Id.toString());
			}
			if (item.ProductId != null) {
			  content_.append(`PurchaseRequestItems[${index}].ProductId`, item.ProductId.toString());
			}
			if (item.Amount != null) {
			  content_.append(`PurchaseRequestItems[${index}].Amount`, item.Amount.toString());
			}
			if (item.ProductUnitId != null) {
			  content_.append(`PurchaseRequestItems[${index}].ProductUnitId`, item.ProductUnitId.toString());
			}
			if (item.Description != null) {
			  content_.append(`PurchaseRequestItems[${index}].Description`, item.Description.toString());
			}
		  });
        }
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePurchaseRequestStatusClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    updateStatus(updatePurchaseRequestStatusCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaserequest/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePurchaseRequestStatusCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateStatus(_response);
        });
    }
    processUpdateStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ApprovePurchaseProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(approvePurchaseProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposal/PurchaseRequestProposalApprove";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(approvePurchaseProposalCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePurchaseProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(purchaseRequestId, name, proposalCompanyId, totalPrice, totalPriceWithTax, transportation, paymentDetail, deliveryTime, brand, proposalFile, purchaseProposalStatusId, laborTotalPrice, productTotalPrice, tSEFile) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposal/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (purchaseRequestId !== null && purchaseRequestId !== undefined)
            content_.append("PurchaseRequestId", purchaseRequestId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (proposalCompanyId !== null && proposalCompanyId !== undefined)
            content_.append("ProposalCompanyId", proposalCompanyId.toString());
        if (totalPrice === null || totalPrice === undefined)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else
            content_.append("TotalPrice", totalPrice.toString());
        if (totalPriceWithTax === null || totalPriceWithTax === undefined)
            throw new Error("The parameter 'totalPriceWithTax' cannot be null.");
        else
            content_.append("TotalPriceWithTax", totalPriceWithTax.toString());
        if (transportation !== null && transportation !== undefined)
            content_.append("Transportation", transportation.toString());
        if (paymentDetail !== null && paymentDetail !== undefined)
            content_.append("PaymentDetail", paymentDetail.toString());
        if (deliveryTime !== null && deliveryTime !== undefined)
            content_.append("DeliveryTime", deliveryTime.toString());
        if (brand !== null && brand !== undefined)
            content_.append("Brand", brand.toString());
        if (proposalFile !== null && proposalFile !== undefined)
            content_.append("ProposalFile", proposalFile, proposalFile.name ? proposalFile.name : "ProposalFile");
        if (purchaseProposalStatusId !== null && purchaseProposalStatusId !== undefined)
            content_.append("PurchaseProposalStatusId", purchaseProposalStatusId.toString());
        if (laborTotalPrice !== null && laborTotalPrice !== undefined)
            content_.append("LaborTotalPrice", laborTotalPrice.toString());
        if (productTotalPrice !== null && productTotalPrice !== undefined)
            content_.append("ProductTotalPrice", productTotalPrice.toString());
        if (tSEFile !== null && tSEFile !== undefined)
            content_.append("TSEFile", tSEFile, tSEFile.name ? tSEFile.name : "TSEFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePurchaseProposalCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePurchaseProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(id, purchaseRequestId, name, proposalCompanyId, totalPrice, totalPriceWithTax, transportation, paymentDetail, deliveryTime, brand, proposalFile, purchaseProposalStatusId) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposal/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (purchaseRequestId !== null && purchaseRequestId !== undefined)
            content_.append("PurchaseRequestId", purchaseRequestId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (proposalCompanyId !== null && proposalCompanyId !== undefined)
            content_.append("ProposalCompanyId", proposalCompanyId.toString());
        if (totalPrice === null || totalPrice === undefined)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else
            content_.append("TotalPrice", totalPrice.toString());
        if (totalPriceWithTax === null || totalPriceWithTax === undefined)
            throw new Error("The parameter 'totalPriceWithTax' cannot be null.");
        else
            content_.append("TotalPriceWithTax", totalPriceWithTax.toString());
        if (transportation !== null && transportation !== undefined)
            content_.append("Transportation", transportation.toString());
        if (paymentDetail !== null && paymentDetail !== undefined)
            content_.append("PaymentDetail", paymentDetail.toString());
        if (deliveryTime !== null && deliveryTime !== undefined)
            content_.append("DeliveryTime", deliveryTime.toString());
        if (brand !== null && brand !== undefined)
            content_.append("Brand", brand.toString());
        if (proposalFile !== null && proposalFile !== undefined)
            content_.append("ProposalFile", proposalFile, proposalFile.name ? proposalFile.name : "ProposalFile");
        if (purchaseProposalStatusId !== null && purchaseProposalStatusId !== undefined)
            content_.append("PurchaseProposalStatusId", purchaseProposalStatusId.toString());
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePurchaseProposalRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createPurchaseProposalRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPurchaseProposalRequestCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePurchaseProposalRequestCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetPurchaseProposalRequestClient extends UnauthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getPurchaseProposalRequestQuery) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/GetForCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPurchaseProposalRequestQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseProposalRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetPurchaseProposalRequestSendMailClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getPurchaseProposalRequestSendMailQuery) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/SendMail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPurchaseProposalRequestSendMailQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseProposalRequestSendMailQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetPurchaseProposalRequestSubInfoClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getPurchaseProposalRequestSubInfoQuery) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/GetSubInfo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPurchaseProposalRequestSubInfoQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseProposalRequestSubInfoQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPurchaseProposalRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPurchaseProposalRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdatePurchaseProposalRequestClient extends UnauthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(purchaseProposalGuid, note, file, laborTotalPrice, productTotalPrice, totalPrice, totalPriceWithTax, transportation, paymentDetail, deliveryTime, brand, tSEFile) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposalrequest/PostForCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (purchaseProposalGuid !== null && purchaseProposalGuid !== undefined)
            content_.append("PurchaseProposalGuid", purchaseProposalGuid.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file, file.name ? file.name : "File");
        if (laborTotalPrice !== null && laborTotalPrice !== undefined)
            content_.append("LaborTotalPrice", laborTotalPrice.toString());
        if (productTotalPrice !== null && productTotalPrice !== undefined)
            content_.append("ProductTotalPrice", productTotalPrice.toString());
        if (totalPrice === null || totalPrice === undefined)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else
            content_.append("TotalPrice", totalPrice.toString());
        if (totalPriceWithTax === null || totalPriceWithTax === undefined)
            throw new Error("The parameter 'totalPriceWithTax' cannot be null.");
        else
            content_.append("TotalPriceWithTax", totalPriceWithTax.toString());
        if (transportation !== null && transportation !== undefined)
            content_.append("Transportation", transportation.toString());
        if (paymentDetail !== null && paymentDetail !== undefined)
            content_.append("PaymentDetail", paymentDetail.toString());
        if (deliveryTime !== null && deliveryTime !== undefined)
            content_.append("DeliveryTime", deliveryTime.toString());
        if (brand !== null && brand !== undefined)
            content_.append("Brand", brand.toString());
        if (tSEFile !== null && tSEFile !== undefined)
            content_.append("TSEFile", tSEFile, tSEFile.name ? tSEFile.name : "TSEFile");
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createPurchaseOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPurchaseOrderCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePurchaseOrderCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetPurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPurchaseOrderQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, companyId, purchaseOrderStatusId, projectId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (purchaseOrderStatusId !== undefined && purchaseOrderStatusId !== null)
            url_ += "PurchaseOrderStatusId=" + encodeURIComponent("" + purchaseOrderStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPurchaseOrderQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, companyId, purchaseOrderStatusId, projectId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (purchaseOrderStatusId !== undefined && purchaseOrderStatusId !== null)
            url_ += "PurchaseOrderStatusId=" + encodeURIComponent("" + purchaseOrderStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdatePurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updatePurchaseOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePurchaseOrderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateProposalCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createProposalCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProposalCompanyCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProposalCompanyCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteProposalCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteProposalCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteProposalCompanyCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetProposalCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProposalCompanyQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchProposalCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, categoryId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchProposalCompanyQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, categoryId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateProposalCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateProposalCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/proposalcompany/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProposalCompanyCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingProjectCommand) {
        let url_ = this.baseUrl + "/api/v1/project/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingProjectCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createProjectCommand) {
        let url_ = this.baseUrl + "/api/v1/project/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProjectCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProjectCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteProjectCommand) {
        let url_ = this.baseUrl + "/api/v1/project/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteProjectCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(projectId) {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProjectQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, projectStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/project/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectStateId !== undefined && projectStateId !== null)
            url_ += "ProjectStateId=" + encodeURIComponent("" + projectStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchProjectQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, projectStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/project/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectStateId !== undefined && projectStateId !== null)
            url_ += "ProjectStateId=" + encodeURIComponent("" + projectStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateProjectClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateProjectCommand) {
        let url_ = this.baseUrl + "/api/v1/project/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProjectCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePlotClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createPlotCommand) {
        let url_ = this.baseUrl + "/api/v1/plot/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPlotCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePlotCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeletePlotClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePlotCommand) {
        let url_ = this.baseUrl + "/api/v1/plot/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePlotCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetPlotClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/plot/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPlotQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPlotClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/plot/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPlotQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/plot/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdatePlotClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updatePlotCommand) {
        let url_ = this.baseUrl + "/api/v1/plot/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePlotCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateContractClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createContractCommand) {
        let url_ = this.baseUrl + "/api/v1/contract/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createContractCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateContractCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteContractClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteContractCommand) {
        let url_ = this.baseUrl + "/api/v1/contract/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteContractCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetContractClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/contract/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetContractQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchContractClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, projectId, startDate, endDate, contractTypeId, contractStateId, companyId, contractName, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/contract/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (contractTypeId !== undefined && contractTypeId !== null)
            url_ += "ContractTypeId=" + encodeURIComponent("" + contractTypeId) + "&";
        if (contractStateId !== undefined && contractStateId !== null)
            url_ += "ContractStateId=" + encodeURIComponent("" + contractStateId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (contractName !== undefined && contractName !== null)
            url_ += "ContractName=" + encodeURIComponent("" + contractName) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchContractQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, projectId, startDate, endDate, contractTypeId, contractStateId, companyId, contractName, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/contract/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (contractTypeId !== undefined && contractTypeId !== null)
            url_ += "ContractTypeId=" + encodeURIComponent("" + contractTypeId) + "&";
        if (contractStateId !== undefined && contractStateId !== null)
            url_ += "ContractStateId=" + encodeURIComponent("" + contractStateId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (contractName !== undefined && contractName !== null)
            url_ += "ContractName=" + encodeURIComponent("" + contractName) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateContractClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateContractCommand) {
        let url_ = this.baseUrl + "/api/v1/contract/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateContractCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateConstructionSiteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createConstructionSiteCommand) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createConstructionSiteCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateConstructionSiteCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteConstructionSiteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteConstructionSiteCommand) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteConstructionSiteCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetConstructionSiteAnalysisClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getConstructionSiteAnalysis(constructionSiteId) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/{constructionSiteId}/Analysis";
        if (constructionSiteId === undefined || constructionSiteId === null)
            throw new Error("The parameter 'constructionSiteId' must be defined.");
        url_ = url_.replace("{constructionSiteId}", encodeURIComponent("" + constructionSiteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetConstructionSiteAnalysis(_response);
        });
    }
    processGetConstructionSiteAnalysis(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetConstructionSiteAnalysisQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetConstructionSiteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetConstructionSiteQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchConstructionSiteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchConstructionSiteQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateConstructionSiteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateConstructionSiteCommand) {
        let url_ = this.baseUrl + "/api/v1/constructionsite/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateConstructionSiteCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateBuildingBlockTypeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createBuildingBlockTypeCommand) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createBuildingBlockTypeCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBuildingBlockTypeCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteBuildingBlockTypeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteBuildingBlockTypeCommand) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteBuildingBlockTypeCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetBuildingBlockTypeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBuildingBlockTypeQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchBuildingBlockTypeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchBuildingBlockTypeQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateBuildingBlockTypeClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBuildingBlockTypeCommand) {
        let url_ = this.baseUrl + "/api/v1/buildingblocktype/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBuildingBlockTypeCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateBlockClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createBlockCommand) {
        let url_ = this.baseUrl + "/api/v1/block/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createBlockCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBlockCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteBlockClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteBlockCommand) {
        let url_ = this.baseUrl + "/api/v1/block/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteBlockCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetBlockClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/block/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBlockQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchBlockClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/block/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchBlockQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/block/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateBlockClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBlockCommand) {
        let url_ = this.baseUrl + "/api/v1/block/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBlockCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CheckActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(checkActivityReportQuery) {
        let url_ = this.baseUrl + "/api/v1/activityreport/CheckReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(checkActivityReportQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CheckActivityReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createActivityReportCommand) {
        let url_ = this.baseUrl + "/api/v1/activityreport/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createActivityReportCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateActivityReportCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/activityreport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetActivityReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetActivityReportExcelClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/activityreport/excel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetAllTimeKeepingTemplateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllTimeKeepingTemplateQuery) {
        let url_ = this.baseUrl + "/api/v1/timekeepingtemplate/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllTimeKeepingTemplateQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllTimeKeepingTemplateQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetProjectInfoClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getProjectInfoQuery) {
        let url_ = this.baseUrl + "/api/v1/activityreport/GetProjectInformation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getProjectInfoQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProjectInfoQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ReleaseActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(releaseActivityReportCommand) {
        let url_ = this.baseUrl + "/api/v1/activityreport/Release";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(releaseActivityReportCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SearchActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, activityReportType, projectId, reportDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/activityreport/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (activityReportType !== undefined && activityReportType !== null)
            url_ += "ActivityReportType=" + encodeURIComponent("" + activityReportType) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (reportDate === null)
            throw new Error("The parameter 'reportDate' cannot be null.");
        else if (reportDate !== undefined)
            url_ += "ReportDate=" + encodeURIComponent(reportDate ? "" + reportDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchActivityReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, activityReportType, projectId, reportDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/activityreport/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (activityReportType !== undefined && activityReportType !== null)
            url_ += "ActivityReportType=" + encodeURIComponent("" + activityReportType) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (reportDate === null)
            throw new Error("The parameter 'reportDate' cannot be null.");
        else if (reportDate !== undefined)
            url_ += "ReportDate=" + encodeURIComponent(reportDate ? "" + reportDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateActivityReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateActivityReportCommand) {
        let url_ = this.baseUrl + "/api/v1/activityreport/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateActivityReportCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteOutgoingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteOutgoingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteOutgoingWaybillCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetOutgoingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOutgoingWaybillQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchOutgoingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchOutgoingWaybillQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateOutgoingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateOutgoingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateOutgoingWaybillCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteIncomingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteIncomingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteIncomingWaybillCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetIncomingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetIncomingWaybillQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchIncomingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchIncomingWaybillQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateIncomingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateIncomingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateIncomingWaybillCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingWarehouseCommand) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingWarehouseCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createWarehouseCommand) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createWarehouseCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateWarehouseCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SetDefaultWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(defaultWarehouseCommand) {
        let url_ = this.baseUrl + "/api/v1/warehouse/SetDefault";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(defaultWarehouseCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteWarehouseCommand) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteWarehouseCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/warehouse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetWarehouseQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchWarehouseQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateWarehouseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateWarehouseCommand) {
        let url_ = this.baseUrl + "/api/v1/warehouse/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateWarehouseCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateWarehouseTransferClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createWarehouseTransferCommand) {
        let url_ = this.baseUrl + "/api/v1/warehousetransfer/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createWarehouseTransferCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateWarehouseTransferCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteWarehouseTransferClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteWarehouseTransferCommand) {
        let url_ = this.baseUrl + "/api/v1/warehousetransfer/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteWarehouseTransferCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetWarehouseTransferClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/warehousetransfer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetWarehouseTransferQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchWarehouseTransferClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/warehousetransfer/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchWarehouseTransferQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateIncomingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createIncomingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/incomingWaybill/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createIncomingWaybillCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateIncomingWaybillCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateOutgoingWaybillClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createOutgoingWaybillCommand) {
        let url_ = this.baseUrl + "/api/v1/outgoingWaybill/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createOutgoingWaybillCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateOutgoingWaybillCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingProductCommand) {
        let url_ = this.baseUrl + "/api/v1/product/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingProductCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateFastProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createFastProductCommand) {
        let url_ = this.baseUrl + "/api/v1/product/CreateFast";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createFastProductCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateFastProductCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createProductCommand) {
        let url_ = this.baseUrl + "/api/v1/product/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProductCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProductCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteProductCommand) {
        let url_ = this.baseUrl + "/api/v1/product/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteProductCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetProductInfoClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getProductInfoQuery) {
        let url_ = this.baseUrl + "/api/v1/product/ProductInfo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getProductInfoQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductInfoQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetStockProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getStockQuery) {
        let url_ = this.baseUrl + "/api/v1/product/GetStock";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getStockQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStockQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchExpenseInvoiceProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/product/SearchExpenseInvoices";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchExpenseInvoiceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchExpenseInvoiceQueryExcel(id) {
        let url_ = this.baseUrl + "/api/v1/product/SearchExpenseInvoiceQueryExcel?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchExpenseInvoiceQueryExcel(_response);
        });
    }
    processSearchExpenseInvoiceQueryExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/product/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchProductQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/product/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchSaleInvoiceProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchSaleInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/product/SearchSaleInvoices";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchSaleInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchSaleInvoiceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchSaleInvoicesExcel(id) {
        let url_ = this.baseUrl + "/api/v1/product/SearchSaleInvoicesExcel?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchSaleInvoicesExcel(_response);
        });
    }
    processSearchSaleInvoicesExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchStockProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchStockQuery) {
        let url_ = this.baseUrl + "/api/v1/product/SearchStocks";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchStockQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchStockQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchStocksExcel(id) {
        let url_ = this.baseUrl + "/api/v1/product/SearchStocksExcel?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchStocksExcel(_response);
        });
    }
    processSearchStocksExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchWarehouseProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchWarehouseQuery) {
        let url_ = this.baseUrl + "/api/v1/product/SearchWarehouses";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchWarehouseQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchWarehouseQueryResponse2.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchWarehousesExcel(id) {
        let url_ = this.baseUrl + "/api/v1/product/SearchWarehousesExcel?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchWarehousesExcel(_response);
        });
    }
    processSearchWarehousesExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateProductCommand) {
        let url_ = this.baseUrl + "/api/v1/product/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProductCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateWarehousesProductClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateWarehousesCommand) {
        let url_ = this.baseUrl + "/api/v1/stock/UpdateWarehouses";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateWarehousesCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompleteNotificationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    complete(completeNotificationCommand) {
        let url_ = this.baseUrl + "/api/v1/notification/Complete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(completeNotificationCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processComplete(_response);
        });
    }
    processComplete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DashboardNotificationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get() {
        let url_ = this.baseUrl + "/api/v1/notification/Get";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardNotificationQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchNotificationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(content, notificationTypeId, isCompleted, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/notification/Search?";
        if (content !== undefined && content !== null)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (notificationTypeId !== undefined && notificationTypeId !== null)
            url_ += "NotificationTypeId=" + encodeURIComponent("" + notificationTypeId) + "&";
        if (isCompleted !== undefined && isCompleted !== null)
            url_ += "IsCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchNotificationQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(content, notificationTypeId, isCompleted, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/notification/Excel?";
        if (content !== undefined && content !== null)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (notificationTypeId !== undefined && notificationTypeId !== null)
            url_ += "NotificationTypeId=" + encodeURIComponent("" + notificationTypeId) + "&";
        if (isCompleted !== undefined && isCompleted !== null)
            url_ += "IsCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class TestEmailClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    testEmail() {
        let url_ = this.baseUrl + "/api/v1/notification/TestEmail";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTestEmail(_response);
        });
    }
    processTestEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ApplicationInfoMetaClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    info() {
        let url_ = this.baseUrl + "/applicationinfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processInfo(_response);
        });
    }
    processInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetApplicationInfoQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UserInfoMetaClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    info() {
        let url_ = this.baseUrl + "/userinfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processInfo(_response);
        });
    }
    processInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key] !== undefined ? resultData200[key] : null;
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DistrictLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    districtLookup(getDistrictLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/lookup/District";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getDistrictLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDistrictLookup(_response);
        });
    }
    processDistrictLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(DistrictLookupVm.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BasicLookupClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    basicLookup(getAllBasicLookupQuery) {
        let url_ = this.baseUrl + "/api/v1/lookup/Basic";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllBasicLookupQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBasicLookup(_response);
        });
    }
    processBasicLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BasicLookupVm.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ArchivingCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/company/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingCompanyCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/company/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createCompanyCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateCompanyCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/company/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteCompanyCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/company/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCompanyQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, companyTypeId, hasBalance, categoryId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/company/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (companyTypeId !== undefined && companyTypeId !== null)
            url_ += "CompanyTypeId=" + encodeURIComponent("" + companyTypeId) + "&";
        if (hasBalance !== undefined && hasBalance !== null)
            url_ += "HasBalance=" + encodeURIComponent("" + hasBalance) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchCompanyQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, companyTypeId, hasBalance, categoryId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/company/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (companyTypeId !== undefined && companyTypeId !== null)
            url_ += "CompanyTypeId=" + encodeURIComponent("" + companyTypeId) + "&";
        if (hasBalance !== undefined && hasBalance !== null)
            url_ += "HasBalance=" + encodeURIComponent("" + hasBalance) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCompanyCommand) {
        let url_ = this.baseUrl + "/api/v1/company/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCompanyCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompleteUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(completeUserTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/usertask/CompleteTask";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(completeUserTaskCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createUserTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/usertask/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createUserTaskCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateUserTaskCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteUserTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/usertask/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteUserTaskCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/usertask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserTaskQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, userTaskStatusId, taskPriorityId, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/usertask/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (userTaskStatusId !== undefined && userTaskStatusId !== null)
            url_ += "UserTaskStatusId=" + encodeURIComponent("" + userTaskStatusId) + "&";
        if (taskPriorityId !== undefined && taskPriorityId !== null)
            url_ += "TaskPriorityId=" + encodeURIComponent("" + taskPriorityId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchUserTaskQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, userTaskStatusId, taskPriorityId, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/usertask/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (userTaskStatusId !== undefined && userTaskStatusId !== null)
            url_ += "UserTaskStatusId=" + encodeURIComponent("" + userTaskStatusId) + "&";
        if (taskPriorityId !== undefined && taskPriorityId !== null)
            url_ += "TaskPriorityId=" + encodeURIComponent("" + taskPriorityId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateUserTaskClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateUserTaskCommand) {
        let url_ = this.baseUrl + "/api/v1/usertask/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateUserTaskCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetTenantCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get() {
        let url_ = this.baseUrl + "/api/v1/tenantcompany/Get";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTenantCompanyQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateTenantCompanyClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(name, title, address, provinceId, districtId, phone, fax, taxOffice, taxNumber, registerNumber, email, logoFile, iban, mersisNo, postalCode, ticariSicilNo, webSite, sealSignatureFile) {
        let url_ = this.baseUrl + "/api/v1/tenantcompany/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (address !== null && address !== undefined)
            content_.append("Address", address.toString());
        if (provinceId !== null && provinceId !== undefined)
            content_.append("ProvinceId", provinceId.toString());
        if (districtId !== null && districtId !== undefined)
            content_.append("DistrictId", districtId.toString());
        if (phone !== null && phone !== undefined)
            content_.append("Phone", phone.toString());
        if (fax !== null && fax !== undefined)
            content_.append("Fax", fax.toString());
        if (taxOffice !== null && taxOffice !== undefined)
            content_.append("TaxOffice", taxOffice.toString());
        if (taxNumber !== null && taxNumber !== undefined)
            content_.append("TaxNumber", taxNumber.toString());
        if (registerNumber !== null && registerNumber !== undefined)
            content_.append("RegisterNumber", registerNumber.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (logoFile !== null && logoFile !== undefined)
            content_.append("LogoFile", logoFile, logoFile.name ? logoFile.name : "LogoFile");
        if (iban !== null && iban !== undefined)
            content_.append("Iban", iban.toString());
        if (mersisNo !== null && mersisNo !== undefined)
            content_.append("MersisNo", mersisNo.toString());
        if (postalCode !== null && postalCode !== undefined)
            content_.append("PostalCode", postalCode.toString());
        if (ticariSicilNo !== null && ticariSicilNo !== undefined)
            content_.append("TicariSicilNo", ticariSicilNo.toString());
        if (webSite !== null && webSite !== undefined)
            content_.append("WebSite", webSite.toString());
        if (sealSignatureFile !== null && sealSignatureFile !== undefined)
            content_.append("SealSignatureFile", sealSignatureFile, sealSignatureFile.name ? sealSignatureFile.name : "SealSignatureFile");
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SearchCalendarClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(searchCalendarQuery) {
        let url_ = this.baseUrl + "/api/v1/searchCalendar/calendar";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchCalendarQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchCalendarQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetAllRecordHistoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllRecordHistoryQuery) {
        let url_ = this.baseUrl + "/api/v1/recordhistory/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllRecordHistoryQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllRecordHistoryQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateRecordCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createRecordCategoryCommand) {
        let url_ = this.baseUrl + "/api/v1/recordcategory/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createRecordCategoryCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRecordCategoryCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetRecordCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getRecordCategoryQuery) {
        let url_ = this.baseUrl + "/api/v1/recordcategory/Get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getRecordCategoryQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRecordCategoryQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateRecordCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateRecordCategoryCommand) {
        let url_ = this.baseUrl + "/api/v1/recordcategory/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateRecordCategoryCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateNoteClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  create(description, sourceId, sourceTypeId, formFile) {
    let url_ = this.baseUrl + "/api/v1/note/Create";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (description !== null && description !== undefined)
      content_.append("Description", description.toString());
    if (sourceId === null || sourceId === undefined)
      throw new Error("The parameter 'sourceId' cannot be null.");
    else
      content_.append("SourceId", sourceId.toString());
    if (sourceTypeId === null || sourceTypeId === undefined)
      throw new Error("The parameter 'sourceTypeId' cannot be null.");
    else
      content_.append("SourceTypeId", sourceTypeId.toString());
    if (formFile !== null && formFile !== undefined)
      Array.from(formFile).forEach(file => { content_.append("FormFile", file); });
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processCreate(_response);
    });
  }
  processCreate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200 = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreateNoteCommandResponse.fromJS(resultData200);
        return result200;
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}
export class DeleteNoteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteNoteCommand) {
        let url_ = this.baseUrl + "/api/v1/note/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteNoteCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllNoteClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllNoteBySourceIdAndSourceTypeIdQuery) {
        let url_ = this.baseUrl + "/api/v1/note/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllNoteBySourceIdAndSourceTypeIdQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllNoteBySourceIdAndSourceTypeIdQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetAllNoteImagesClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAllNoteImages(getAllNoteImagesQuery) {
        let url_ = this.baseUrl + "/api/v1/note/GetAllNoteImages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllNoteImagesQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAllNoteImages(_response);
        });
    }
    processGetAllNoteImages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllNoteImagesQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GlobalSearchClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(globalSearchQuery) {
        let url_ = this.baseUrl + "/api/v1/globalsearch/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(globalSearchQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GlobalSearchQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateFileClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  create(sourceId, sourceTypeId, formFile) {
    let url_ = this.baseUrl + "/api/v1/file/Create";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (sourceId === null || sourceId === undefined)
      throw new Error("The parameter 'sourceId' cannot be null.");
    else
      content_.append("SourceId", sourceId.toString());
    if (sourceTypeId === null || sourceTypeId === undefined)
      throw new Error("The parameter 'sourceTypeId' cannot be null.");
    else
      content_.append("SourceTypeId", sourceTypeId.toString());
    if (formFile !== null && formFile !== undefined)
      Array.from(formFile).forEach(file => { content_.append("FormFile", file); });
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processCreate(_response);
    });
  }
  processCreate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200 = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreateFileCommandResponse.fromJS(resultData200);
        return result200;
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}
export class DeleteFileClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(id) {
        let url_ = this.baseUrl + "/api/v1/file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class AssignFileFolderPermissionClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    assignPermission(command) {
        let url_ = this.baseUrl + "/api/v1/filefolder/Permission";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAssignPermission(_response);
        });
    }
    processAssignPermission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssignFileFolderPermissionCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateFileFolderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createFileFolderCommand) {
        let url_ = this.baseUrl + "/api/v1/filefolder/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createFileFolderCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateFileFolderCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteFileFolderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteFileFolderCommand) {
        let url_ = this.baseUrl + "/api/v1/filefolder/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteFileFolderCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllFolderWithFilesClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllFolderWithFilesQuery) {
        let url_ = this.baseUrl + "/api/v1/filefolder/GetAllWithFiles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllFolderWithFilesQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllFolderWithFilesQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetFileFolderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getFileFolderQuery) {
        let url_ = this.baseUrl + "/api/v1/filefolder/GetFileFolders";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getFileFolderQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetFileFolderQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetFileFolderPermissionClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getPermission(fileFolderId, sourceId, sourceTypeId) {
        let url_ = this.baseUrl + "/api/v1/filefolder/GetPermission?";
        if (fileFolderId !== undefined && fileFolderId !== null)
            url_ += "FileFolderId=" + encodeURIComponent("" + fileFolderId) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "SourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (sourceTypeId !== undefined && sourceTypeId !== null)
            url_ += "SourceTypeId=" + encodeURIComponent("" + sourceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPermission(_response);
        });
    }
    processGetPermission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFileFolderPermissionQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetRootFileFolderIdClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getRootFileFolderIdQuery) {
        let url_ = this.baseUrl + "/api/v1/filefolder/GetRootFileFolderId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getRootFileFolderIdQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRootFileFolderIdQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RenameFileFolderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(renameFileFolderCommand) {
        let url_ = this.baseUrl + "/api/v1/filefolder/Rename";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(renameFileFolderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateFileFolderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateFileFolderCommand) {
        let url_ = this.baseUrl + "/api/v1/filefolder/UpdateFolder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateFileFolderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetFeatureFlagsClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll() {
        let url_ = this.baseUrl + "/api/v1/featureflags/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllFeatureFlagsQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BankCashDashboardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(dashboardQuery) {
        let url_ = this.baseUrl + "/api/v1/bankcashdashboard/Get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dashboardQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BankCashDashboardQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GeneralDashboardClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(dashboardQuery) {
        let url_ = this.baseUrl + "/api/v1/generaldashboard/Get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dashboardQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDashboardQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createCategoryCommand) {
        let url_ = this.baseUrl + "/api/v1/category/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createCategoryCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateCategoryCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteCategoryCommand) {
        let url_ = this.baseUrl + "/api/v1/category/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteCategoryCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllCategoryQuery) {
        let url_ = this.baseUrl + "/api/v1/category/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllCategoryQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllCategoryQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateCategoryClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCategoryCommand) {
        let url_ = this.baseUrl + "/api/v1/category/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCategoryCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAllActivityClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getAll(getAllActivityQuery) {
        let url_ = this.baseUrl + "/api/v1/activities/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAllActivityQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllActivityQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateUserClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createUserCommand) {
        let url_ = this.baseUrl + "/api/v1/user/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createUserCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateUserCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteUserClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(id) {
        let url_ = this.baseUrl + "/api/v1/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetUserClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SearchUserClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/user/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchUserQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/user/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateUserClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateUserCommand) {
        let url_ = this.baseUrl + "/api/v1/user/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateUserCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateUserCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateUserRolesClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateUserRolesCommand) {
        let url_ = this.baseUrl + "/api/v1/user/Roles/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateUserRolesCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateUserRolesCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAuditClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    details(id) {
        let url_ = this.baseUrl + "/api/v1/audit/Details?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDetails(_response);
        });
    }
    processDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAuditQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ListAuditClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    listByGuid(guid) {
        let url_ = this.baseUrl + "/api/v1/audit/ListByGuid?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processListByGuid(_response);
        });
    }
    processListByGuid(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ListByGuidCommandResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchAuditClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(auditEntityId, userId, dateFrom, dateTo, type, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/audit/Search?";
        if (auditEntityId !== undefined && auditEntityId !== null)
            url_ += "AuditEntityId=" + encodeURIComponent("" + auditEntityId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchAuditQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DeletePurchaseProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePurchaseProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseproposal/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePurchaseProposalCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingPurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingPurchaseOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingPurchaseOrderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeletePurchaseOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePurchaseOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePurchaseOrderCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePurchaseOrderStatusClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    updateStatus(updatePurchaseOrderStatusCommand) {
        let url_ = this.baseUrl + "/api/v1/purchaseorder/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePurchaseOrderStatusCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateStatus(_response);
        });
    }
    processUpdateStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingSaleInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingSaleInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createSaleInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createSaleInvoiceCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSaleInvoiceCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteSaleInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteSaleInvoiceCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSaleInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, editStartDate, editEndDate, projectId, companyId, salePaymentStatusId, categoryId, invoiceKindId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (editStartDate === null)
            throw new Error("The parameter 'editStartDate' cannot be null.");
        else if (editStartDate !== undefined)
            url_ += "EditStartDate=" + encodeURIComponent(editStartDate ? "" + editStartDate.toISOString() : "") + "&";
        if (editEndDate === null)
            throw new Error("The parameter 'editEndDate' cannot be null.");
        else if (editEndDate !== undefined)
            url_ += "EditEndDate=" + encodeURIComponent(editEndDate ? "" + editEndDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (salePaymentStatusId !== undefined && salePaymentStatusId !== null)
            url_ += "SalePaymentStatusId=" + encodeURIComponent("" + salePaymentStatusId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (invoiceKindId !== undefined && invoiceKindId !== null)
            url_ += "InvoiceKindId=" + encodeURIComponent("" + invoiceKindId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchSaleInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, editStartDate, editEndDate, projectId, companyId, salePaymentStatusId, categoryId, invoiceKindId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (editStartDate === null)
            throw new Error("The parameter 'editStartDate' cannot be null.");
        else if (editStartDate !== undefined)
            url_ += "EditStartDate=" + encodeURIComponent(editStartDate ? "" + editStartDate.toISOString() : "") + "&";
        if (editEndDate === null)
            throw new Error("The parameter 'editEndDate' cannot be null.");
        else if (editEndDate !== undefined)
            url_ += "EditEndDate=" + encodeURIComponent(editEndDate ? "" + editEndDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (salePaymentStatusId !== undefined && salePaymentStatusId !== null)
            url_ += "SalePaymentStatusId=" + encodeURIComponent("" + salePaymentStatusId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (invoiceKindId !== undefined && invoiceKindId !== null)
            url_ += "InvoiceKindId=" + encodeURIComponent("" + invoiceKindId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateSaleInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/saleinvoice/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateSaleInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/proposal/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingProposalCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/proposal/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProposalCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProposalCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/proposal/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteProposalCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/proposal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProposalQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, proposalStatusId, projectId, companyId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/proposal/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (proposalStatusId !== undefined && proposalStatusId !== null)
            url_ += "ProposalStatusId=" + encodeURIComponent("" + proposalStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchProposalQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, proposalStatusId, projectId, companyId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/proposal/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (proposalStatusId !== undefined && proposalStatusId !== null)
            url_ += "ProposalStatusId=" + encodeURIComponent("" + proposalStatusId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateProposalClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateProposalCommand) {
        let url_ = this.baseUrl + "/api/v1/proposal/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProposalCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateProposalStatusClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    updateStatus(updateProposalStatusCommand) {
        let url_ = this.baseUrl + "/api/v1/proposal/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProposalStatusCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateStatus(_response);
        });
    }
    processUpdateStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePaymentRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createPaymentRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPaymentRequestCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePaymentRequestCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeletePaymentRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePaymentRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePaymentRequestCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetAvailablePaymentsClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(getAvailablePaymentsQuery) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/GetAvailablePayments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getAvailablePaymentsQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAvailablePaymentsQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetConfirmationStateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getConfirmationStateQuery) {
        let url_ = this.baseUrl + "/api/v1/paymentrequestconfirmation/GetConfirmationState";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getConfirmationStateQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetConfirmationStateQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetPaymentRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPaymentRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetWaitingConfirmationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(projectId, companyId, approveUserId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentrequestconfirmation/WaitingConfirmation?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (approveUserId !== undefined && approveUserId !== null)
            url_ += "ApproveUserId=" + encodeURIComponent("" + approveUserId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfGetWaitingConfirmationQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(projectId, companyId, approveUserId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentrequestconfirmation/Excel?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (approveUserId !== undefined && approveUserId !== null)
            url_ += "ApproveUserId=" + encodeURIComponent("" + approveUserId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPaymentRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, projectId, companyId, beginDate, endDate, requestedUserId, paymentRequestTypeId, paymentRequestStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (requestedUserId !== undefined && requestedUserId !== null)
            url_ += "RequestedUserId=" + encodeURIComponent("" + requestedUserId) + "&";
        if (paymentRequestTypeId !== undefined && paymentRequestTypeId !== null)
            url_ += "PaymentRequestTypeId=" + encodeURIComponent("" + paymentRequestTypeId) + "&";
        if (paymentRequestStateId !== undefined && paymentRequestStateId !== null)
            url_ += "PaymentRequestStateId=" + encodeURIComponent("" + paymentRequestStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPaymentRequestQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, projectId, companyId, beginDate, endDate, requestedUserId, paymentRequestTypeId, paymentRequestStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (requestedUserId !== undefined && requestedUserId !== null)
            url_ += "RequestedUserId=" + encodeURIComponent("" + requestedUserId) + "&";
        if (paymentRequestTypeId !== undefined && paymentRequestTypeId !== null)
            url_ += "PaymentRequestTypeId=" + encodeURIComponent("" + paymentRequestTypeId) + "&";
        if (paymentRequestStateId !== undefined && paymentRequestStateId !== null)
            url_ += "PaymentRequestStateId=" + encodeURIComponent("" + paymentRequestStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateOnConfirmationStateClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateOnConfirmationStateCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/UpdateOnConfirmationState";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateOnConfirmationStateCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePaymentRequestConfirmationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updatePaymentRequestConfirmationCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentrequestconfirmation/Confirm";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePaymentRequestConfirmationCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePaymentRequestClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updatePaymentRequestCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentrequest/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePaymentRequestCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdatePaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updatePaymentPlanCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePaymentPlanCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateExpensePaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createExpensePaymentPlanCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/CreateExpense";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createExpensePaymentPlanCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateExpensePaymentPlanCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreatePaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createPaymentPlanCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPaymentPlanCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePaymentPlanCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateSalePaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createSalePaymentPlanCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/CreateSale";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createSalePaymentPlanCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSalePaymentPlanCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeletePaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deletePaymentPlanCommand) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deletePaymentPlanCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetPaymentPlanClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPaymentPlanQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPaymentPlanForExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, startDate, endDate, projectId, companyId, paymentPlanTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchExpense?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (paymentPlanTypeId !== undefined && paymentPlanTypeId !== null)
            url_ += "PaymentPlanTypeId=" + encodeURIComponent("" + paymentPlanTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPaymentPlanForExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, startDate, endDate, projectId, companyId, paymentPlanTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchExpenseExcel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (paymentPlanTypeId !== undefined && paymentPlanTypeId !== null)
            url_ += "PaymentPlanTypeId=" + encodeURIComponent("" + paymentPlanTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPaymentPlanForSaleInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, startDate, endDate, projectId, companyId, paymentPlanTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchSale?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (paymentPlanTypeId !== undefined && paymentPlanTypeId !== null)
            url_ += "PaymentPlanTypeId=" + encodeURIComponent("" + paymentPlanTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPaymentPlanForSaleInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, startDate, endDate, projectId, companyId, paymentPlanTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchSaleExcel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (paymentPlanTypeId !== undefined && paymentPlanTypeId !== null)
            url_ += "PaymentPlanTypeId=" + encodeURIComponent("" + paymentPlanTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchPaymentPlanUnscheduledClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchUnscheduled?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchPaymentPlanUnscheduledQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/paymentplan/SearchUnscheduledExcel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CreateOfficialExpenseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(expenseInvoiceId, name, invoiceNumber, totalPrice, totalTax, totalWithHolding, officialExpenseFile, invoiceDate) {
        let url_ = this.baseUrl + "/api/v1/officialexpense/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (expenseInvoiceId !== null && expenseInvoiceId !== undefined)
            content_.append("ExpenseInvoiceId", expenseInvoiceId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (invoiceNumber !== null && invoiceNumber !== undefined)
            content_.append("InvoiceNumber", invoiceNumber.toString());
        if (totalPrice === null || totalPrice === undefined)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else
            content_.append("TotalPrice", totalPrice.toString());
        if (totalTax === null || totalTax === undefined)
            throw new Error("The parameter 'totalTax' cannot be null.");
        else
            content_.append("TotalTax", totalTax.toString());
        if (totalWithHolding === null || totalWithHolding === undefined)
            throw new Error("The parameter 'totalWithHolding' cannot be null.");
        else
            content_.append("TotalWithHolding", totalWithHolding.toString());
        if (officialExpenseFile !== null && officialExpenseFile !== undefined)
            content_.append("OfficialExpenseFile", officialExpenseFile, officialExpenseFile.name ? officialExpenseFile.name : "OfficialExpenseFile");
        if (invoiceDate === null || invoiceDate === undefined)
            throw new Error("The parameter 'invoiceDate' cannot be null.");
        else
            content_.append("InvoiceDate", invoiceDate.toJSON());
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateOfficialExpenseCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteOfficialExpenseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteOfficialExpenseCommand) {
        let url_ = this.baseUrl + "/api/v1/officialexpense/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteOfficialExpenseCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetOfficialExpenseByExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(getOfficialExpenseQuery) {
        let url_ = this.baseUrl + "/api/v1/officialexpense/GetOfficialExpenseByExpenseInvoice";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getOfficialExpenseQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetOfficialExpenseByExpenseInvoiceQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetOfficialExpenseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getOfficialExpenseQuery) {
        let url_ = this.baseUrl + "/api/v1/officialexpense/Get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getOfficialExpenseQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOfficialExpenseQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateOfficialExpenseClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateOfficialExpenseCommand) {
        let url_ = this.baseUrl + "/api/v1/officialexpense/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateOfficialExpenseCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateGuaranteeLetterClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createGuaranteeLetterCommand) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createGuaranteeLetterCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateGuaranteeLetterCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteGuaranteeLetterClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteGuaranteeLetterCommand) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteGuaranteeLetterCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetGuaranteeLetterClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetGuaranteeLetterQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchGuaranteeLetterClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, projectId, companyId, bankId, guaranteeLetterTypeId, guaranteeLetterStateId, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "BankId=" + encodeURIComponent("" + bankId) + "&";
        if (guaranteeLetterTypeId !== undefined && guaranteeLetterTypeId !== null)
            url_ += "GuaranteeLetterTypeId=" + encodeURIComponent("" + guaranteeLetterTypeId) + "&";
        if (guaranteeLetterStateId !== undefined && guaranteeLetterStateId !== null)
            url_ += "GuaranteeLetterStateId=" + encodeURIComponent("" + guaranteeLetterStateId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchGuaranteeLetterQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, projectId, companyId, bankId, guaranteeLetterTypeId, guaranteeLetterStateId, startDate, endDate, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "BankId=" + encodeURIComponent("" + bankId) + "&";
        if (guaranteeLetterTypeId !== undefined && guaranteeLetterTypeId !== null)
            url_ += "GuaranteeLetterTypeId=" + encodeURIComponent("" + guaranteeLetterTypeId) + "&";
        if (guaranteeLetterStateId !== undefined && guaranteeLetterStateId !== null)
            url_ += "GuaranteeLetterStateId=" + encodeURIComponent("" + guaranteeLetterStateId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateGuaranteeLetterClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateGuaranteeLetterCommand) {
        let url_ = this.baseUrl + "/api/v1/guaranteeletter/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateGuaranteeLetterCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetDocumentPdfClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getDocumentPdf(uuid, documentType) {
        let url_ = this.baseUrl + "/api/v1/gib/pdf/{uuid}/{documentType}";
        if (uuid === undefined || uuid === null)
            throw new Error("The parameter 'uuid' must be defined.");
        url_ = url_.replace("{uuid}", encodeURIComponent("" + uuid));
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDocumentPdf(_response);
        });
    }
    processGetDocumentPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/gib/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetInvoicePdfClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    getPdf(id) {
        let url_ = this.baseUrl + "/api/v1/gib/pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPdf(_response);
        });
    }
    processGetPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/gib/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/gib/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SendInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    send(id) {
        let url_ = this.baseUrl + "/api/v1/gib/send/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSend(_response);
        });
    }
    processSend(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SendInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ArchivingExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateBankExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createBankExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/CreateBank";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createBankExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBankExpenseInvoiceCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class CreateDetailExpenseInvoiceClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  create(name, invoiceTypeId, projectId, companyId, editDate, defermentDate, invoiceNumber, subTotalPrice, totalTax, totalDiscount, grossTotalPrice, totalWitholding, totalPrice, expensePaymentStatusId, fromAccountId, checkoutName, paymentDate, expenseFile, relatedStaffId, gibInvoiceId, categoryId, invoiceKindId, expenseInvoiceItems) {
    let url_ = this.baseUrl + "/api/v1/expenseinvoice/CreateDetail";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (name === null || name === undefined)
      throw new Error("The parameter 'name' cannot be null.");
    else
      content_.append("Name", name.toString());
    if (invoiceTypeId !== null && invoiceTypeId !== undefined)
      content_.append("InvoiceTypeId", invoiceTypeId.toString());
    if (projectId !== null && projectId !== undefined)
      content_.append("ProjectId", projectId.toString());
    if (companyId !== null && companyId !== undefined)
      content_.append("CompanyId", companyId.toString());
    if (editDate !== null && editDate !== undefined)
      content_.append("EditDate", editDate.toJSON());
    if (defermentDate !== null && defermentDate !== undefined)
      content_.append("DefermentDate", defermentDate.toJSON());
    if (invoiceNumber !== null && invoiceNumber !== undefined)
      content_.append("InvoiceNumber", invoiceNumber.toString());
    if (subTotalPrice !== null && subTotalPrice !== undefined)
      content_.append("SubTotalPrice", subTotalPrice.toString());
    if (totalTax !== null && totalTax !== undefined)
      content_.append("TotalTax", totalTax.toString());
    if (totalDiscount !== null && totalDiscount !== undefined)
      content_.append("TotalDiscount", totalDiscount.toString());
    if (grossTotalPrice !== null && grossTotalPrice !== undefined)
      content_.append("GrossTotalPrice", grossTotalPrice.toString());
    if (totalWitholding !== null && totalWitholding !== undefined)
      content_.append("TotalWitholding", totalWitholding.toString());
    if (totalPrice !== null && totalPrice !== undefined)
      content_.append("TotalPrice", totalPrice.toString());
    if (expensePaymentStatusId !== null && expensePaymentStatusId !== undefined)
      content_.append("ExpensePaymentStatusId", expensePaymentStatusId.toString());
    if (fromAccountId !== null && fromAccountId !== undefined)
      content_.append("FromAccountId", fromAccountId.toString());
    if (checkoutName !== null && checkoutName !== undefined)
      content_.append("CheckoutName", checkoutName.toString());
    if (paymentDate !== null && paymentDate !== undefined)
      content_.append("PaymentDate", paymentDate.toJSON());
    if (expenseFile !== null && expenseFile !== undefined)
      content_.append("ExpenseFile", expenseFile, expenseFile.name ? expenseFile.name : "ExpenseFile");
    if (relatedStaffId !== null && relatedStaffId !== undefined)
      content_.append("RelatedStaffId", relatedStaffId.toString());
    if (gibInvoiceId !== null && gibInvoiceId !== undefined)
      content_.append("GibInvoiceId", gibInvoiceId.toString());
    if (categoryId !== null && categoryId !== undefined)
      content_.append("CategoryId", categoryId.toString());
    if (invoiceKindId !== null && invoiceKindId !== undefined)
      content_.append("InvoiceKindId", invoiceKindId.toString());
    if (expenseInvoiceItems === null || expenseInvoiceItems === undefined)
      throw new Error("The parameter 'expenseInvoiceItems' cannot be null.");
    else {
      expenseInvoiceItems.forEach((item, index) => {
        if (item.ProductId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].ProductId`, item.ProductId.toString());
        }
        if (item.WarehouseId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].WarehouseId`, item.WarehouseId.toString());
        }
        if (item.Amount != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Amount`, item.Amount.toString());
        }
        if (item.UnitPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].UnitPrice`, item.UnitPrice.toString());
        }
        if (item.ProductUnitId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].ProductUnitId`, item.ProductUnitId.toString());
        }
        if (item.TaxId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TaxId`, item.TaxId.toString());
        }
        if (item.TotalTax != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TotalTax`, item.TotalTax.toString());
        }
        if (item.SubTotalPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].SubTotalPrice`, item.SubTotalPrice.toString());
        }
        if (item.TotalPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TotalPrice`, item.TotalPrice.toString());
        }
        if (item.Description != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Description`, item.Description.toString());
        }
        if (item.DiscountTypeId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].DiscountTypeId`, item.DiscountTypeId.toString());
        }
        if (item.DiscountRate != null) {
          content_.append(`ExpenseInvoiceItems[${index}].DiscountRate`, item.DiscountRate.toString());
        }
        if (item.Discount != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Discount`, item.Discount.toString());
        }
        if (item.WitholdingRateId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].WitholdingRateId`, item.WitholdingRateId.toString());
        }
        if (item.Witholding != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Witholding`, item.Witholding.toString());
        }
      });
    }
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processCreate(_response);
    });
  }
  processCreate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200 = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreateExpenseInvoiceCommandResponse.fromJS(resultData200);
        return result200;
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}


export class CreateFastExpenseInvoiceClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  create(name, projectId, companyId, editDate, defermentDate, subTotalPrice, totalTax, totalPrice, expensePaymentStatusId, fromAccountId, checkoutName, paymentDate, expenseFile, relatedStaffId, invoiceNumber, categoryId, invoiceKindId) {
    let url_ = this.baseUrl + "/api/v1/expenseinvoice/CreateFast";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (name === null || name === undefined)
      throw new Error("The parameter 'name' cannot be null.");
    else
      content_.append("Name", name.toString());
    if (projectId !== null && projectId !== undefined)
      content_.append("ProjectId", projectId.toString());
    if (companyId !== null && companyId !== undefined)
      content_.append("CompanyId", companyId.toString());
    if (editDate !== null && editDate !== undefined)
      content_.append("EditDate", editDate.toJSON());
    if (defermentDate !== null && defermentDate !== undefined)
      content_.append("DefermentDate", defermentDate.toJSON());
    if (subTotalPrice !== null && subTotalPrice !== undefined)
      content_.append("SubTotalPrice", subTotalPrice.toString());
    if (totalTax !== null && totalTax !== undefined)
      content_.append("TotalTax", totalTax.toString());
    if (totalPrice !== null && totalPrice !== undefined)
      content_.append("TotalPrice", totalPrice.toString());
    if (expensePaymentStatusId !== null && expensePaymentStatusId !== undefined)
      content_.append("ExpensePaymentStatusId", expensePaymentStatusId.toString());
    if (fromAccountId !== null && fromAccountId !== undefined)
      content_.append("FromAccountId", fromAccountId.toString());
    if (checkoutName !== null && checkoutName !== undefined)
      content_.append("CheckoutName", checkoutName.toString());
    if (paymentDate !== null && paymentDate !== undefined)
      content_.append("PaymentDate", paymentDate.toJSON());
    if (expenseFile !== null && expenseFile !== undefined)
      content_.append("ExpenseFile", expenseFile, expenseFile.name ? expenseFile.name : "ExpenseFile");
    if (relatedStaffId !== null && relatedStaffId !== undefined)
      content_.append("RelatedStaffId", relatedStaffId.toString());
    if (invoiceNumber !== null && invoiceNumber !== undefined)
      content_.append("InvoiceNumber", invoiceNumber.toString());
    if (categoryId !== null && categoryId !== undefined)
      content_.append("CategoryId", categoryId.toString());
    if (invoiceKindId !== null && invoiceKindId !== undefined)
      content_.append("InvoiceKindId", invoiceKindId.toString());
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processCreate(_response);
    });
  }
  processCreate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200 = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreateFastExpenseInvoiceCommandResponse.fromJS(resultData200);
        return result200;
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}

export class CreateSundryExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createSundryExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/CreateSundry";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createSundryExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSundryExpenseInvoiceCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateTaxExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createTaxExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/CreateTax";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createTaxExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateTaxExpenseInvoiceCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetBankExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getBankExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/GetBank";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getBankExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBankExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetDetailExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/GetDetail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetFastExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getFastExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/GetFast";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getFastExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFastExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetSundryExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getSundryExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/GetSundry";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getSundryExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSundryExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetTaxExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getTaxExpenseInvoiceQuery) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/GetTax";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getTaxExpenseInvoiceQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTaxExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, editStartDate, editEndDate, projectId, companyId, expensePaymentStatusId, expenseTypeId, categoryId, invoiceKindId, bankId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (editStartDate === null)
            throw new Error("The parameter 'editStartDate' cannot be null.");
        else if (editStartDate !== undefined)
            url_ += "EditStartDate=" + encodeURIComponent(editStartDate ? "" + editStartDate.toISOString() : "") + "&";
        if (editEndDate === null)
            throw new Error("The parameter 'editEndDate' cannot be null.");
        else if (editEndDate !== undefined)
            url_ += "EditEndDate=" + encodeURIComponent(editEndDate ? "" + editEndDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (expensePaymentStatusId !== undefined && expensePaymentStatusId !== null)
            url_ += "ExpensePaymentStatusId=" + encodeURIComponent("" + expensePaymentStatusId) + "&";
        if (expenseTypeId !== undefined && expenseTypeId !== null)
            url_ += "ExpenseTypeId=" + encodeURIComponent("" + expenseTypeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (invoiceKindId !== undefined && invoiceKindId !== null)
            url_ += "InvoiceKindId=" + encodeURIComponent("" + invoiceKindId) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "BankId=" + encodeURIComponent("" + bankId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchExpenseInvoiceQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, editStartDate, editEndDate, projectId, companyId, expensePaymentStatusId, expenseTypeId, categoryId, invoiceKindId, bankId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (editStartDate === null)
            throw new Error("The parameter 'editStartDate' cannot be null.");
        else if (editStartDate !== undefined)
            url_ += "EditStartDate=" + encodeURIComponent(editStartDate ? "" + editStartDate.toISOString() : "") + "&";
        if (editEndDate === null)
            throw new Error("The parameter 'editEndDate' cannot be null.");
        else if (editEndDate !== undefined)
            url_ += "EditEndDate=" + encodeURIComponent(editEndDate ? "" + editEndDate.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (expensePaymentStatusId !== undefined && expensePaymentStatusId !== null)
            url_ += "ExpensePaymentStatusId=" + encodeURIComponent("" + expensePaymentStatusId) + "&";
        if (expenseTypeId !== undefined && expenseTypeId !== null)
            url_ += "ExpenseTypeId=" + encodeURIComponent("" + expenseTypeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (invoiceKindId !== undefined && invoiceKindId !== null)
            url_ += "InvoiceKindId=" + encodeURIComponent("" + invoiceKindId) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "BankId=" + encodeURIComponent("" + bankId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateBankExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBankExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/UpdateBank";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBankExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class UpdateDetailExpenseInvoiceClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  update(id, name, projectId, editDate, defermentDate, invoiceNumber, subTotalPrice, expenseFile, relatedStaffId, totalTax, totalDiscount, grossTotalPrice, totalWitholding, totalPrice, invoiceKindId, expenseInvoiceItems) {
    let url_ = this.baseUrl + "/api/v1/expenseinvoice/UpdateDetail";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (id === null || id === undefined)
      throw new Error("The parameter 'id' cannot be null.");
    else
      content_.append("Id", id.toString());
    if (name !== null && name !== undefined)
      content_.append("Name", name.toString());
    if (projectId !== null && projectId !== undefined)
      content_.append("ProjectId", projectId.toString());
    if (editDate !== null && editDate !== undefined)
      content_.append("EditDate", editDate.toJSON());
    if (defermentDate !== null && defermentDate !== undefined)
      content_.append("DefermentDate", defermentDate.toJSON());
    if (invoiceNumber !== null && invoiceNumber !== undefined)
      content_.append("InvoiceNumber", invoiceNumber.toString());
    if (subTotalPrice !== null && subTotalPrice !== undefined)
      content_.append("SubTotalPrice", subTotalPrice.toString());
    if (expenseFile !== null && expenseFile !== undefined)
      content_.append("ExpenseFile", expenseFile, expenseFile.name ? expenseFile.name : "ExpenseFile");
    if (relatedStaffId !== null && relatedStaffId !== undefined)
      content_.append("RelatedStaffId", relatedStaffId.toString());
    if (totalTax !== null && totalTax !== undefined)
      content_.append("TotalTax", totalTax.toString());
    if (totalDiscount !== null && totalDiscount !== undefined)
      content_.append("TotalDiscount", totalDiscount.toString());
    if (grossTotalPrice !== null && grossTotalPrice !== undefined)
      content_.append("GrossTotalPrice", grossTotalPrice.toString());
    if (totalWitholding !== null && totalWitholding !== undefined)
      content_.append("TotalWitholding", totalWitholding.toString());
    if (totalPrice !== null && totalPrice !== undefined)
      content_.append("TotalPrice", totalPrice.toString());
    if (invoiceKindId !== null && invoiceKindId !== undefined)
      content_.append("InvoiceKindId", invoiceKindId.toString());
    if (expenseInvoiceItems === null || expenseInvoiceItems === undefined)
      throw new Error("The parameter 'expenseInvoiceItems' cannot be null.");
    else {
      expenseInvoiceItems.forEach((item, index) => {
        if (item.Id != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Id`, item.Id.toString());
        }
        if (item.ProductId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].ProductId`, item.ProductId.toString());
        }
        if (item.WarehouseId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].WarehouseId`, item.WarehouseId.toString());
        }
        if (item.Amount != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Amount`, item.Amount.toString());
        }
        if (item.UnitPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].UnitPrice`, item.UnitPrice.toString());
        }
        if (item.ProductUnitId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].ProductUnitId`, item.ProductUnitId.toString());
        }
        if (item.TaxId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TaxId`, item.TaxId.toString());
        }
        if (item.TotalTax != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TotalTax`, item.TotalTax.toString());
        }
        if (item.SubTotalPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].SubTotalPrice`, item.SubTotalPrice.toString());
        }
        if (item.TotalPrice != null) {
          content_.append(`ExpenseInvoiceItems[${index}].TotalPrice`, item.TotalPrice.toString());
        }
        if (item.Description != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Description`, item.Description.toString());
        }
        if (item.DiscountTypeId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].DiscountTypeId`, item.DiscountTypeId.toString());
        }
        if (item.DiscountRate != null) {
          content_.append(`ExpenseInvoiceItems[${index}].DiscountRate`, item.DiscountRate.toString());
        }
        if (item.Discount != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Discount`, item.Discount.toString());
        }
        if (item.WitholdingRateId != null) {
          content_.append(`ExpenseInvoiceItems[${index}].WitholdingRateId`, item.WitholdingRateId.toString());
        }
        if (item.Witholding != null) {
          content_.append(`ExpenseInvoiceItems[${index}].Witholding`, item.Witholding.toString());
        }
      });
    }
    let options_ = {
      body: content_,
      method: "PUT",
      headers: {}
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processUpdate(_response);
    });
  }
  processUpdate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    }
    else if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    }
    else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404 = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}

export class UpdateFastExpenseInvoiceClient extends AuthorizedApiBase {
  constructor(baseUrl, http) {
    super();
    this.jsonParseReviver = undefined;
    this.http = http ? http : window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
  }
  update(id, name, projectId, editDate, defermentDate, subTotalPrice, expenseFile, invoiceNumber, relatedStaffId, totalTax, totalPrice, invoiceKindId) {
    let url_ = this.baseUrl + "/api/v1/expenseinvoice/UpdateFast";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = new FormData();
    if (id === null || id === undefined)
      throw new Error("The parameter 'id' cannot be null.");
    else
      content_.append("Id", id.toString());
    if (name === null || name === undefined)
      throw new Error("The parameter 'name' cannot be null.");
    else
      content_.append("Name", name.toString());
    if (projectId !== null && projectId !== undefined)
      content_.append("ProjectId", projectId.toString());
    if (editDate !== null && editDate !== undefined)
      content_.append("EditDate", editDate.toJSON());
    if (defermentDate !== null && defermentDate !== undefined)
      content_.append("DefermentDate", defermentDate.toJSON());
    if (subTotalPrice !== null && subTotalPrice !== undefined)
      content_.append("SubTotalPrice", subTotalPrice.toString());
    if (expenseFile !== null && expenseFile !== undefined)
      content_.append("ExpenseFile", expenseFile, expenseFile.name ? expenseFile.name : "ExpenseFile");
    if (invoiceNumber !== null && invoiceNumber !== undefined)
      content_.append("InvoiceNumber", invoiceNumber.toString());
    if (relatedStaffId !== null && relatedStaffId !== undefined)
      content_.append("RelatedStaffId", relatedStaffId.toString());
    if (totalTax !== null && totalTax !== undefined)
      content_.append("TotalTax", totalTax.toString());
    if (totalPrice !== null && totalPrice !== undefined)
      content_.append("TotalPrice", totalPrice.toString());
    if (invoiceKindId !== null && invoiceKindId !== undefined)
      content_.append("InvoiceKindId", invoiceKindId.toString());
    let options_ = {
      body: content_,
      method: "PUT",
      headers: {}
    };
    return this.transformOptions(options_).then(transformedOptions_ => {
      return this.http.fetch(url_, transformedOptions_);
    }).then((_response) => {
      return this.processUpdate(_response);
    });
  }
  processUpdate(response) {
    const status = response.status;
    let _headers = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v, k) => _headers[k] = v);
    }
    ;
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    }
    else if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    }
    else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404 = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
      });
    }
    else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400 = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    }
    else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    }
    else {
      return response.text().then((_responseText) => {
        let resultdefault = null;
        let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        resultdefault = ProblemDetails.fromJS(resultDatadefault);
        return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
      });
    }
  }
}

export class UpdateSundryExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateSundryExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/UpdateSundry";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateSundryExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateTaxExpenseInvoiceClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateTaxExpenseInvoiceCommand) {
        let url_ = this.baseUrl + "/api/v1/expenseinvoice/UpdateTax";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateTaxExpenseInvoiceCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CheckAddCollectionCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(checkAddCollectionCommand) {
        let url_ = this.baseUrl + "/api/v1/check/AddCollection";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(checkAddCollectionCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CheckAddPaymentCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(checkAddPaymentCommand) {
        let url_ = this.baseUrl + "/api/v1/check/AddPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(checkAddPaymentCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/check/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCheckQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, checkTypeId, defermentStartDate, defermentEndDate, companyId, checkStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/check/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (checkTypeId !== undefined && checkTypeId !== null)
            url_ += "CheckTypeId=" + encodeURIComponent("" + checkTypeId) + "&";
        if (defermentStartDate === null)
            throw new Error("The parameter 'defermentStartDate' cannot be null.");
        else if (defermentStartDate !== undefined)
            url_ += "DefermentStartDate=" + encodeURIComponent(defermentStartDate ? "" + defermentStartDate.toISOString() : "") + "&";
        if (defermentEndDate === null)
            throw new Error("The parameter 'defermentEndDate' cannot be null.");
        else if (defermentEndDate !== undefined)
            url_ += "DefermentEndDate=" + encodeURIComponent(defermentEndDate ? "" + defermentEndDate.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (checkStateId !== undefined && checkStateId !== null)
            url_ += "CheckStateId=" + encodeURIComponent("" + checkStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchCheckQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, checkTypeId, defermentStartDate, defermentEndDate, companyId, checkStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/check/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (checkTypeId !== undefined && checkTypeId !== null)
            url_ += "CheckTypeId=" + encodeURIComponent("" + checkTypeId) + "&";
        if (defermentStartDate === null)
            throw new Error("The parameter 'defermentStartDate' cannot be null.");
        else if (defermentStartDate !== undefined)
            url_ += "DefermentStartDate=" + encodeURIComponent(defermentStartDate ? "" + defermentStartDate.toISOString() : "") + "&";
        if (defermentEndDate === null)
            throw new Error("The parameter 'defermentEndDate' cannot be null.");
        else if (defermentEndDate !== undefined)
            url_ += "DefermentEndDate=" + encodeURIComponent(defermentEndDate ? "" + defermentEndDate.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (checkStateId !== undefined && checkStateId !== null)
            url_ += "CheckStateId=" + encodeURIComponent("" + checkStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateAdvanceCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateAdvanceCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/check/UpdateAdvanceCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateAdvanceCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateCheckClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/check/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class AccountToAccountTransactionCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(accountToAccountTransactionCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/AccountToAccountTransaction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(accountToAccountTransactionCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompanyCollectionCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(companyCollectionCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/CompanyCollection";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(companyCollectionCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyCollectionCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompanyPayCheckCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(companyPayCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/CompanyPayCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(companyPayCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompanyPaymentCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(companyPaymentCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/CompanyPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(companyPaymentCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyPaymentCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompanyPayNewCheckCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(companyPayNewCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/CompanyPayNewCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(companyPayNewCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreditTransactionCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(creditTransactionCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/CreditTransaction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(creditTransactionCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DebitTransactionCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(debitTransactionCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/DebitTransaction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(debitTransactionCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ExpenseInvoicePayCheckCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(expenseInvoicePayCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/ExpenseInvoicePayCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(expenseInvoicePayCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ExpenseInvoicePayMoneyCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(expenseInvoicePayMoneyCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/ExpenseInvoicePayMoney";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(expenseInvoicePayMoneyCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ExpenseInvoicePayNewCheckCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(expenseInvoicePayNewCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/ExpenseInvoicePayNewCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(expenseInvoicePayNewCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/checkout/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCheckoutQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetCollectionReceiptClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getCollectionReceiptQuery) {
        let url_ = this.baseUrl + "/api/v1/checkout/CollectionReceipt";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getCollectionReceiptQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCollectionReceiptQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SalaryPaymentCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(salaryPaymentCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/SalaryPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(salaryPaymentCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SalaryPaymentCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SaleInvoiceReceiveCheckCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(saleInvoiceReceiveCheckCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/SaleInvoiceRecieveCheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(saleInvoiceReceiveCheckCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SaleInvoiceReceiveMoneyCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(saleInvoiceReceiveMoneyCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/SaleInvoiceRecieveMoney";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(saleInvoiceReceiveMoneyCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SearchCheckoutByStaffIdClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchCheckoutByStaffIdQuery) {
        let url_ = this.baseUrl + "/api/v1/checkout/SearchByStaffId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchCheckoutByStaffIdQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchCheckoutByStaffIdQueryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchByStaffIdExcel(staffId, staffAccountId) {
        let url_ = this.baseUrl + "/api/v1/checkout/SearchByStaffIdExcel?";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (staffAccountId !== undefined && staffAccountId !== null)
            url_ += "StaffAccountId=" + encodeURIComponent("" + staffAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchByStaffIdExcel(_response);
        });
    }
    processSearchByStaffIdExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchTransactionsCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, beginDate, endDate, toAccountId, fromAccountId, minAmount, maxAmount, checkoutProcessTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/checkout/SearchTransactions?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (toAccountId !== undefined && toAccountId !== null)
            url_ += "ToAccountId=" + encodeURIComponent("" + toAccountId) + "&";
        if (fromAccountId !== undefined && fromAccountId !== null)
            url_ += "FromAccountId=" + encodeURIComponent("" + fromAccountId) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (checkoutProcessTypeId !== undefined && checkoutProcessTypeId !== null)
            url_ += "CheckoutProcessTypeId=" + encodeURIComponent("" + checkoutProcessTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchTransactionsQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, beginDate, endDate, toAccountId, fromAccountId, minAmount, maxAmount, checkoutProcessTypeId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/checkout/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (toAccountId !== undefined && toAccountId !== null)
            url_ += "ToAccountId=" + encodeURIComponent("" + toAccountId) + "&";
        if (fromAccountId !== undefined && fromAccountId !== null)
            url_ += "FromAccountId=" + encodeURIComponent("" + fromAccountId) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (checkoutProcessTypeId !== undefined && checkoutProcessTypeId !== null)
            url_ += "CheckoutProcessTypeId=" + encodeURIComponent("" + checkoutProcessTypeId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class StaffPaymentCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(staffPaymentCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/StaffPayment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(staffPaymentCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StaffPaymentCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateCheckoutDescriptionClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCheckoutDescriptionCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/UpdateDescription";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCheckoutDescriptionCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SearchCheckoutApproveClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(checkoutApproveStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/checkoutapprove/Search?";
        if (checkoutApproveStateId !== undefined && checkoutApproveStateId !== null)
            url_ += "CheckoutApproveStateId=" + encodeURIComponent("" + checkoutApproveStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchCheckoutApproveQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(checkoutApproveStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/checkoutapprove/Excel?";
        if (checkoutApproveStateId !== undefined && checkoutApproveStateId !== null)
            url_ += "CheckoutApproveStateId=" + encodeURIComponent("" + checkoutApproveStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateCheckoutApproveConfirmationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCheckoutApproveConfirmationCommand) {
        let url_ = this.baseUrl + "/api/v1/checkoutapprove/Confirm";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCheckoutApproveConfirmationCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CompleteBankOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(completeBankPaymentOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/CompleteBankOrder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(completeBankPaymentOrderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateBankPaymentOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createBankPaymentOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createBankPaymentOrderCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBankPaymentOrderCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteBankPaymentOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteBankPaymentOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteBankPaymentOrderCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetExcelReportClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(getPaymentRequestForExcelReportQuery) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/excelreport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(getPaymentRequestForExcelReportQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPaymentRequestForExcelReportQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class GetBankPaymentOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBankPaymentOrderQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchBankPaymentOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, beginDate, endDate, bankPaymentOrderStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (bankPaymentOrderStateId !== undefined && bankPaymentOrderStateId !== null)
            url_ += "BankPaymentOrderStateId=" + encodeURIComponent("" + bankPaymentOrderStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchBankPaymentOrderQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, beginDate, endDate, bankPaymentOrderStateId, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "BeginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (bankPaymentOrderStateId !== undefined && bankPaymentOrderStateId !== null)
            url_ += "BankPaymentOrderStateId=" + encodeURIComponent("" + bankPaymentOrderStateId) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateBankPaymentOrderConfirmationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBankPaymentOrderConfirmationCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Confirm";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBankPaymentOrderConfirmationCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateBankPaymentOrderClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBankPaymentOrderCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBankPaymentOrderCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateSendToConfirmationClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateSendToConfirmationCommand) {
        let url_ = this.baseUrl + "/api/v1/bankpaymentorder/SendToConfirmation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateSendToConfirmationCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class ArchivingAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    archive(archivingAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/account/Archive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(archivingAccountCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processArchive(_response);
        });
    }
    processArchive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateBankAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createBankAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/bankaccount/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createBankAccountCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBankAccountCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CreateCashAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    create(createCashAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/cashaccount/Create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createCashAccountCommand);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateCashAccountCommandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class CurrentAccountStatementClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(currentAccountStatementQuery) {
        let url_ = this.baseUrl + "/api/v1/account/CurrentAccountStatement";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(currentAccountStatementQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrentAccountStatementQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DeleteAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/account/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteAccountCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetBankCashAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    get(id) {
        let url_ = this.baseUrl + "/api/v1/bankcashaccount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAccountQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchBankCashAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(name, accountTypeId, projectId, currencyId, minBalance, maxBalance, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/bankcashaccount/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (accountTypeId !== undefined && accountTypeId !== null)
            url_ += "AccountTypeId=" + encodeURIComponent("" + accountTypeId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (currencyId !== undefined && currencyId !== null)
            url_ += "CurrencyId=" + encodeURIComponent("" + currencyId) + "&";
        if (minBalance !== undefined && minBalance !== null)
            url_ += "MinBalance=" + encodeURIComponent("" + minBalance) + "&";
        if (maxBalance !== undefined && maxBalance !== null)
            url_ += "MaxBalance=" + encodeURIComponent("" + maxBalance) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedListOfSearchAccountQueryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(name, accountTypeId, projectId, currencyId, minBalance, maxBalance, items_Per_Page, page, order, sort) {
        let url_ = this.baseUrl + "/api/v1/bankcashaccount/Excel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (accountTypeId !== undefined && accountTypeId !== null)
            url_ += "AccountTypeId=" + encodeURIComponent("" + accountTypeId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (currencyId !== undefined && currencyId !== null)
            url_ += "CurrencyId=" + encodeURIComponent("" + currencyId) + "&";
        if (minBalance !== undefined && minBalance !== null)
            url_ += "MinBalance=" + encodeURIComponent("" + minBalance) + "&";
        if (maxBalance !== undefined && maxBalance !== null)
            url_ += "MaxBalance=" + encodeURIComponent("" + maxBalance) + "&";
        if (items_Per_Page !== undefined && items_Per_Page !== null)
            url_ += "Items_Per_Page=" + encodeURIComponent("" + items_Per_Page) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (order !== undefined && order !== null)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchTransactionsAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    search(searchTransactionsQuery) {
        let url_ = this.baseUrl + "/api/v1/account/SearchTransactions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(searchTransactionsQuery);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchTransactionsQueryResponse2.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    excel(id) {
        let url_ = this.baseUrl + "/api/v1/account/Excel?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExcel(_response);
        });
    }
    processExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UpdateBankAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateBankAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/bankaccount/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBankAccountCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class UpdateCashAccountClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    update(updateCashAccountCommand) {
        let url_ = this.baseUrl + "/api/v1/cashaccount/Update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateCashAccountCommand);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DeleteCheckoutClient extends AuthorizedApiBase {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7016";
    }
    delete(deleteCheckoutCommand) {
        let url_ = this.baseUrl + "/api/v1/checkout/Delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(deleteCheckoutCommand);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class GetUserProfileQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["rolesWithName"])) {
                this.rolesWithName = [];
                for (let item of _data["rolesWithName"])
                    this.rolesWithName.push(IdName.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.rolesWithName)) {
            data["rolesWithName"] = [];
            for (let item of this.rolesWithName)
                data["rolesWithName"].push(item.toJSON());
        }
        return data;
    }
}
export class IdName {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IdName();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}
export class UpdateUserProfileCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}
export class GetStaffLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllProjectLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetBlockLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetBlockLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.constructionSiteId = _data["constructionSiteId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["constructionSiteId"] = this.constructionSiteId;
        return data;
    }
}
export class GetBuildingBlockTypeLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingBlockTypeLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetBuildingBlockTypeLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingBlockTypeLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}
export class GetConstructionSiteLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionSiteLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetConstructionSiteLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionSiteLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}
export class GetPlotLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlotLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetPlotLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.constructionId = _data["constructionId"];
            this.blockId = _data["blockId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlotLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["constructionId"] = this.constructionId;
        data["blockId"] = this.blockId;
        return data;
    }
}
export class GetProjectLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetProjectUsersLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUsersLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetProposalCompanyLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProposalCompanyLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetProposalCompanyLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProposalCompanyLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetScoreCardLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoreCardLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        return data;
    }
}
export class GetAllProductLookupForUpdateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFollowStock = _data["isFollowStock"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProductLookupForUpdateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFollowStock"] = this.isFollowStock;
        return data;
    }
}
export class GetAllProductLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFollowStock = _data["isFollowStock"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProductLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFollowStock"] = this.isFollowStock;
        return data;
    }
}
export class GetStockProductLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockProductLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetWarehouseLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllRoleLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRoleLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllUserByUserProjectLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserByUserProjectLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllUserLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllCompanyByProjectLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCompanyByProjectLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllCompanyByProjectLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCompanyByProjectLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}
export class GetCompanyInformationLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyTitle = _data["companyTitle"];
            this.identityNumber = _data["identityNumber"];
            this.taxNumber = _data["taxNumber"];
            this.iban = _data["iban"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["expenseInvoices"])) {
                this.expenseInvoices = [];
                for (let item of _data["expenseInvoices"])
                    this.expenseInvoices.push(GetCompanyInformationLookupQueryResponseExpenseInvoice.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyInformationLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyTitle"] = this.companyTitle;
        data["identityNumber"] = this.identityNumber;
        data["taxNumber"] = this.taxNumber;
        data["iban"] = this.iban;
        data["balance"] = this.balance;
        if (Array.isArray(this.expenseInvoices)) {
            data["expenseInvoices"] = [];
            for (let item of this.expenseInvoices)
                data["expenseInvoices"].push(item.toJSON());
        }
        return data;
    }
}
export class GetCompanyInformationLookupQueryResponseExpenseInvoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyInformationLookupQueryResponseExpenseInvoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetCompanyInformationLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyInformationLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetAllCompanyLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCompanyLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllDynamicReportRoleLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicReportRoleLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAccountLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAdvanceCheckLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceCheckLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAdvanceCheckLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceCheckLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetAllAccountLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAccountLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetUsableCheckLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsableCheckLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetExtendedAccountLookupQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExtendedAccountLookupQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class UpdateSalaryCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalaryCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class UpdateSalaryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.payment = _data["payment"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.projectId = _data["projectId"];
            this.salaryTypeId = _data["salaryTypeId"];
            this.besPayment = _data["besPayment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalaryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["payment"] = this.payment;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["projectId"] = this.projectId;
        data["salaryTypeId"] = this.salaryTypeId;
        data["besPayment"] = this.besPayment;
        return data;
    }
}
export class ArchivingStaffCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingStaffCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        return data;
    }
}
export class CreateStaffCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateStaffCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bloodTypeId = _data["bloodTypeId"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.relativeInformation = _data["relativeInformation"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.leaveDate = _data["leaveDate"] ? new Date(_data["leaveDate"].toString()) : undefined;
            this.salary = _data["salary"];
            this.registryNumber = _data["registryNumber"];
            this.identityNumber = _data["identityNumber"];
            this.title = _data["title"];
            this.iban = _data["iban"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bloodTypeId"] = this.bloodTypeId;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["relativeInformation"] = this.relativeInformation;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["leaveDate"] = this.leaveDate ? this.leaveDate.toISOString() : undefined;
        data["salary"] = this.salary;
        data["registryNumber"] = this.registryNumber;
        data["identityNumber"] = this.identityNumber;
        data["title"] = this.title;
        data["iban"] = this.iban;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export class DeleteStaffCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStaffCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetStaffQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.bloodTypeId = _data["bloodTypeId"];
            this.bloodTypeName = _data["bloodTypeName"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.relativeInformation = _data["relativeInformation"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.leaveDate = _data["leaveDate"] ? new Date(_data["leaveDate"].toString()) : undefined;
            this.salary = _data["salary"];
            this.registryNumber = _data["registryNumber"];
            this.identityNumber = _data["identityNumber"];
            this.title = _data["title"];
            this.iban = _data["iban"];
            this.totalPaidSalary = _data["totalPaidSalary"];
            this.totalSalaryAmount = _data["totalSalaryAmount"];
            this.totalAdvancePayment = _data["totalAdvancePayment"];
            this.totalBalance = _data["totalBalance"];
            this.earningLeaveBalance = _data["earningLeaveBalance"];
            this.montlyOvertime = _data["montlyOvertime"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [];
                for (let item of _data["projects"])
                    this.projects.push(ProjectModel.fromJS(item));
            }
            if (Array.isArray(_data["certificates"])) {
                this.certificates = [];
                for (let item of _data["certificates"])
                    this.certificates.push(CertificateModel.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["bloodTypeId"] = this.bloodTypeId;
        data["bloodTypeName"] = this.bloodTypeName;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["relativeInformation"] = this.relativeInformation;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["leaveDate"] = this.leaveDate ? this.leaveDate.toISOString() : undefined;
        data["salary"] = this.salary;
        data["registryNumber"] = this.registryNumber;
        data["identityNumber"] = this.identityNumber;
        data["title"] = this.title;
        data["iban"] = this.iban;
        data["totalPaidSalary"] = this.totalPaidSalary;
        data["totalSalaryAmount"] = this.totalSalaryAmount;
        data["totalAdvancePayment"] = this.totalAdvancePayment;
        data["totalBalance"] = this.totalBalance;
        data["earningLeaveBalance"] = this.earningLeaveBalance;
        data["montlyOvertime"] = this.montlyOvertime;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.certificates)) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class ProjectModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class CertificateModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.file = _data["file"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["file"] = this.file;
        return data;
    }
}
export class PagedListOfSearchStaffQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchStaffQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchStaffQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchStaffQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectIds = _data["projectIds"];
            this.nameSurname = _data["nameSurname"];
            this.title = _data["title"];
            this.phone = _data["phone"];
            this.identityNumber = _data["identityNumber"];
            this.projectNames = _data["projectNames"];
            this.balance = _data["balance"];
            this.balanceInformation = _data["balanceInformation"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStaffQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectIds"] = this.projectIds;
        data["nameSurname"] = this.nameSurname;
        data["title"] = this.title;
        data["phone"] = this.phone;
        data["identityNumber"] = this.identityNumber;
        data["projectNames"] = this.projectNames;
        data["balance"] = this.balance;
        data["balanceInformation"] = this.balanceInformation;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class Payload {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Payload();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined;
        return data;
    }
}
export class Pagination {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.first_page_url = _data["first_page_url"];
            this.from = _data["from"];
            this.items_per_page = _data["items_per_page"];
            this.last_page = _data["last_page"];
            if (Array.isArray(_data["links"])) {
                this.links = [];
                for (let item of _data["links"])
                    this.links.push(Link.fromJS(item));
            }
            this.next_page_url = _data["next_page_url"];
            this.page = _data["page"];
            this.previous_page_url = _data["previous_page_url"];
            this.to = _data["to"];
            this.total = _data["total"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["first_page_url"] = this.first_page_url;
        data["from"] = this.from;
        data["items_per_page"] = this.items_per_page;
        data["last_page"] = this.last_page;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["next_page_url"] = this.next_page_url;
        data["page"] = this.page;
        data["previous_page_url"] = this.previous_page_url;
        data["to"] = this.to;
        data["total"] = this.total;
        return data;
    }
}
export class Link {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.active = _data["active"];
            this.label = _data["label"];
            this.page = _data["page"];
            this.url = _data["url"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["label"] = this.label;
        data["page"] = this.page;
        data["url"] = this.url;
        data["type"] = this.type;
        return data;
    }
}
export class UpdateStaffCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.bloodTypeId = _data["bloodTypeId"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.relativeInformation = _data["relativeInformation"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.leaveDate = _data["leaveDate"] ? new Date(_data["leaveDate"].toString()) : undefined;
            this.salary = _data["salary"];
            this.registryNumber = _data["registryNumber"];
            this.identityNumber = _data["identityNumber"];
            this.title = _data["title"];
            this.iban = _data["iban"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bloodTypeId"] = this.bloodTypeId;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["relativeInformation"] = this.relativeInformation;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["leaveDate"] = this.leaveDate ? this.leaveDate.toISOString() : undefined;
        data["salary"] = this.salary;
        data["registryNumber"] = this.registryNumber;
        data["identityNumber"] = this.identityNumber;
        data["title"] = this.title;
        data["iban"] = this.iban;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}
export class ArchivingSalaryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingSalaryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSalaryCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalaryCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSalaryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.paymentStateId = _data["paymentStateId"];
            this.accountId = _data["accountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.projectId = _data["projectId"];
            this.salaryTypeId = _data["salaryTypeId"];
            this.besPayment = _data["besPayment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalaryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["paymentStateId"] = this.paymentStateId;
        data["accountId"] = this.accountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["projectId"] = this.projectId;
        data["salaryTypeId"] = this.salaryTypeId;
        data["besPayment"] = this.besPayment;
        return data;
    }
}
export class DeleteSalaryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSalaryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetMonthlySalaryByYearMonthQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
            this.balance = _data["balance"];
            this.isUpdateActive = _data["isUpdateActive"];
            this.isPayrollActive = _data["isPayrollActive"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["salaryList"])) {
                this.salaryList = [];
                for (let item of _data["salaryList"])
                    this.salaryList.push(GetMonthlySalaryByYearMonthQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryByYearMonthQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        data["balance"] = this.balance;
        data["isUpdateActive"] = this.isUpdateActive;
        data["isPayrollActive"] = this.isPayrollActive;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["name"] = this.name;
        if (Array.isArray(this.salaryList)) {
            data["salaryList"] = [];
            for (let item of this.salaryList)
                data["salaryList"].push(item.toJSON());
        }
        return data;
    }
}
export class GetMonthlySalaryByYearMonthQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.salaryId = _data["salaryId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.staffId = _data["staffId"];
            this.nameSurname = _data["nameSurname"];
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
            this.balance = _data["balance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryByYearMonthQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["salaryId"] = this.salaryId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["staffId"] = this.staffId;
        data["nameSurname"] = this.nameSurname;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        data["balance"] = this.balance;
        return data;
    }
}
export class GetMonthlySalaryByYearMonthQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryByYearMonthQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}
export class GetMonthlySalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["salaryList"])) {
                this.salaryList = [];
                for (let item of _data["salaryList"])
                    this.salaryList.push(GetMonthlySalaryQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["name"] = this.name;
        if (Array.isArray(this.salaryList)) {
            data["salaryList"] = [];
            for (let item of this.salaryList)
                data["salaryList"].push(item.toJSON());
        }
        return data;
    }
}
export class GetMonthlySalaryQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
            this.nameSurname = _data["nameSurname"];
            this.identityNumber = _data["identityNumber"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.jobLeaveDate = _data["jobLeaveDate"] ? new Date(_data["jobLeaveDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        data["nameSurname"] = this.nameSurname;
        data["identityNumber"] = this.identityNumber;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["jobLeaveDate"] = this.jobLeaveDate ? this.jobLeaveDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        return data;
    }
}
export class GetMonthlySalaryQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        return data;
    }
}
export class GetMonthlySalaryForPaymentQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.nameSurname = _data["nameSurname"];
            this.identityNumber = _data["identityNumber"];
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
            this.balance = _data["balance"];
            this.advance = _data["advance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryForPaymentQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["nameSurname"] = this.nameSurname;
        data["identityNumber"] = this.identityNumber;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        data["balance"] = this.balance;
        data["advance"] = this.advance;
        return data;
    }
}
export class GetMonthlySalaryForPaymentQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlySalaryForPaymentQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}
export class GetSalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffAccountId = _data["staffAccountId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.staffId = _data["staffId"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.paymentStateId = _data["paymentStateId"];
            this.balance = _data["balance"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.salaryTypeId = _data["salaryTypeId"];
            this.salaryTypeName = _data["salaryTypeName"];
            this.besPayment = _data["besPayment"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["checkouts"])) {
                this.checkouts = [];
                for (let item of _data["checkouts"])
                    this.checkouts.push(CheckoutResponse.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetSalaryQueryResponsePaymentPlan.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffAccountId"] = this.staffAccountId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["staffId"] = this.staffId;
        data["staffNameSurname"] = this.staffNameSurname;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["paymentStateId"] = this.paymentStateId;
        data["balance"] = this.balance;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["salaryTypeId"] = this.salaryTypeId;
        data["salaryTypeName"] = this.salaryTypeName;
        data["besPayment"] = this.besPayment;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.checkouts)) {
            data["checkouts"] = [];
            for (let item of this.checkouts)
                data["checkouts"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        return data;
    }
}
export class CheckoutResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.checkoutId = _data["checkoutId"];
            this.checkoutPaymenDate = _data["checkoutPaymenDate"] ? new Date(_data["checkoutPaymenDate"].toString()) : undefined;
            this.checkoutName = _data["checkoutName"];
            this.fromAccountName = _data["fromAccountName"];
            this.processTypeName = _data["processTypeName"];
            this.amount = _data["amount"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["checkoutId"] = this.checkoutId;
        data["checkoutPaymenDate"] = this.checkoutPaymenDate ? this.checkoutPaymenDate.toISOString() : undefined;
        data["checkoutName"] = this.checkoutName;
        data["fromAccountName"] = this.fromAccountName;
        data["processTypeName"] = this.processTypeName;
        data["amount"] = this.amount;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetSalaryQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class SearchByStaffIdQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.balance = _data["balance"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchByStaffIdQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffNameSurname"] = this.staffNameSurname;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["balance"] = this.balance;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        return data;
    }
}
export class PagedListOfSearchMonthlySalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchMonthlySalaryQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchMonthlySalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchMonthlySalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
            this.balance = _data["balance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMonthlySalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        data["balance"] = this.balance;
        return data;
    }
}
export class PagedListOfSearchSalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchSalaryQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchSalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchSalaryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.balance = _data["balance"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSalaryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffNameSurname"] = this.staffNameSurname;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["balance"] = this.balance;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateMonthlySalaryCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class UpdateMonthlySalaryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.progressPaymentDate = _data["progressPaymentDate"] ? new Date(_data["progressPaymentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            if (Array.isArray(_data["updateSalaryItems"])) {
                this.updateSalaryItems = [];
                for (let item of _data["updateSalaryItems"])
                    this.updateSalaryItems.push(UpdateMonthlySalaryCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["progressPaymentDate"] = this.progressPaymentDate ? this.progressPaymentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        if (Array.isArray(this.updateSalaryItems)) {
            data["updateSalaryItems"] = [];
            for (let item of this.updateSalaryItems)
                data["updateSalaryItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateMonthlySalaryCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
            this.payment = _data["payment"];
            this.besPayment = _data["besPayment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        data["payment"] = this.payment;
        data["besPayment"] = this.besPayment;
        return data;
    }
}
export class UpdateMonthlySalaryForPaymentCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryForPaymentCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class UpdateMonthlySalaryForPaymentCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentName = _data["paymentName"];
            this.accountId = _data["accountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            if (Array.isArray(_data["updateSalaryItems"])) {
                this.updateSalaryItems = [];
                for (let item of _data["updateSalaryItems"])
                    this.updateSalaryItems.push(UpdateMonthlySalaryForPaymentCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryForPaymentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentName"] = this.paymentName;
        data["accountId"] = this.accountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        if (Array.isArray(this.updateSalaryItems)) {
            data["updateSalaryItems"] = [];
            for (let item of this.updateSalaryItems)
                data["updateSalaryItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateMonthlySalaryForPaymentCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlySalaryForPaymentCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        return data;
    }
}
export class CreateOvertimeCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOvertimeCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateOvertimeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.overtimeTypeId = _data["overtimeTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOvertimeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["overtimeTypeId"] = this.overtimeTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class DeleteOvertimeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOvertimeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetOvertimeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.overtimeTypeId = _data["overtimeTypeId"];
            this.overtimeTypeName = _data["overtimeTypeName"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOvertimeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffNameSurname"] = this.staffNameSurname;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["overtimeTypeId"] = this.overtimeTypeId;
        data["overtimeTypeName"] = this.overtimeTypeName;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class SearchByStaffIdQueryResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.staffId = _data["staffId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.overtimeTypeName = _data["overtimeTypeName"];
            this.overtimeTypeId = _data["overtimeTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchByStaffIdQueryResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["staffId"] = this.staffId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["overtimeTypeName"] = this.overtimeTypeName;
        data["overtimeTypeId"] = this.overtimeTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class PagedListOfSearchOvertimeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchOvertimeQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchOvertimeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchOvertimeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOvertimeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["staffNameSurname"] = this.staffNameSurname;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateOvertimeCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : undefined;
            this.staffId = _data["staffId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.overtimeType = _data["overtimeType"] ? OvertimeType.fromJS(_data["overtimeType"]) : undefined;
            this.overtimeTypeId = _data["overtimeTypeId"];
            this.description = _data["description"];
            this.calculatedHour = _data["calculatedHour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOvertimeCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staff"] = this.staff ? this.staff.toJSON() : undefined;
        data["staffId"] = this.staffId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["overtimeType"] = this.overtimeType ? this.overtimeType.toJSON() : undefined;
        data["overtimeTypeId"] = this.overtimeTypeId;
        data["description"] = this.description;
        data["calculatedHour"] = this.calculatedHour;
        return data;
    }
}
export class BaseEntity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [];
                for (let item of _data["domainEvents"])
                    this.domainEvents.push(DomainEvent.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        return data;
    }
}
export class Staff extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bloodTypeId = _data["bloodTypeId"];
            this.bloodType = _data["bloodType"] ? BloodType.fromJS(_data["bloodType"]) : undefined;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined;
            this.accountId = _data["accountId"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.relativeInformation = _data["relativeInformation"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.leaveDate = _data["leaveDate"] ? new Date(_data["leaveDate"].toString()) : undefined;
            this.salary = _data["salary"];
            this.registryNumber = _data["registryNumber"];
            this.identityNumber = _data["identityNumber"];
            this.title = _data["title"];
            this.isArchived = _data["isArchived"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined;
            this.archivedBy = _data["archivedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined;
            this.deletedBy = _data["deletedBy"];
            if (Array.isArray(_data["projectStaffList"])) {
                this.projectStaffList = [];
                for (let item of _data["projectStaffList"])
                    this.projectStaffList.push(ProjectStaff.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Staff();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bloodTypeId"] = this.bloodTypeId;
        data["bloodType"] = this.bloodType ? this.bloodType.toJSON() : undefined;
        data["account"] = this.account ? this.account.toJSON() : undefined;
        data["accountId"] = this.accountId;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["relativeInformation"] = this.relativeInformation;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["leaveDate"] = this.leaveDate ? this.leaveDate.toISOString() : undefined;
        data["salary"] = this.salary;
        data["registryNumber"] = this.registryNumber;
        data["identityNumber"] = this.identityNumber;
        data["title"] = this.title;
        data["isArchived"] = this.isArchived;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined;
        data["archivedBy"] = this.archivedBy;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined;
        data["deletedBy"] = this.deletedBy;
        if (Array.isArray(this.projectStaffList)) {
            data["projectStaffList"] = [];
            for (let item of this.projectStaffList)
                data["projectStaffList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class LookupEntity extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'LookupEntity' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        super.toJSON(data);
        return data;
    }
}
export class BloodType extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BloodType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DomainEvent {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (_data["properties"]) {
                this.properties = {};
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties[key] = _data["properties"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DomainEvent' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    }
}
export class Account extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.accountType = _data["accountType"] ? AccountType.fromJS(_data["accountType"]) : undefined;
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : undefined;
            this.accountTypeId = _data["accountTypeId"];
            this.bankName = _data["bankName"];
            this.branch = _data["branch"];
            this.accountNumber = _data["accountNumber"];
            this.iban = _data["iban"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined;
            this.projectId = _data["projectId"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined;
            this.deletedBy = _data["deletedBy"];
            this.isArchived = _data["isArchived"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined;
            this.archivedBy = _data["archivedBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountType"] = this.accountType ? this.accountType.toJSON() : undefined;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : undefined;
        data["accountTypeId"] = this.accountTypeId;
        data["bankName"] = this.bankName;
        data["branch"] = this.branch;
        data["accountNumber"] = this.accountNumber;
        data["iban"] = this.iban;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["projectId"] = this.projectId;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined;
        data["deletedBy"] = this.deletedBy;
        data["isArchived"] = this.isArchived;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined;
        data["archivedBy"] = this.archivedBy;
        super.toJSON(data);
        return data;
    }
}
export class AccountType extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class Currency extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.currencySymbol = _data["currencySymbol"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["currencySymbol"] = this.currencySymbol;
        super.toJSON(data);
        return data;
    }
}
export class Project extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.projectState = _data["projectState"] ? ProjectState.fromJS(_data["projectState"]) : undefined;
            this.projectStateId = _data["projectStateId"];
            this.customerName = _data["customerName"];
            this.province = _data["province"] ? Province.fromJS(_data["province"]) : undefined;
            this.provinceId = _data["provinceId"];
            this.district = _data["district"] ? District.fromJS(_data["district"]) : undefined;
            this.districtId = _data["districtId"];
            this.address = _data["address"];
            this.projectLeader = _data["projectLeader"];
            this.description = _data["description"];
            this.isArchived = _data["isArchived"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined;
            this.archivedBy = _data["archivedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined;
            this.deletedBy = _data["deletedBy"];
            this.projectId = _data["projectId"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.auctionDate = _data["auctionDate"] ? new Date(_data["auctionDate"].toString()) : undefined;
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined;
            this.locationDueDate = _data["locationDueDate"] ? new Date(_data["locationDueDate"].toString()) : undefined;
            this.technicalStaffNotificationDate = _data["technicalStaffNotificationDate"] ? new Date(_data["technicalStaffNotificationDate"].toString()) : undefined;
            this.workProgramDueDate = _data["workProgramDueDate"] ? new Date(_data["workProgramDueDate"].toString()) : undefined;
            this.allRiskDueDate = _data["allRiskDueDate"] ? new Date(_data["allRiskDueDate"].toString()) : undefined;
            this.comparison = _data["comparison"] ? new Date(_data["comparison"].toString()) : undefined;
            this.timeOfExtension = _data["timeOfExtension"] ? new Date(_data["timeOfExtension"].toString()) : undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined;
            this.temporaryOfWorkAcceptanceDate = _data["temporaryOfWorkAcceptanceDate"] ? new Date(_data["temporaryOfWorkAcceptanceDate"].toString()) : undefined;
            this.exactOfWorkAcceptanceDate = _data["exactOfWorkAcceptanceDate"] ? new Date(_data["exactOfWorkAcceptanceDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["projectState"] = this.projectState ? this.projectState.toJSON() : undefined;
        data["projectStateId"] = this.projectStateId;
        data["customerName"] = this.customerName;
        data["province"] = this.province ? this.province.toJSON() : undefined;
        data["provinceId"] = this.provinceId;
        data["district"] = this.district ? this.district.toJSON() : undefined;
        data["districtId"] = this.districtId;
        data["address"] = this.address;
        data["projectLeader"] = this.projectLeader;
        data["description"] = this.description;
        data["isArchived"] = this.isArchived;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined;
        data["archivedBy"] = this.archivedBy;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined;
        data["deletedBy"] = this.deletedBy;
        data["projectId"] = this.projectId;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["auctionDate"] = this.auctionDate ? this.auctionDate.toISOString() : undefined;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined;
        data["locationDueDate"] = this.locationDueDate ? this.locationDueDate.toISOString() : undefined;
        data["technicalStaffNotificationDate"] = this.technicalStaffNotificationDate ? this.technicalStaffNotificationDate.toISOString() : undefined;
        data["workProgramDueDate"] = this.workProgramDueDate ? this.workProgramDueDate.toISOString() : undefined;
        data["allRiskDueDate"] = this.allRiskDueDate ? this.allRiskDueDate.toISOString() : undefined;
        data["comparison"] = this.comparison ? this.comparison.toISOString() : undefined;
        data["timeOfExtension"] = this.timeOfExtension ? this.timeOfExtension.toISOString() : undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["temporaryOfWorkAcceptanceDate"] = this.temporaryOfWorkAcceptanceDate ? this.temporaryOfWorkAcceptanceDate.toISOString() : undefined;
        data["exactOfWorkAcceptanceDate"] = this.exactOfWorkAcceptanceDate ? this.exactOfWorkAcceptanceDate.toISOString() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ProjectState extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectState();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class Province extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Province();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class District extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.province = _data["province"] ? Province.fromJS(_data["province"]) : undefined;
            this.provinceId = _data["provinceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new District();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["province"] = this.province ? this.province.toJSON() : undefined;
        data["provinceId"] = this.provinceId;
        super.toJSON(data);
        return data;
    }
}
export class ProjectStaff extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : undefined;
            this.staffId = _data["staffId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined;
            this.projectId = _data["projectId"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined;
            this.deletedBy = _data["deletedBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaff();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["staff"] = this.staff ? this.staff.toJSON() : undefined;
        data["staffId"] = this.staffId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["projectId"] = this.projectId;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined;
        data["deletedBy"] = this.deletedBy;
        super.toJSON(data);
        return data;
    }
}
export class OvertimeType extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateOvertimeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.hourDuration = _data["hourDuration"];
            this.overtimeTypeId = _data["overtimeTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOvertimeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["hourDuration"] = this.hourDuration;
        data["overtimeTypeId"] = this.overtimeTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class CreateLeaveCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeaveCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateLeaveCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.dayCount = _data["dayCount"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeaveCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["dayCount"] = this.dayCount;
        data["leaveTypeId"] = this.leaveTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class DeleteLeaveCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLeaveCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetLeaveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.dayCount = _data["dayCount"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveTypeName = _data["leaveTypeName"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        data["staffNameSurname"] = this.staffNameSurname;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["dayCount"] = this.dayCount;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveTypeName"] = this.leaveTypeName;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class SearchByStaffIdQueryResponse3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.staffId = _data["staffId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.dayCount = _data["dayCount"];
            this.leaveTypeName = _data["leaveTypeName"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchByStaffIdQueryResponse3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["staffId"] = this.staffId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["dayCount"] = this.dayCount;
        data["leaveTypeName"] = this.leaveTypeName;
        data["leaveTypeId"] = this.leaveTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class SearchByStaffIdQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchByStaffIdQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        return data;
    }
}
export class PagedListOfSearchLeaveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchLeaveQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchLeaveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchLeaveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.dayCount = _data["dayCount"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLeaveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffNameSurname"] = this.staffNameSurname;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["dayCount"] = this.dayCount;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateLeaveCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.dayCount = _data["dayCount"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLeaveCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["dayCount"] = this.dayCount;
        data["leaveTypeId"] = this.leaveTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class CreateEarningLeaveCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEarningLeaveCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateEarningLeaveCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.name = _data["name"];
            this.dayCount = _data["dayCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEarningLeaveCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["name"] = this.name;
        data["dayCount"] = this.dayCount;
        return data;
    }
}
export class DeleteEarningLeaveCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEarningLeaveCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffId"] = this.staffId;
        return data;
    }
}
export class GetAllEarningLeaveByStaffIdQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dayCount = _data["dayCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEarningLeaveByStaffIdQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dayCount"] = this.dayCount;
        return data;
    }
}
export class GetAllEarningLeaveByStaffIdQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEarningLeaveByStaffIdQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        return data;
    }
}
export class GetEarningLeaveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dayCount = _data["dayCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetEarningLeaveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dayCount"] = this.dayCount;
        return data;
    }
}
export class GetRemainingLeaveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.balance = _data["balance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemainingLeaveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        return data;
    }
}
export class CreateCertificateCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCertificateCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DeleteCertificateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCertificateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class UpdateFirstTableCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.genderId = _data["genderId"];
            this.isActive = _data["isActive"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.appointmentHour = _data["appointmentHour"] ? new Date(_data["appointmentHour"].toString()) : undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [];
                for (let item of _data["hobbies"])
                    this.hobbies.push(HobbyCommandResponseModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFirstTableCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["genderId"] = this.genderId;
        data["isActive"] = this.isActive;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["appointmentHour"] = this.appointmentHour ? this.appointmentHour.toISOString() : undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item.toJSON());
        }
        return data;
    }
}
export class HobbyCommandResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HobbyCommandResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class UpdateFirstTableCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.genderId = _data["genderId"];
            this.isActive = _data["isActive"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.appointmentHour = _data["appointmentHour"] ? new Date(_data["appointmentHour"].toString()) : undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [];
                for (let item of _data["hobbies"])
                    this.hobbies.push(HobbyCommandModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFirstTableCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["genderId"] = this.genderId;
        data["isActive"] = this.isActive;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["appointmentHour"] = this.appointmentHour ? this.appointmentHour.toISOString() : undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item.toJSON());
        }
        return data;
    }
}
export class HobbyCommandModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HobbyCommandModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class GetAllFirstTableQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.genderName = _data["genderName"];
            this.isActive = _data["isActive"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.appointmentHour = _data["appointmentHour"] ? new Date(_data["appointmentHour"].toString()) : undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [];
                for (let item of _data["hobbies"])
                    this.hobbies.push(HobbyResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFirstTableQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["genderName"] = this.genderName;
        data["isActive"] = this.isActive;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["appointmentHour"] = this.appointmentHour ? this.appointmentHour.toISOString() : undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item.toJSON());
        }
        return data;
    }
}
export class HobbyResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HobbyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class CreateFirstTableCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFirstTableCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateFirstTableCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.genderId = _data["genderId"];
            this.isActive = _data["isActive"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.appointmentHour = _data["appointmentHour"] ? new Date(_data["appointmentHour"].toString()) : undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [];
                for (let item of _data["hobbies"])
                    this.hobbies.push(HobbyCommandModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFirstTableCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["genderId"] = this.genderId;
        data["isActive"] = this.isActive;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["appointmentHour"] = this.appointmentHour ? this.appointmentHour.toISOString() : undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item.toJSON());
        }
        return data;
    }
}
export class HobbyCommandModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HobbyCommandModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class GetAllBookQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBookQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class CashFlowReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.generalCashFlows = _data["generalCashFlows"] ? GeneralCashFlow.fromJS(_data["generalCashFlows"]) : undefined;
            this.currentCashFlows = _data["currentCashFlows"] ? CurrentCashFlow.fromJS(_data["currentCashFlows"]) : undefined;
            if (Array.isArray(_data["generalCashFlowList"])) {
                this.generalCashFlowList = [];
                for (let item of _data["generalCashFlowList"])
                    this.generalCashFlowList.push(GeneralCashFlowList.fromJS(item));
            }
            if (Array.isArray(_data["currentCashFlowList"])) {
                this.currentCashFlowList = [];
                for (let item of _data["currentCashFlowList"])
                    this.currentCashFlowList.push(CurrentCashFlowList.fromJS(item));
            }
            this.bankAccounts = _data["bankAccounts"] ? BankAccount.fromJS(_data["bankAccounts"]) : undefined;
            if (Array.isArray(_data["paymentPlansMonthlyExpenses"])) {
                this.paymentPlansMonthlyExpenses = [];
                for (let item of _data["paymentPlansMonthlyExpenses"])
                    this.paymentPlansMonthlyExpenses.push(PaymentPlanMonthlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlySales"])) {
                this.paymentPlansMonthlySales = [];
                for (let item of _data["paymentPlansMonthlySales"])
                    this.paymentPlansMonthlySales.push(PaymentPlanMonthlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansYearlyExpenses"])) {
                this.paymentPlansYearlyExpenses = [];
                for (let item of _data["paymentPlansYearlyExpenses"])
                    this.paymentPlansYearlyExpenses.push(PaymentPlanYearlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansYearlySales"])) {
                this.paymentPlansYearlySales = [];
                for (let item of _data["paymentPlansYearlySales"])
                    this.paymentPlansYearlySales.push(PaymentPlanYearlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansExpenses"])) {
                this.paymentPlansExpenses = [];
                for (let item of _data["paymentPlansExpenses"])
                    this.paymentPlansExpenses.push(PaymentPlanModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansSales"])) {
                this.paymentPlansSales = [];
                for (let item of _data["paymentPlansSales"])
                    this.paymentPlansSales.push(PaymentPlanModelForCashFlow.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashFlowReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["generalCashFlows"] = this.generalCashFlows ? this.generalCashFlows.toJSON() : undefined;
        data["currentCashFlows"] = this.currentCashFlows ? this.currentCashFlows.toJSON() : undefined;
        if (Array.isArray(this.generalCashFlowList)) {
            data["generalCashFlowList"] = [];
            for (let item of this.generalCashFlowList)
                data["generalCashFlowList"].push(item.toJSON());
        }
        if (Array.isArray(this.currentCashFlowList)) {
            data["currentCashFlowList"] = [];
            for (let item of this.currentCashFlowList)
                data["currentCashFlowList"].push(item.toJSON());
        }
        data["bankAccounts"] = this.bankAccounts ? this.bankAccounts.toJSON() : undefined;
        if (Array.isArray(this.paymentPlansMonthlyExpenses)) {
            data["paymentPlansMonthlyExpenses"] = [];
            for (let item of this.paymentPlansMonthlyExpenses)
                data["paymentPlansMonthlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlySales)) {
            data["paymentPlansMonthlySales"] = [];
            for (let item of this.paymentPlansMonthlySales)
                data["paymentPlansMonthlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansYearlyExpenses)) {
            data["paymentPlansYearlyExpenses"] = [];
            for (let item of this.paymentPlansYearlyExpenses)
                data["paymentPlansYearlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansYearlySales)) {
            data["paymentPlansYearlySales"] = [];
            for (let item of this.paymentPlansYearlySales)
                data["paymentPlansYearlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansExpenses)) {
            data["paymentPlansExpenses"] = [];
            for (let item of this.paymentPlansExpenses)
                data["paymentPlansExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansSales)) {
            data["paymentPlansSales"] = [];
            for (let item of this.paymentPlansSales)
                data["paymentPlansSales"].push(item.toJSON());
        }
        return data;
    }
}
export class GeneralCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["paymentPlansYearlyExpenses"])) {
                this.paymentPlansYearlyExpenses = [];
                for (let item of _data["paymentPlansYearlyExpenses"])
                    this.paymentPlansYearlyExpenses.push(PaymentPlanYearlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansYearlySales"])) {
                this.paymentPlansYearlySales = [];
                for (let item of _data["paymentPlansYearlySales"])
                    this.paymentPlansYearlySales.push(PaymentPlanYearlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansYearlyCashFlows"])) {
                this.paymentPlansYearlyCashFlows = [];
                for (let item of _data["paymentPlansYearlyCashFlows"])
                    this.paymentPlansYearlyCashFlows.push(PaymentPlansYearlyCashFlowModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentPlansYearlyExpenses)) {
            data["paymentPlansYearlyExpenses"] = [];
            for (let item of this.paymentPlansYearlyExpenses)
                data["paymentPlansYearlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansYearlySales)) {
            data["paymentPlansYearlySales"] = [];
            for (let item of this.paymentPlansYearlySales)
                data["paymentPlansYearlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansYearlyCashFlows)) {
            data["paymentPlansYearlyCashFlows"] = [];
            for (let item of this.paymentPlansYearlyCashFlows)
                data["paymentPlansYearlyCashFlows"].push(item.toJSON());
        }
        return data;
    }
}
export class PaymentPlanYearlyModelForCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanYearlyModelForCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class PaymentPlansYearlyCashFlowModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.cashFlow = _data["cashFlow"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlansYearlyCashFlowModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["cashFlow"] = this.cashFlow;
        return data;
    }
}
export class CurrentCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["paymentPlansMonthlyExpenses"])) {
                this.paymentPlansMonthlyExpenses = [];
                for (let item of _data["paymentPlansMonthlyExpenses"])
                    this.paymentPlansMonthlyExpenses.push(PaymentPlanMonthlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlySales"])) {
                this.paymentPlansMonthlySales = [];
                for (let item of _data["paymentPlansMonthlySales"])
                    this.paymentPlansMonthlySales.push(PaymentPlanMonthlyModelForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlyCashFlows"])) {
                this.paymentPlansMonthlyCashFlows = [];
                for (let item of _data["paymentPlansMonthlyCashFlows"])
                    this.paymentPlansMonthlyCashFlows.push(PaymentPlansMonthlyCashFlowModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentPlansMonthlyExpenses)) {
            data["paymentPlansMonthlyExpenses"] = [];
            for (let item of this.paymentPlansMonthlyExpenses)
                data["paymentPlansMonthlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlySales)) {
            data["paymentPlansMonthlySales"] = [];
            for (let item of this.paymentPlansMonthlySales)
                data["paymentPlansMonthlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlyCashFlows)) {
            data["paymentPlansMonthlyCashFlows"] = [];
            for (let item of this.paymentPlansMonthlyCashFlows)
                data["paymentPlansMonthlyCashFlows"].push(item.toJSON());
        }
        return data;
    }
}
export class PaymentPlanMonthlyModelForCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.day = _data["day"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanMonthlyModelForCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["day"] = this.day;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class PaymentPlansMonthlyCashFlowModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.monthName = _data["monthName"];
            this.cashFlow = _data["cashFlow"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlansMonthlyCashFlowModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["monthName"] = this.monthName;
        data["cashFlow"] = this.cashFlow;
        return data;
    }
}
export class GeneralCashFlowList {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.yearlyCashFlowListItem = _data["yearlyCashFlowListItem"];
            this.yearlyExpenseListItem = _data["yearlyExpenseListItem"];
            this.yearlySaleListItem = _data["yearlySaleListItem"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCashFlowList();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["yearlyCashFlowListItem"] = this.yearlyCashFlowListItem;
        data["yearlyExpenseListItem"] = this.yearlyExpenseListItem;
        data["yearlySaleListItem"] = this.yearlySaleListItem;
        return data;
    }
}
export class CurrentCashFlowList {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.monthlyCashFlowListItem = _data["monthlyCashFlowListItem"];
            this.monthlyExpenseListItem = _data["monthlyExpenseListItem"];
            this.monthlySaleListItem = _data["monthlySaleListItem"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCashFlowList();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["monthlyCashFlowListItem"] = this.monthlyCashFlowListItem;
        data["monthlyExpenseListItem"] = this.monthlyExpenseListItem;
        data["monthlySaleListItem"] = this.monthlySaleListItem;
        return data;
    }
}
export class BankAccount {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalDefaultCurrencyAmount = _data["totalDefaultCurrencyAmount"];
            this.totalOtherCurrenciesAmount = _data["totalOtherCurrenciesAmount"];
            this.totalAllCurrenciesAmount = _data["totalAllCurrenciesAmount"];
            if (Array.isArray(_data["currenctBankCashAccounts"])) {
                this.currenctBankCashAccounts = [];
                for (let item of _data["currenctBankCashAccounts"])
                    this.currenctBankCashAccounts.push(CurrentBankCashAccountForCashFlow.fromJS(item));
            }
            if (Array.isArray(_data["currencyInfos"])) {
                this.currencyInfos = [];
                for (let item of _data["currencyInfos"])
                    this.currencyInfos.push(CurrencyInfo.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccount();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalDefaultCurrencyAmount"] = this.totalDefaultCurrencyAmount;
        data["totalOtherCurrenciesAmount"] = this.totalOtherCurrenciesAmount;
        data["totalAllCurrenciesAmount"] = this.totalAllCurrenciesAmount;
        if (Array.isArray(this.currenctBankCashAccounts)) {
            data["currenctBankCashAccounts"] = [];
            for (let item of this.currenctBankCashAccounts)
                data["currenctBankCashAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.currencyInfos)) {
            data["currencyInfos"] = [];
            for (let item of this.currencyInfos)
                data["currencyInfos"].push(item.toJSON());
        }
        return data;
    }
}
export class CurrentBankCashAccountForCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.currencyId = _data["currencyId"];
            this.totalAmount = _data["totalAmount"];
            this.defaultCurrencyAmount = _data["defaultCurrencyAmount"];
            this.currentRate = _data["currentRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentBankCashAccountForCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["currencyId"] = this.currencyId;
        data["totalAmount"] = this.totalAmount;
        data["defaultCurrencyAmount"] = this.defaultCurrencyAmount;
        data["currentRate"] = this.currentRate;
        return data;
    }
}
export class CurrencyInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.currencyRate = _data["currencyRate"];
            this.currencyCode = _data["currencyCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["currencyRate"] = this.currencyRate;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}
export class PaymentPlanModelForCashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paymentPlanTypeId = _data["paymentPlanTypeId"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.salaryId = _data["salaryId"];
            this.checkId = _data["checkId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.defermenDate = _data["defermenDate"] ? new Date(_data["defermenDate"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanModelForCashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentPlanTypeId"] = this.paymentPlanTypeId;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["salaryId"] = this.salaryId;
        data["checkId"] = this.checkId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseTypeId"] = this.expenseTypeId;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["defermenDate"] = this.defermenDate ? this.defermenDate.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}
export class CashFlowReportQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashFlowReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class SaleInvoicePaymentPlanQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.companyName = _data["companyName"];
            this.projectName = _data["projectName"];
            this.defermentDate = _data["defermentDate"];
            this.paymentPlanTotalPrice = _data["paymentPlanTotalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoicePaymentPlanQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["companyName"] = this.companyName;
        data["projectName"] = this.projectName;
        data["defermentDate"] = this.defermentDate;
        data["paymentPlanTotalPrice"] = this.paymentPlanTotalPrice;
        return data;
    }
}
export class SaleWithBalanceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.paidAmount = _data["paidAmount"];
            this.balance = _data["balance"];
            this.editDate = _data["editDate"];
            this.defermentDate = _data["defermentDate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleWithBalanceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["paidAmount"] = this.paidAmount;
        data["balance"] = this.balance;
        data["editDate"] = this.editDate;
        data["defermentDate"] = this.defermentDate;
        return data;
    }
}
export class ExpenseInvoicePaymentPlanQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.companyName = _data["companyName"];
            this.projectName = _data["projectName"];
            this.defermentDate = _data["defermentDate"];
            this.paymentPlanTotalPrice = _data["paymentPlanTotalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoicePaymentPlanQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["companyName"] = this.companyName;
        data["projectName"] = this.projectName;
        data["defermentDate"] = this.defermentDate;
        data["paymentPlanTotalPrice"] = this.paymentPlanTotalPrice;
        return data;
    }
}
export class ExpenseWithBalanceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.paidAmount = _data["paidAmount"];
            this.balance = _data["balance"];
            this.editDate = _data["editDate"];
            this.defermentDate = _data["defermentDate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseWithBalanceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["paidAmount"] = this.paidAmount;
        data["balance"] = this.balance;
        data["editDate"] = this.editDate;
        data["defermentDate"] = this.defermentDate;
        return data;
    }
}
export class ExpenseInvoiceReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.expenseCategoryName = _data["expenseCategoryName"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseTypeName = _data["expenseTypeName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.totalTax = _data["totalTax"];
            this.totalWitholding = _data["totalWitholding"];
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["relatedStaffId"] = this.relatedStaffId;
        data["staffNameSurname"] = this.staffNameSurname;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["expenseCategoryName"] = this.expenseCategoryName;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseTypeName"] = this.expenseTypeName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["totalTax"] = this.totalTax;
        data["totalWitholding"] = this.totalWitholding;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        return data;
    }
}
export class SaleInvoiceReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.saleCategoryId = _data["saleCategoryId"];
            this.saleCategoryName = _data["saleCategoryName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.salePaymentStatusId = _data["salePaymentStatusId"];
            this.salePaymentStatusName = _data["salePaymentStatusName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.totalTax = _data["totalTax"];
            this.totalWitholding = _data["totalWitholding"];
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["saleCategoryId"] = this.saleCategoryId;
        data["saleCategoryName"] = this.saleCategoryName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["salePaymentStatusId"] = this.salePaymentStatusId;
        data["salePaymentStatusName"] = this.salePaymentStatusName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["totalTax"] = this.totalTax;
        data["totalWitholding"] = this.totalWitholding;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        return data;
    }
}
export class ChecksWithExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.checkNo = _data["checkNo"];
            this.bankName = _data["bankName"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"];
            this.defermentDate = _data["defermentDate"];
            this.totalPrice = _data["totalPrice"];
            this.checkStateName = _data["checkStateName"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.expenseInvoiceTotalPrice = _data["expenseInvoiceTotalPrice"];
            this.expenseInvoiceBalance = _data["expenseInvoiceBalance"];
            this.projectName = _data["projectName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChecksWithExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["checkNo"] = this.checkNo;
        data["bankName"] = this.bankName;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate;
        data["defermentDate"] = this.defermentDate;
        data["totalPrice"] = this.totalPrice;
        data["checkStateName"] = this.checkStateName;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["expenseInvoiceTotalPrice"] = this.expenseInvoiceTotalPrice;
        data["expenseInvoiceBalance"] = this.expenseInvoiceBalance;
        data["projectName"] = this.projectName;
        return data;
    }
}
export class ExpenseInvoiceChartCategoryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceChartCategoryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class ExpenseInvoiceChartProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceChartProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class ExpenseInvoiceChartDateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceChartDateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class ExpenseInvoiceChartMonthQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceChartMonthQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class ExpenseInvoiceChartStatusQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceChartStatusQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceChartCategoryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceChartCategoryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceChartProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceChartProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceChartDateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceChartDateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceChartMonthQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceChartMonthQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceRealEstateChartMonthQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceRealEstateChartMonthQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class SaleInvoiceChartStatusQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.dataCount = _data["dataCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceChartStatusQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataCount"] = this.dataCount;
        return data;
    }
}
export class BlockCompleteRateWithConstructionSiteByProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            if (Array.isArray(_data["blockList"])) {
                this.blockList = [];
                for (let item of _data["blockList"])
                    this.blockList.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BlockCompleteRateWithConstructionSiteByProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        if (Array.isArray(this.blockList)) {
            data["blockList"] = [];
            for (let item of this.blockList)
                data["blockList"].push(item);
        }
        return data;
    }
}
export class AccountWithCreditQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.accountTypeName = _data["accountTypeName"];
            this.editDate = _data["editDate"];
            this.defermentDate = _data["defermentDate"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.paymentPlanFirstPayment = _data["paymentPlanFirstPayment"];
            this.paymentPlanFirstDefermentDate = _data["paymentPlanFirstDefermentDate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWithCreditQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["accountTypeName"] = this.accountTypeName;
        data["editDate"] = this.editDate;
        data["defermentDate"] = this.defermentDate;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["paymentPlanFirstPayment"] = this.paymentPlanFirstPayment;
        data["paymentPlanFirstDefermentDate"] = this.paymentPlanFirstDefermentDate;
        return data;
    }
}
export class AccountWithCreditQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWithCreditQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class ClosedCreditQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.accountTypeName = _data["accountTypeName"];
            this.editDate = _data["editDate"];
            this.defermentDate = _data["defermentDate"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.paymentPlanFirstPayment = _data["paymentPlanFirstPayment"];
            this.paymentPlanFirstDefermentDate = _data["paymentPlanFirstDefermentDate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClosedCreditQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["accountTypeName"] = this.accountTypeName;
        data["editDate"] = this.editDate;
        data["defermentDate"] = this.defermentDate;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["paymentPlanFirstPayment"] = this.paymentPlanFirstPayment;
        data["paymentPlanFirstDefermentDate"] = this.paymentPlanFirstDefermentDate;
        return data;
    }
}
export class ClosedCreditQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClosedCreditQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class PagedListOfSearchDynamicReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchDynamicReportQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchDynamicReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchDynamicReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uniqueName = _data["uniqueName"];
            this.description = _data["description"];
            this.route = _data["route"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDynamicReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uniqueName"] = this.uniqueName;
        data["description"] = this.description;
        data["route"] = this.route;
        return data;
    }
}
export class ArchivingRealEstateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingRealEstateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateRealEstateCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRealEstateCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateRealEstateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.address = _data["address"];
            this.projectId = _data["projectId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.description = _data["description"];
            this.estateTypeId = _data["estateTypeId"];
            this.grossArea = _data["grossArea"];
            this.netArea = _data["netArea"];
            this.estateStateId = _data["estateStateId"];
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRealEstateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["address"] = this.address;
        data["projectId"] = this.projectId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["description"] = this.description;
        data["estateTypeId"] = this.estateTypeId;
        data["grossArea"] = this.grossArea;
        data["netArea"] = this.netArea;
        data["estateStateId"] = this.estateStateId;
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export class DeleteRealEstateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRealEstateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetRealEstateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.address = _data["address"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.provinceName = _data["provinceName"];
            this.provinceId = _data["provinceId"];
            this.districtName = _data["districtName"];
            this.districtId = _data["districtId"];
            this.description = _data["description"];
            this.estateTypeName = _data["estateTypeName"];
            this.estateTypeId = _data["estateTypeId"];
            this.grossArea = _data["grossArea"];
            this.netArea = _data["netArea"];
            this.estateStateName = _data["estateStateName"];
            this.estateStateId = _data["estateStateId"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRealEstateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["address"] = this.address;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["provinceName"] = this.provinceName;
        data["provinceId"] = this.provinceId;
        data["districtName"] = this.districtName;
        data["districtId"] = this.districtId;
        data["description"] = this.description;
        data["estateTypeName"] = this.estateTypeName;
        data["estateTypeId"] = this.estateTypeId;
        data["grossArea"] = this.grossArea;
        data["netArea"] = this.netArea;
        data["estateStateName"] = this.estateStateName;
        data["estateStateId"] = this.estateStateId;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class PagedListOfSearchRealEstateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchRealEstateQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchRealEstateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchRealEstateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.projectName = _data["projectName"];
            this.estateTypeName = _data["estateTypeName"];
            this.grossArea = _data["grossArea"];
            this.netArea = _data["netArea"];
            this.estateStateName = _data["estateStateName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRealEstateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["baseSalePrice"] = this.baseSalePrice;
        data["projectName"] = this.projectName;
        data["estateTypeName"] = this.estateTypeName;
        data["grossArea"] = this.grossArea;
        data["netArea"] = this.netArea;
        data["estateStateName"] = this.estateStateName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateRealEstateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.address = _data["address"];
            this.projectId = _data["projectId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.description = _data["description"];
            this.estateTypeId = _data["estateTypeId"];
            this.grossArea = _data["grossArea"];
            this.netArea = _data["netArea"];
            this.estateStateId = _data["estateStateId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRealEstateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["address"] = this.address;
        data["projectId"] = this.projectId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["description"] = this.description;
        data["estateTypeId"] = this.estateTypeId;
        data["grossArea"] = this.grossArea;
        data["netArea"] = this.netArea;
        data["estateStateId"] = this.estateStateId;
        return data;
    }
}
export class CreateTimeKeepingTemplateCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTimeKeepingTemplateCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateTimeKeepingTemplateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.timeKeepingTypeId = _data["timeKeepingTypeId"];
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTimeKeepingTemplateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["timeKeepingTypeId"] = this.timeKeepingTypeId;
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class DeleteTimeKeepingTemplateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTimeKeepingTemplateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetTimeKeepingTemplateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.timeKeepingTypeId = _data["timeKeepingTypeId"];
            this.timeKeepingTypeName = _data["timeKeepingTypeName"];
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimeKeepingTemplateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["timeKeepingTypeId"] = this.timeKeepingTypeId;
        data["timeKeepingTypeName"] = this.timeKeepingTypeName;
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class PagedListOfSearchTimeKeepingTemplateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchTimeKeepingTemplateQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchTimeKeepingTemplateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchTimeKeepingTemplateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.timeKeepingTypeId = _data["timeKeepingTypeId"];
            this.timeKeepingTypeName = _data["timeKeepingTypeName"];
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTimeKeepingTemplateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["timeKeepingTypeId"] = this.timeKeepingTypeId;
        data["timeKeepingTypeName"] = this.timeKeepingTypeName;
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class UpdateTimeKeepingTemplateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.timeKeepingTypeId = _data["timeKeepingTypeId"];
            this.name = _data["name"];
            this.dataOrder = _data["dataOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimeKeepingTemplateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["timeKeepingTypeId"] = this.timeKeepingTypeId;
        data["name"] = this.name;
        data["dataOrder"] = this.dataOrder;
        return data;
    }
}
export class ArchivingTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateTaskCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.taskStateId = _data["taskStateId"];
            this.rootTaskId = _data["rootTaskId"];
            this.duration = _data["duration"];
            this.staffId = _data["staffId"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.completionRate = _data["completionRate"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockId = _data["blockId"];
            this.plotId = _data["plotId"];
            this.totalWork = _data["totalWork"];
            this.totalPersonDay = _data["totalPersonDay"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["taskStateId"] = this.taskStateId;
        data["rootTaskId"] = this.rootTaskId;
        data["duration"] = this.duration;
        data["staffId"] = this.staffId;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["completionRate"] = this.completionRate;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockId"] = this.blockId;
        data["plotId"] = this.plotId;
        data["totalWork"] = this.totalWork;
        data["totalPersonDay"] = this.totalPersonDay;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class DeleteTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.remainingDay = _data["remainingDay"];
            this.duration = _data["duration"];
            this.taskStateId = _data["taskStateId"];
            this.taskStateName = _data["taskStateName"];
            this.staffId = _data["staffId"];
            this.staffName = _data["staffName"];
            this.description = _data["description"];
            this.completionRate = _data["completionRate"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockName = _data["blockName"];
            this.blockId = _data["blockId"];
            this.plotName = _data["plotName"];
            this.plotId = _data["plotId"];
            this.totalWork = _data["totalWork"];
            this.totalPersonDay = _data["totalPersonDay"];
            this.rootTaskName = _data["rootTaskName"];
            this.rootTaskId = _data["rootTaskId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["subTasks"])) {
                this.subTasks = [];
                for (let item of _data["subTasks"])
                    this.subTasks.push(GetTaskQueryResponseSubTask.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["remainingDay"] = this.remainingDay;
        data["duration"] = this.duration;
        data["taskStateId"] = this.taskStateId;
        data["taskStateName"] = this.taskStateName;
        data["staffId"] = this.staffId;
        data["staffName"] = this.staffName;
        data["description"] = this.description;
        data["completionRate"] = this.completionRate;
        data["constructionSiteName"] = this.constructionSiteName;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockName"] = this.blockName;
        data["blockId"] = this.blockId;
        data["plotName"] = this.plotName;
        data["plotId"] = this.plotId;
        data["totalWork"] = this.totalWork;
        data["totalPersonDay"] = this.totalPersonDay;
        data["rootTaskName"] = this.rootTaskName;
        data["rootTaskId"] = this.rootTaskId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.subTasks)) {
            data["subTasks"] = [];
            for (let item of this.subTasks)
                data["subTasks"].push(item.toJSON());
        }
        return data;
    }
}
export class GetTaskQueryResponseSubTask {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.taskStateName = _data["taskStateName"];
            this.staffName = _data["staffName"];
            this.totalWork = _data["totalWork"];
            this.completionRate = _data["completionRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskQueryResponseSubTask();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["taskStateName"] = this.taskStateName;
        data["staffName"] = this.staffName;
        data["totalWork"] = this.totalWork;
        data["completionRate"] = this.completionRate;
        return data;
    }
}
export class PagedListOfSearchTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchTaskQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.rootTaskName = _data["rootTaskName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.remainingDay = _data["remainingDay"];
            this.taskStateName = _data["taskStateName"];
            this.staffName = _data["staffName"];
            this.description = _data["description"];
            this.completionRate = _data["completionRate"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockName = _data["blockName"];
            this.blockId = _data["blockId"];
            this.plotName = _data["plotName"];
            this.plotId = _data["plotId"];
            this.totalWork = _data["totalWork"];
            this.totalPersonDay = _data["totalPersonDay"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["rootTaskName"] = this.rootTaskName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["remainingDay"] = this.remainingDay;
        data["taskStateName"] = this.taskStateName;
        data["staffName"] = this.staffName;
        data["description"] = this.description;
        data["completionRate"] = this.completionRate;
        data["constructionSiteName"] = this.constructionSiteName;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockName"] = this.blockName;
        data["blockId"] = this.blockId;
        data["plotName"] = this.plotName;
        data["plotId"] = this.plotId;
        data["totalWork"] = this.totalWork;
        data["totalPersonDay"] = this.totalPersonDay;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateTaskCompletionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.taskStateId = _data["taskStateId"];
            this.completionRate = _data["completionRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCompletionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["taskStateId"] = this.taskStateId;
        data["completionRate"] = this.completionRate;
        return data;
    }
}
export class UpdateTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.taskStateId = _data["taskStateId"];
            this.duration = _data["duration"];
            this.staffId = _data["staffId"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.completionRate = _data["completionRate"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockId = _data["blockId"];
            this.plotId = _data["plotId"];
            this.totalWork = _data["totalWork"];
            this.totalPersonDay = _data["totalPersonDay"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["taskStateId"] = this.taskStateId;
        data["duration"] = this.duration;
        data["staffId"] = this.staffId;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["completionRate"] = this.completionRate;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockId"] = this.blockId;
        data["plotId"] = this.plotId;
        data["totalWork"] = this.totalWork;
        data["totalPersonDay"] = this.totalPersonDay;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class CreateScoreCardCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScoreCardCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateScoreCardCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.identityNumber = _data["identityNumber"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScoreCardCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["identityNumber"] = this.identityNumber;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined;
        return data;
    }
}
export class DeleteScoreCardCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScoreCardCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetScoreCardQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.identityNumber = _data["identityNumber"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined;
            if (Array.isArray(_data["scoreCardItems"])) {
                this.scoreCardItems = [];
                for (let item of _data["scoreCardItems"])
                    this.scoreCardItems.push(GetScoreCardQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoreCardQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["identityNumber"] = this.identityNumber;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined;
        if (Array.isArray(this.scoreCardItems)) {
            data["scoreCardItems"] = [];
            for (let item of this.scoreCardItems)
                data["scoreCardItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetScoreCardQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.scoreCardId = _data["scoreCardId"];
            this.scoreCardTypeId = _data["scoreCardTypeId"];
            this.scoreCardTypeName = _data["scoreCardTypeName"];
            this.scoreCardDate = _data["scoreCardDate"] ? new Date(_data["scoreCardDate"].toString()) : undefined;
            this.leaveHour = _data["leaveHour"];
            this.overtimeHour = _data["overtimeHour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoreCardQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["scoreCardId"] = this.scoreCardId;
        data["scoreCardTypeId"] = this.scoreCardTypeId;
        data["scoreCardTypeName"] = this.scoreCardTypeName;
        data["scoreCardDate"] = this.scoreCardDate ? this.scoreCardDate.toISOString() : undefined;
        data["leaveHour"] = this.leaveHour;
        data["overtimeHour"] = this.overtimeHour;
        return data;
    }
}
export class PagedListOfSearchScoreCardQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchScoreCardQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchScoreCardQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchScoreCardQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.identityNumber = _data["identityNumber"];
            this.companyName = _data["companyName"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchScoreCardQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["identityNumber"] = this.identityNumber;
        data["companyName"] = this.companyName;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateScoreCardCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.identityNumber = _data["identityNumber"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScoreCardCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["identityNumber"] = this.identityNumber;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined;
        return data;
    }
}
export class GetScoreCardDaysQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.scoreCardId = _data["scoreCardId"];
            this.projectId = _data["projectId"];
            this.scoreCardDate = _data["scoreCardDate"] ? new Date(_data["scoreCardDate"].toString()) : undefined;
            this.scoreCardTypeId = _data["scoreCardTypeId"];
            this.leaveHour = _data["leaveHour"];
            this.overtimeHour = _data["overtimeHour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoreCardDaysQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scoreCardId"] = this.scoreCardId;
        data["projectId"] = this.projectId;
        data["scoreCardDate"] = this.scoreCardDate ? this.scoreCardDate.toISOString() : undefined;
        data["scoreCardTypeId"] = this.scoreCardTypeId;
        data["leaveHour"] = this.leaveHour;
        data["overtimeHour"] = this.overtimeHour;
        return data;
    }
}
export class GetScoreCardDaysQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.scoreCardDate = _data["scoreCardDate"] ? new Date(_data["scoreCardDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoreCardDaysQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["scoreCardDate"] = this.scoreCardDate ? this.scoreCardDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateScoreCardDaysCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["scoreCardDayModels"])) {
                this.scoreCardDayModels = [];
                for (let item of _data["scoreCardDayModels"])
                    this.scoreCardDayModels.push(UpdateScoreCardDaysCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScoreCardDaysCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scoreCardDayModels)) {
            data["scoreCardDayModels"] = [];
            for (let item of this.scoreCardDayModels)
                data["scoreCardDayModels"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateScoreCardDaysCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.scoreCardId = _data["scoreCardId"];
            this.projectId = _data["projectId"];
            this.scoreCardDate = _data["scoreCardDate"] ? new Date(_data["scoreCardDate"].toString()) : undefined;
            this.scoreCardTypeId = _data["scoreCardTypeId"];
            this.leaveHour = _data["leaveHour"];
            this.overtimeHour = _data["overtimeHour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScoreCardDaysCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scoreCardId"] = this.scoreCardId;
        data["projectId"] = this.projectId;
        data["scoreCardDate"] = this.scoreCardDate ? this.scoreCardDate.toISOString() : undefined;
        data["scoreCardTypeId"] = this.scoreCardTypeId;
        data["leaveHour"] = this.leaveHour;
        data["overtimeHour"] = this.overtimeHour;
        return data;
    }
}
export class ArchivingPurchaseRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingPurchaseRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePurchaseRequestCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseRequestCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePurchaseRequestCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseRequestCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["description"] = this.description;
        return data;
    }
}
export class DeletePurchaseRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePurchaseRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetPurchaseRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.purchaseRequestStatusId = _data["purchaseRequestStatusId"];
            this.purchaseRequestStatusName = _data["purchaseRequestStatusName"];
            this.note = _data["note"];
            this.relatedUserId = _data["relatedUserId"];
            this.relatedUserName = _data["relatedUserName"];
            this.requestedUserId = _data["requestedUserId"];
            this.requestedUserName = _data["requestedUserName"];
            this.approveUserId = _data["approveUserId"];
            this.approveUserName = _data["approveUserName"];
            this.approveDate = _data["approveDate"] ? new Date(_data["approveDate"].toString()) : undefined;
            this.approveNote = _data["approveNote"];
            this.evaluationResult = _data["evaluationResult"];
            this.canApprove = _data["canApprove"];
            this.fileUrl = _data["fileUrl"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["purchaseRequestItems"])) {
                this.purchaseRequestItems = [];
                for (let item of _data["purchaseRequestItems"])
                    this.purchaseRequestItems.push(GetPurchaseRequestQueryResponseItem.fromJS(item));
            }
            if (Array.isArray(_data["purchaseProposalItems"])) {
                this.purchaseProposalItems = [];
                for (let item of _data["purchaseProposalItems"])
                    this.purchaseProposalItems.push(GetPurchaseRequestQueryResponseProposalItem.fromJS(item));
            }
            this.purchaseProposalConfirmedItem = _data["purchaseProposalConfirmedItem"] ? GetPurchaseRequestQueryResponseConfirmedProposalItem.fromJS(_data["purchaseProposalConfirmedItem"]) : undefined;
            if (Array.isArray(_data["purchaseProposalRequestItems"])) {
                this.purchaseProposalRequestItems = [];
                for (let item of _data["purchaseProposalRequestItems"])
                    this.purchaseProposalRequestItems.push(GetPurchaseRequestQueryResponseProposalRequestItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["purchaseRequestStatusId"] = this.purchaseRequestStatusId;
        data["purchaseRequestStatusName"] = this.purchaseRequestStatusName;
        data["note"] = this.note;
        data["relatedUserId"] = this.relatedUserId;
        data["relatedUserName"] = this.relatedUserName;
        data["requestedUserId"] = this.requestedUserId;
        data["requestedUserName"] = this.requestedUserName;
        data["approveUserId"] = this.approveUserId;
        data["approveUserName"] = this.approveUserName;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : undefined;
        data["approveNote"] = this.approveNote;
        data["evaluationResult"] = this.evaluationResult;
        data["canApprove"] = this.canApprove;
        data["fileUrl"] = this.fileUrl;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.purchaseRequestItems)) {
            data["purchaseRequestItems"] = [];
            for (let item of this.purchaseRequestItems)
                data["purchaseRequestItems"].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseProposalItems)) {
            data["purchaseProposalItems"] = [];
            for (let item of this.purchaseProposalItems)
                data["purchaseProposalItems"].push(item.toJSON());
        }
        data["purchaseProposalConfirmedItem"] = this.purchaseProposalConfirmedItem ? this.purchaseProposalConfirmedItem.toJSON() : undefined;
        if (Array.isArray(this.purchaseProposalRequestItems)) {
            data["purchaseProposalRequestItems"] = [];
            for (let item of this.purchaseProposalRequestItems)
                data["purchaseProposalRequestItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetPurchaseRequestQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["description"] = this.description;
        return data;
    }
}
export class GetPurchaseRequestQueryResponseProposalItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceWithTax = _data["totalPriceWithTax"];
            this.proposalFileUrl = _data["proposalFileUrl"];
            this.purchaseProposalStatusId = _data["purchaseProposalStatusId"];
            this.purchaseProposalStatusName = _data["purchaseProposalStatusName"];
            this.transportation = _data["transportation"];
            this.paymentDetail = _data["paymentDetail"];
            this.deliveryTime = _data["deliveryTime"];
            this.brand = _data["brand"];
            this.laborTotalPrice = _data["laborTotalPrice"];
            this.productTotalPrice = _data["productTotalPrice"];
            this.tseFileUrl = _data["tseFileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestQueryResponseProposalItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceWithTax"] = this.totalPriceWithTax;
        data["proposalFileUrl"] = this.proposalFileUrl;
        data["purchaseProposalStatusId"] = this.purchaseProposalStatusId;
        data["purchaseProposalStatusName"] = this.purchaseProposalStatusName;
        data["transportation"] = this.transportation;
        data["paymentDetail"] = this.paymentDetail;
        data["deliveryTime"] = this.deliveryTime;
        data["brand"] = this.brand;
        data["laborTotalPrice"] = this.laborTotalPrice;
        data["productTotalPrice"] = this.productTotalPrice;
        data["tseFileUrl"] = this.tseFileUrl;
        return data;
    }
}
export class GetPurchaseRequestQueryResponseConfirmedProposalItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceWithTax = _data["totalPriceWithTax"];
            this.proposalFileUrl = _data["proposalFileUrl"];
            this.purchaseProposalStatusId = _data["purchaseProposalStatusId"];
            this.purchaseProposalStatusName = _data["purchaseProposalStatusName"];
            this.transportation = _data["transportation"];
            this.paymentDetail = _data["paymentDetail"];
            this.deliveryTime = _data["deliveryTime"];
            this.brand = _data["brand"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestQueryResponseConfirmedProposalItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceWithTax"] = this.totalPriceWithTax;
        data["proposalFileUrl"] = this.proposalFileUrl;
        data["purchaseProposalStatusId"] = this.purchaseProposalStatusId;
        data["purchaseProposalStatusName"] = this.purchaseProposalStatusName;
        data["transportation"] = this.transportation;
        data["paymentDetail"] = this.paymentDetail;
        data["deliveryTime"] = this.deliveryTime;
        data["brand"] = this.brand;
        return data;
    }
}
export class GetPurchaseRequestQueryResponseProposalRequestItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseProposalGuid = _data["purchaseProposalGuid"];
            this.proposalCompanyId = _data["proposalCompanyId"];
            this.proposalCompanyName = _data["proposalCompanyName"];
            this.fileUrl = _data["fileUrl"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.latestDateProposal = _data["latestDateProposal"] ? new Date(_data["latestDateProposal"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestQueryResponseProposalRequestItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseProposalGuid"] = this.purchaseProposalGuid;
        data["proposalCompanyId"] = this.proposalCompanyId;
        data["proposalCompanyName"] = this.proposalCompanyName;
        data["fileUrl"] = this.fileUrl;
        data["description"] = this.description;
        data["note"] = this.note;
        data["latestDateProposal"] = this.latestDateProposal ? this.latestDateProposal.toISOString() : undefined;
        return data;
    }
}
export class GetPurchaseRequestWithAllSubInfoQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestWithAllSubInfoQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}
export class GetPurchaseRequestWithAllSubInfoQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.purchaseRequestId = _data["purchaseRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseRequestWithAllSubInfoQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["purchaseRequestId"] = this.purchaseRequestId;
        return data;
    }
}
export class PagedListOfSearchPurchaseRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPurchaseRequestQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPurchaseRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPurchaseRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.proposalCount = _data["proposalCount"];
            this.purchaseRequestStatusName = _data["purchaseRequestStatusName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPurchaseRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["proposalCount"] = this.proposalCount;
        data["purchaseRequestStatusName"] = this.purchaseRequestStatusName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateEvaluationResultCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseRequestStatusId = _data["purchaseRequestStatusId"];
            this.evaluationResult = _data["evaluationResult"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEvaluationResultCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseRequestStatusId"] = this.purchaseRequestStatusId;
        data["evaluationResult"] = this.evaluationResult;
        return data;
    }
}
export class UpdatePurchaseRequestCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseRequestCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["description"] = this.description;
        return data;
    }
}
export class UpdatePurchaseRequestStatusCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseRequestStatusId = _data["purchaseRequestStatusId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseRequestStatusCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseRequestStatusId"] = this.purchaseRequestStatusId;
        return data;
    }
}
export class ApprovePurchaseProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseProposalId = _data["purchaseProposalId"];
            this.approveNote = _data["approveNote"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovePurchaseProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseProposalId"] = this.purchaseProposalId;
        data["approveNote"] = this.approveNote;
        return data;
    }
}
export class CreatePurchaseProposalCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseProposalCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePurchaseProposalRequestCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseProposalRequestCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePurchaseProposalRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.proposalCompanyId = _data["proposalCompanyId"];
            this.description = _data["description"];
            this.latestDateProposal = _data["latestDateProposal"] ? new Date(_data["latestDateProposal"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseProposalRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["proposalCompanyId"] = this.proposalCompanyId;
        data["description"] = this.description;
        data["latestDateProposal"] = this.latestDateProposal ? this.latestDateProposal.toISOString() : undefined;
        return data;
    }
}
export class GetPurchaseProposalRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.fileUrl = _data["fileUrl"];
            this.description = _data["description"];
            this.latestDateProposal = _data["latestDateProposal"] ? new Date(_data["latestDateProposal"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["fileUrl"] = this.fileUrl;
        data["description"] = this.description;
        data["latestDateProposal"] = this.latestDateProposal ? this.latestDateProposal.toISOString() : undefined;
        return data;
    }
}
export class GetPurchaseProposalRequestQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.purchaseProposalGuid = _data["purchaseProposalGuid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["purchaseProposalGuid"] = this.purchaseProposalGuid;
        return data;
    }
}
export class GetPurchaseProposalRequestSendMailQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestSendMailQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetPurchaseProposalRequestSendMailQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestSendMailQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetPurchaseProposalRequestSubInfoQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.applicationLink = _data["applicationLink"];
            this.description = _data["description"];
            this.content = _data["content"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestSubInfoQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["applicationLink"] = this.applicationLink;
        data["description"] = this.description;
        data["content"] = this.content;
        return data;
    }
}
export class GetPurchaseProposalRequestSubInfoQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseProposalRequestSubInfoQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedListOfSearchPurchaseProposalRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPurchaseProposalRequestQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPurchaseProposalRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPurchaseProposalRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.purchaseRequestName = _data["purchaseRequestName"];
            this.proposalCompanyName = _data["proposalCompanyName"];
            this.latestDateProposal = _data["latestDateProposal"] ? new Date(_data["latestDateProposal"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPurchaseProposalRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["purchaseRequestName"] = this.purchaseRequestName;
        data["proposalCompanyName"] = this.proposalCompanyName;
        data["latestDateProposal"] = this.latestDateProposal ? this.latestDateProposal.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class CreatePurchaseOrderCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePurchaseOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.purchaseOrderStatusId = _data["purchaseOrderStatusId"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.note = _data["note"];
            if (Array.isArray(_data["purchaseOrderItems"])) {
                this.purchaseOrderItems = [];
                for (let item of _data["purchaseOrderItems"])
                    this.purchaseOrderItems.push(CreatePurchaseOrderCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["purchaseOrderStatusId"] = this.purchaseOrderStatusId;
        data["deliveryAddress"] = this.deliveryAddress;
        data["relatedStaffId"] = this.relatedStaffId;
        data["note"] = this.note;
        if (Array.isArray(this.purchaseOrderItems)) {
            data["purchaseOrderItems"] = [];
            for (let item of this.purchaseOrderItems)
                data["purchaseOrderItems"].push(item.toJSON());
        }
        return data;
    }
}
export class CreatePurchaseOrderCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["description"] = this.description;
        return data;
    }
}
export class GetPurchaseOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.purchaseRequestName = _data["purchaseRequestName"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.purchaseOrderStatusId = _data["purchaseOrderStatusId"];
            this.purchaseOrderStatusName = _data["purchaseOrderStatusName"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.note = _data["note"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["purchaseOrderItems"])) {
                this.purchaseOrderItems = [];
                for (let item of _data["purchaseOrderItems"])
                    this.purchaseOrderItems.push(GetPurchaseOrderQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["purchaseRequestName"] = this.purchaseRequestName;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["purchaseOrderStatusId"] = this.purchaseOrderStatusId;
        data["purchaseOrderStatusName"] = this.purchaseOrderStatusName;
        data["deliveryAddress"] = this.deliveryAddress;
        data["relatedStaffId"] = this.relatedStaffId;
        data["relatedStaffName"] = this.relatedStaffName;
        data["note"] = this.note;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.purchaseOrderItems)) {
            data["purchaseOrderItems"] = [];
            for (let item of this.purchaseOrderItems)
                data["purchaseOrderItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetPurchaseOrderQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseOrderQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["description"] = this.description;
        return data;
    }
}
export class PagedListOfSearchPurchaseOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPurchaseOrderQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPurchaseOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPurchaseOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.purchaseOrderStatusName = _data["purchaseOrderStatusName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPurchaseOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["purchaseOrderStatusName"] = this.purchaseOrderStatusName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdatePurchaseOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.purchaseOrderStatusId = _data["purchaseOrderStatusId"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.note = _data["note"];
            if (Array.isArray(_data["purchaseOrderItems"])) {
                this.purchaseOrderItems = [];
                for (let item of _data["purchaseOrderItems"])
                    this.purchaseOrderItems.push(UpdatePurchaseOrderCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["purchaseOrderStatusId"] = this.purchaseOrderStatusId;
        data["deliveryAddress"] = this.deliveryAddress;
        data["relatedStaffId"] = this.relatedStaffId;
        data["note"] = this.note;
        if (Array.isArray(this.purchaseOrderItems)) {
            data["purchaseOrderItems"] = [];
            for (let item of this.purchaseOrderItems)
                data["purchaseOrderItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdatePurchaseOrderCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["description"] = this.description;
        return data;
    }
}
export class CreateProposalCompanyCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalCompanyCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProposalCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.note = _data["note"];
            this.responsibleInfo = _data["responsibleInfo"];
            if (Array.isArray(_data["proposalCompanyPeoples"])) {
                this.proposalCompanyPeoples = [];
                for (let item of _data["proposalCompanyPeoples"])
                    this.proposalCompanyPeoples.push(ProposalCompanyPeopleModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["responsibleInfo"] = this.responsibleInfo;
        if (Array.isArray(this.proposalCompanyPeoples)) {
            data["proposalCompanyPeoples"] = [];
            for (let item of this.proposalCompanyPeoples)
                data["proposalCompanyPeoples"].push(item.toJSON());
        }
        return data;
    }
}
export class ProposalCompanyPeopleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalCompanyPeopleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class DeleteProposalCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProposalCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetProposalCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.note = _data["note"];
            this.responsibleInfo = _data["responsibleInfo"];
            if (Array.isArray(_data["proposalCompanyPeoples"])) {
                this.proposalCompanyPeoples = [];
                for (let item of _data["proposalCompanyPeoples"])
                    this.proposalCompanyPeoples.push(ProposalCompanyPeopleModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProposalCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["responsibleInfo"] = this.responsibleInfo;
        if (Array.isArray(this.proposalCompanyPeoples)) {
            data["proposalCompanyPeoples"] = [];
            for (let item of this.proposalCompanyPeoples)
                data["proposalCompanyPeoples"].push(item.toJSON());
        }
        return data;
    }
}
export class ProposalCompanyPeopleModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.proposalCompanyId = _data["proposalCompanyId"];
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalCompanyPeopleModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proposalCompanyId"] = this.proposalCompanyId;
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class PagedListOfSearchProposalCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchProposalCompanyQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchProposalCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchProposalCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.note = _data["note"];
            this.responsibleInfo = _data["responsibleInfo"];
            this.categoryName = _data["categoryName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProposalCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["responsibleInfo"] = this.responsibleInfo;
        data["categoryName"] = this.categoryName;
        return data;
    }
}
export class UpdateProposalCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.note = _data["note"];
            this.responsibleInfo = _data["responsibleInfo"];
            if (Array.isArray(_data["proposalCompanyPeoples"])) {
                this.proposalCompanyPeoples = [];
                for (let item of _data["proposalCompanyPeoples"])
                    this.proposalCompanyPeoples.push(UpdateProposalCompanyCommandPeople.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposalCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["responsibleInfo"] = this.responsibleInfo;
        if (Array.isArray(this.proposalCompanyPeoples)) {
            data["proposalCompanyPeoples"] = [];
            for (let item of this.proposalCompanyPeoples)
                data["proposalCompanyPeoples"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateProposalCompanyCommandPeople {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposalCompanyCommandPeople();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class ArchivingProjectCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingProjectCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProjectCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProjectCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.projectStateId = _data["projectStateId"];
            this.customerName = _data["customerName"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.address = _data["address"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.auctionDate = _data["auctionDate"] ? new Date(_data["auctionDate"].toString()) : undefined;
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined;
            this.locationDueDate = _data["locationDueDate"] ? new Date(_data["locationDueDate"].toString()) : undefined;
            this.technicalStaffNotificationDate = _data["technicalStaffNotificationDate"] ? new Date(_data["technicalStaffNotificationDate"].toString()) : undefined;
            this.workProgramDueDate = _data["workProgramDueDate"] ? new Date(_data["workProgramDueDate"].toString()) : undefined;
            this.allRiskDueDate = _data["allRiskDueDate"] ? new Date(_data["allRiskDueDate"].toString()) : undefined;
            this.comparison = _data["comparison"] ? new Date(_data["comparison"].toString()) : undefined;
            this.timeOfExtension = _data["timeOfExtension"] ? new Date(_data["timeOfExtension"].toString()) : undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined;
            this.temporaryOfWorkAcceptanceDate = _data["temporaryOfWorkAcceptanceDate"] ? new Date(_data["temporaryOfWorkAcceptanceDate"].toString()) : undefined;
            this.exactOfWorkAcceptanceDate = _data["exactOfWorkAcceptanceDate"] ? new Date(_data["exactOfWorkAcceptanceDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["projectStateId"] = this.projectStateId;
        data["customerName"] = this.customerName;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["address"] = this.address;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["auctionDate"] = this.auctionDate ? this.auctionDate.toISOString() : undefined;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined;
        data["locationDueDate"] = this.locationDueDate ? this.locationDueDate.toISOString() : undefined;
        data["technicalStaffNotificationDate"] = this.technicalStaffNotificationDate ? this.technicalStaffNotificationDate.toISOString() : undefined;
        data["workProgramDueDate"] = this.workProgramDueDate ? this.workProgramDueDate.toISOString() : undefined;
        data["allRiskDueDate"] = this.allRiskDueDate ? this.allRiskDueDate.toISOString() : undefined;
        data["comparison"] = this.comparison ? this.comparison.toISOString() : undefined;
        data["timeOfExtension"] = this.timeOfExtension ? this.timeOfExtension.toISOString() : undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["temporaryOfWorkAcceptanceDate"] = this.temporaryOfWorkAcceptanceDate ? this.temporaryOfWorkAcceptanceDate.toISOString() : undefined;
        data["exactOfWorkAcceptanceDate"] = this.exactOfWorkAcceptanceDate ? this.exactOfWorkAcceptanceDate.toISOString() : undefined;
        return data;
    }
}
export class DeleteProjectCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.remainingDay = _data["remainingDay"];
            this.projectStateId = _data["projectStateId"];
            this.projectStateName = _data["projectStateName"];
            this.customerName = _data["customerName"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.address = _data["address"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.description = _data["description"];
            this.totalSales = _data["totalSales"];
            this.totalSaleBalances = _data["totalSaleBalances"];
            this.totalCollection = _data["totalCollection"];
            this.totalExpenses = _data["totalExpenses"];
            this.totalExpenseBalances = _data["totalExpenseBalances"];
            this.totalPayment = _data["totalPayment"];
            this.totalOnSaleRealEstates = _data["totalOnSaleRealEstates"];
            this.totalSalaries = _data["totalSalaries"];
            if (Array.isArray(_data["realEstates"])) {
                this.realEstates = [];
                for (let item of _data["realEstates"])
                    this.realEstates.push(RealEstateModel.fromJS(item));
            }
            if (Array.isArray(_data["saleInvoices"])) {
                this.saleInvoices = [];
                for (let item of _data["saleInvoices"])
                    this.saleInvoices.push(SaleInvoiceModel.fromJS(item));
            }
            if (Array.isArray(_data["expenseInvoices"])) {
                this.expenseInvoices = [];
                for (let item of _data["expenseInvoices"])
                    this.expenseInvoices.push(ExpenseInvoiceModel.fromJS(item));
            }
            if (Array.isArray(_data["companiesWithExpenseAndSalePrices"])) {
                this.companiesWithExpenseAndSalePrices = [];
                for (let item of _data["companiesWithExpenseAndSalePrices"])
                    this.companiesWithExpenseAndSalePrices.push(CompaniesWithExpenseAndSalePriceModel.fromJS(item));
            }
            if (Array.isArray(_data["staffs"])) {
                this.staffs = [];
                for (let item of _data["staffs"])
                    this.staffs.push(StaffModel.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [];
                for (let item of _data["companies"])
                    this.companies.push(CompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [];
                for (let item of _data["users"])
                    this.users.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["bankCashes"])) {
                this.bankCashes = [];
                for (let item of _data["bankCashes"])
                    this.bankCashes.push(BankCashModel.fromJS(item));
            }
            if (Array.isArray(_data["salaries"])) {
                this.salaries = [];
                for (let item of _data["salaries"])
                    this.salaries.push(SalaryModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlanSales"])) {
                this.paymentPlanSales = [];
                for (let item of _data["paymentPlanSales"])
                    this.paymentPlanSales.push(PaymentPlanModel.fromJS(item));
            }
            this.totalPaymentPlanSale = _data["totalPaymentPlanSale"];
            if (Array.isArray(_data["paymentPlanExpenses"])) {
                this.paymentPlanExpenses = [];
                for (let item of _data["paymentPlanExpenses"])
                    this.paymentPlanExpenses.push(PaymentPlanModel.fromJS(item));
            }
            this.totalPaymentPlanExpense = _data["totalPaymentPlanExpense"];
            this.auctionDate = _data["auctionDate"] ? new Date(_data["auctionDate"].toString()) : undefined;
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined;
            this.locationDueDate = _data["locationDueDate"] ? new Date(_data["locationDueDate"].toString()) : undefined;
            this.technicalStaffNotificationDate = _data["technicalStaffNotificationDate"] ? new Date(_data["technicalStaffNotificationDate"].toString()) : undefined;
            this.workProgramDueDate = _data["workProgramDueDate"] ? new Date(_data["workProgramDueDate"].toString()) : undefined;
            this.allRiskDueDate = _data["allRiskDueDate"] ? new Date(_data["allRiskDueDate"].toString()) : undefined;
            this.comparison = _data["comparison"] ? new Date(_data["comparison"].toString()) : undefined;
            this.timeOfExtension = _data["timeOfExtension"] ? new Date(_data["timeOfExtension"].toString()) : undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined;
            this.temporaryOfWorkAcceptanceDate = _data["temporaryOfWorkAcceptanceDate"] ? new Date(_data["temporaryOfWorkAcceptanceDate"].toString()) : undefined;
            this.exactOfWorkAcceptanceDate = _data["exactOfWorkAcceptanceDate"] ? new Date(_data["exactOfWorkAcceptanceDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["remainingDay"] = this.remainingDay;
        data["projectStateId"] = this.projectStateId;
        data["projectStateName"] = this.projectStateName;
        data["customerName"] = this.customerName;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["address"] = this.address;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["description"] = this.description;
        data["totalSales"] = this.totalSales;
        data["totalSaleBalances"] = this.totalSaleBalances;
        data["totalCollection"] = this.totalCollection;
        data["totalExpenses"] = this.totalExpenses;
        data["totalExpenseBalances"] = this.totalExpenseBalances;
        data["totalPayment"] = this.totalPayment;
        data["totalOnSaleRealEstates"] = this.totalOnSaleRealEstates;
        data["totalSalaries"] = this.totalSalaries;
        if (Array.isArray(this.realEstates)) {
            data["realEstates"] = [];
            for (let item of this.realEstates)
                data["realEstates"].push(item.toJSON());
        }
        if (Array.isArray(this.saleInvoices)) {
            data["saleInvoices"] = [];
            for (let item of this.saleInvoices)
                data["saleInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseInvoices)) {
            data["expenseInvoices"] = [];
            for (let item of this.expenseInvoices)
                data["expenseInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.companiesWithExpenseAndSalePrices)) {
            data["companiesWithExpenseAndSalePrices"] = [];
            for (let item of this.companiesWithExpenseAndSalePrices)
                data["companiesWithExpenseAndSalePrices"].push(item.toJSON());
        }
        if (Array.isArray(this.staffs)) {
            data["staffs"] = [];
            for (let item of this.staffs)
                data["staffs"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.bankCashes)) {
            data["bankCashes"] = [];
            for (let item of this.bankCashes)
                data["bankCashes"].push(item.toJSON());
        }
        if (Array.isArray(this.salaries)) {
            data["salaries"] = [];
            for (let item of this.salaries)
                data["salaries"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlanSales)) {
            data["paymentPlanSales"] = [];
            for (let item of this.paymentPlanSales)
                data["paymentPlanSales"].push(item.toJSON());
        }
        data["totalPaymentPlanSale"] = this.totalPaymentPlanSale;
        if (Array.isArray(this.paymentPlanExpenses)) {
            data["paymentPlanExpenses"] = [];
            for (let item of this.paymentPlanExpenses)
                data["paymentPlanExpenses"].push(item.toJSON());
        }
        data["totalPaymentPlanExpense"] = this.totalPaymentPlanExpense;
        data["auctionDate"] = this.auctionDate ? this.auctionDate.toISOString() : undefined;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined;
        data["locationDueDate"] = this.locationDueDate ? this.locationDueDate.toISOString() : undefined;
        data["technicalStaffNotificationDate"] = this.technicalStaffNotificationDate ? this.technicalStaffNotificationDate.toISOString() : undefined;
        data["workProgramDueDate"] = this.workProgramDueDate ? this.workProgramDueDate.toISOString() : undefined;
        data["allRiskDueDate"] = this.allRiskDueDate ? this.allRiskDueDate.toISOString() : undefined;
        data["comparison"] = this.comparison ? this.comparison.toISOString() : undefined;
        data["timeOfExtension"] = this.timeOfExtension ? this.timeOfExtension.toISOString() : undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["temporaryOfWorkAcceptanceDate"] = this.temporaryOfWorkAcceptanceDate ? this.temporaryOfWorkAcceptanceDate.toISOString() : undefined;
        data["exactOfWorkAcceptanceDate"] = this.exactOfWorkAcceptanceDate ? this.exactOfWorkAcceptanceDate.toISOString() : undefined;
        return data;
    }
}
export class RealEstateModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.estateStateName = _data["estateStateName"];
            this.estateTypeName = _data["estateTypeName"];
            this.grossArea = _data["grossArea"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["baseSalePrice"] = this.baseSalePrice;
        data["estateStateName"] = this.estateStateName;
        data["estateTypeName"] = this.estateTypeName;
        data["grossArea"] = this.grossArea;
        return data;
    }
}
export class SaleInvoiceModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.salePaymentStatusName = _data["salePaymentStatusName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["salePaymentStatusName"] = this.salePaymentStatusName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        return data;
    }
}
export class ExpenseInvoiceModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.expenseTypeId = _data["expenseTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["expenseTypeId"] = this.expenseTypeId;
        return data;
    }
}
export class CompaniesWithExpenseAndSalePriceModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.expenseTotal = _data["expenseTotal"];
            this.expenseBalanceTotal = _data["expenseBalanceTotal"];
            this.saleTotal = _data["saleTotal"];
            this.saleBalanceTotal = _data["saleBalanceTotal"];
            this.totalAdvance = _data["totalAdvance"];
            this.totalCollection = _data["totalCollection"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompaniesWithExpenseAndSalePriceModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["expenseTotal"] = this.expenseTotal;
        data["expenseBalanceTotal"] = this.expenseBalanceTotal;
        data["saleTotal"] = this.saleTotal;
        data["saleBalanceTotal"] = this.saleBalanceTotal;
        data["totalAdvance"] = this.totalAdvance;
        data["totalCollection"] = this.totalCollection;
        return data;
    }
}
export class StaffModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        return data;
    }
}
export class CompanyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class UserModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class BankCashModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.balance = _data["balance"];
            this.currencyName = _data["currencyName"];
            this.currencyCode = _data["currencyCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BankCashModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["balance"] = this.balance;
        data["currencyName"] = this.currencyName;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}
export class SalaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.payment = _data["payment"];
            this.balance = _data["balance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["payment"] = this.payment;
        data["balance"] = this.balance;
        return data;
    }
}
export class PaymentPlanModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchProjectQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchProjectQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.remainingDay = _data["remainingDay"];
            this.projectStateName = _data["projectStateName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProjectQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["remainingDay"] = this.remainingDay;
        data["projectStateName"] = this.projectStateName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateProjectCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.projectStateId = _data["projectStateId"];
            this.customerName = _data["customerName"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.address = _data["address"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.description = _data["description"];
            this.auctionDate = _data["auctionDate"] ? new Date(_data["auctionDate"].toString()) : undefined;
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined;
            this.locationDueDate = _data["locationDueDate"] ? new Date(_data["locationDueDate"].toString()) : undefined;
            this.technicalStaffNotificationDate = _data["technicalStaffNotificationDate"] ? new Date(_data["technicalStaffNotificationDate"].toString()) : undefined;
            this.workProgramDueDate = _data["workProgramDueDate"] ? new Date(_data["workProgramDueDate"].toString()) : undefined;
            this.allRiskDueDate = _data["allRiskDueDate"] ? new Date(_data["allRiskDueDate"].toString()) : undefined;
            this.comparison = _data["comparison"] ? new Date(_data["comparison"].toString()) : undefined;
            this.timeOfExtension = _data["timeOfExtension"] ? new Date(_data["timeOfExtension"].toString()) : undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined;
            this.temporaryOfWorkAcceptanceDate = _data["temporaryOfWorkAcceptanceDate"] ? new Date(_data["temporaryOfWorkAcceptanceDate"].toString()) : undefined;
            this.exactOfWorkAcceptanceDate = _data["exactOfWorkAcceptanceDate"] ? new Date(_data["exactOfWorkAcceptanceDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["projectStateId"] = this.projectStateId;
        data["customerName"] = this.customerName;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["address"] = this.address;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["description"] = this.description;
        data["auctionDate"] = this.auctionDate ? this.auctionDate.toISOString() : undefined;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined;
        data["locationDueDate"] = this.locationDueDate ? this.locationDueDate.toISOString() : undefined;
        data["technicalStaffNotificationDate"] = this.technicalStaffNotificationDate ? this.technicalStaffNotificationDate.toISOString() : undefined;
        data["workProgramDueDate"] = this.workProgramDueDate ? this.workProgramDueDate.toISOString() : undefined;
        data["allRiskDueDate"] = this.allRiskDueDate ? this.allRiskDueDate.toISOString() : undefined;
        data["comparison"] = this.comparison ? this.comparison.toISOString() : undefined;
        data["timeOfExtension"] = this.timeOfExtension ? this.timeOfExtension.toISOString() : undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["temporaryOfWorkAcceptanceDate"] = this.temporaryOfWorkAcceptanceDate ? this.temporaryOfWorkAcceptanceDate.toISOString() : undefined;
        data["exactOfWorkAcceptanceDate"] = this.exactOfWorkAcceptanceDate ? this.exactOfWorkAcceptanceDate.toISOString() : undefined;
        return data;
    }
}
export class CreatePlotCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlotCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePlotCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockId = _data["blockId"];
            this.buildingBlockTypeId = _data["buildingBlockTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basementHeight = _data["basementHeight"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlotCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockId"] = this.blockId;
        data["buildingBlockTypeId"] = this.buildingBlockTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basementHeight"] = this.basementHeight;
        return data;
    }
}
export class DeletePlotCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlotCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetPlotQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.blockId = _data["blockId"];
            this.blockName = _data["blockName"];
            this.buildingBlockTypeId = _data["buildingBlockTypeId"];
            this.buildingBlockTypeName = _data["buildingBlockTypeName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basementHeight = _data["basementHeight"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlotQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        data["blockId"] = this.blockId;
        data["blockName"] = this.blockName;
        data["buildingBlockTypeId"] = this.buildingBlockTypeId;
        data["buildingBlockTypeName"] = this.buildingBlockTypeName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basementHeight"] = this.basementHeight;
        return data;
    }
}
export class PagedListOfSearchPlotQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPlotQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPlotQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPlotQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.blockId = _data["blockId"];
            this.blockName = _data["blockName"];
            this.buildingBlockTypeId = _data["buildingBlockTypeId"];
            this.buildingBlockTypeName = _data["buildingBlockTypeName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basementHeight = _data["basementHeight"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPlotQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        data["blockId"] = this.blockId;
        data["blockName"] = this.blockName;
        data["buildingBlockTypeId"] = this.buildingBlockTypeId;
        data["buildingBlockTypeName"] = this.buildingBlockTypeName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basementHeight"] = this.basementHeight;
        return data;
    }
}
export class UpdatePlotCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockId = _data["blockId"];
            this.buildingBlockTypeId = _data["buildingBlockTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basementHeight = _data["basementHeight"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlotCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockId"] = this.blockId;
        data["buildingBlockTypeId"] = this.buildingBlockTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basementHeight"] = this.basementHeight;
        return data;
    }
}
export class CreateContractCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateContractCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStateId = _data["contractStateId"];
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.duration = _data["duration"];
            this.importantItem = _data["importantItem"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStateId"] = this.contractStateId;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["duration"] = this.duration;
        data["importantItem"] = this.importantItem;
        data["relatedStaffId"] = this.relatedStaffId;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class DeleteContractCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteContractCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetContractQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.contractTypeName = _data["contractTypeName"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStateName = _data["contractStateName"];
            this.contractStateId = _data["contractStateId"];
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.duration = _data["duration"];
            this.importantItem = _data["importantItem"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["contractTypeName"] = this.contractTypeName;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStateName"] = this.contractStateName;
        data["contractStateId"] = this.contractStateId;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["duration"] = this.duration;
        data["importantItem"] = this.importantItem;
        data["relatedStaffName"] = this.relatedStaffName;
        data["relatedStaffId"] = this.relatedStaffId;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class PagedListOfSearchContractQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchContractQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchContractQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchContractQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.contractTypeName = _data["contractTypeName"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStateName = _data["contractStateName"];
            this.contractStateId = _data["contractStateId"];
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.duration = _data["duration"];
            this.importantItem = _data["importantItem"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchContractQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["contractTypeName"] = this.contractTypeName;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStateName"] = this.contractStateName;
        data["contractStateId"] = this.contractStateId;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["duration"] = this.duration;
        data["importantItem"] = this.importantItem;
        data["relatedStaffName"] = this.relatedStaffName;
        data["relatedStaffId"] = this.relatedStaffId;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class UpdateContractCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStateId = _data["contractStateId"];
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.duration = _data["duration"];
            this.importantItem = _data["importantItem"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStateId"] = this.contractStateId;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["duration"] = this.duration;
        data["importantItem"] = this.importantItem;
        data["relatedStaffId"] = this.relatedStaffId;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class CreateConstructionSiteCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionSiteCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateConstructionSiteCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.description = _data["description"];
            this.totalWork = _data["totalWork"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionSiteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["description"] = this.description;
        data["totalWork"] = this.totalWork;
        return data;
    }
}
export class DeleteConstructionSiteCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteConstructionSiteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetConstructionSiteAnalysisQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectStartDate = _data["projectStartDate"] ? new Date(_data["projectStartDate"].toString()) : undefined;
            this.projectEndDate = _data["projectEndDate"] ? new Date(_data["projectEndDate"].toString()) : undefined;
            this.totalDays = _data["totalDays"];
            this.elapsedDays = _data["elapsedDays"];
            this.remainingDays = _data["remainingDays"];
            this.totalWork = _data["totalWork"];
            this.dailyPlannedWork = _data["dailyPlannedWork"];
            this.plannedCompletedWork = _data["plannedCompletedWork"];
            this.actualCompletedWork = _data["actualCompletedWork"];
            this.workDifference = _data["workDifference"];
            this.overallCompletionRate = _data["overallCompletionRate"];
            this.daysBehindOrAhead = _data["daysBehindOrAhead"];
            this.scheduleStatus = _data["scheduleStatus"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [];
                for (let item of _data["tasks"])
                    this.tasks.push(ConstructionSiteTaskAnalysisItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionSiteAnalysisQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : undefined;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toISOString() : undefined;
        data["totalDays"] = this.totalDays;
        data["elapsedDays"] = this.elapsedDays;
        data["remainingDays"] = this.remainingDays;
        data["totalWork"] = this.totalWork;
        data["dailyPlannedWork"] = this.dailyPlannedWork;
        data["plannedCompletedWork"] = this.plannedCompletedWork;
        data["actualCompletedWork"] = this.actualCompletedWork;
        data["workDifference"] = this.workDifference;
        data["overallCompletionRate"] = this.overallCompletionRate;
        data["daysBehindOrAhead"] = this.daysBehindOrAhead;
        data["scheduleStatus"] = this.scheduleStatus;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}
export class ConstructionSiteTaskAnalysisItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalWork = _data["totalWork"];
            this.completionRate = _data["completionRate"];
            this.completedWork = _data["completedWork"];
            this.remainingWork = _data["remainingWork"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.taskStateName = _data["taskStateName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionSiteTaskAnalysisItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalWork"] = this.totalWork;
        data["completionRate"] = this.completionRate;
        data["completedWork"] = this.completedWork;
        data["remainingWork"] = this.remainingWork;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["taskStateName"] = this.taskStateName;
        return data;
    }
}
export class GetConstructionSiteQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
            this.description = _data["description"];
            this.totalWork = _data["totalWork"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionSiteQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["address"] = this.address;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        data["description"] = this.description;
        data["totalWork"] = this.totalWork;
        return data;
    }
}
export class PagedListOfSearchConstructionSiteQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchConstructionSiteQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchConstructionSiteQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchConstructionSiteQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
            this.description = _data["description"];
            this.totalWork = _data["totalWork"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConstructionSiteQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["address"] = this.address;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        data["description"] = this.description;
        data["totalWork"] = this.totalWork;
        return data;
    }
}
export class UpdateConstructionSiteCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.description = _data["description"];
            this.totalWork = _data["totalWork"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionSiteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["description"] = this.description;
        data["totalWork"] = this.totalWork;
        return data;
    }
}
export class CreateBuildingBlockTypeCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuildingBlockTypeCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBuildingBlockTypeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuildingBlockTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class DeleteBuildingBlockTypeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBuildingBlockTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetBuildingBlockTypeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingBlockTypeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class PagedListOfSearchBuildingBlockTypeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchBuildingBlockTypeQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchBuildingBlockTypeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchBuildingBlockTypeQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBuildingBlockTypeQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class UpdateBuildingBlockTypeCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBuildingBlockTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class CreateBlockCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBlockCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBlockCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.constructionSiteId = _data["constructionSiteId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBlockCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["constructionSiteId"] = this.constructionSiteId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class DeleteBlockCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBlockCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetBlockQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class PagedListOfSearchBlockQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchBlockQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchBlockQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchBlockQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBlockQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constructionSiteId"] = this.constructionSiteId;
        data["constructionSiteName"] = this.constructionSiteName;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class UpdateBlockCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBlockCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constructionSiteId"] = this.constructionSiteId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
export class CheckActivityReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckActivityReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CheckActivityReportQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.activityReportTypeId = _data["activityReportTypeId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckActivityReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["activityReportTypeId"] = this.activityReportTypeId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        return data;
    }
}
export class CreateActivityReportCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateActivityReportCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.activityReportTypeId = _data["activityReportTypeId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.weatherCondition = _data["weatherCondition"];
            this.workProgress = _data["workProgress"];
            this.lostWorkingHour = _data["lostWorkingHour"];
            this.workmanTimesheet = _data["workmanTimesheet"];
            this.subcontractors = _data["subcontractors"];
            this.machineryEquipment = _data["machineryEquipment"];
            this.aheadMilestones = _data["aheadMilestones"];
            this.hseLogs = _data["hseLogs"];
            this.qaqcLogs = _data["qaqcLogs"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.incomingMaterial = _data["incomingMaterial"];
            this.activityReportStateId = _data["activityReportStateId"];
            this.isRiskPrecaution = _data["isRiskPrecaution"];
            this.riskPrecaution = _data["riskPrecaution"];
            if (Array.isArray(_data["activityReportWorks"])) {
                this.activityReportWorks = [];
                for (let item of _data["activityReportWorks"])
                    this.activityReportWorks.push(CreateActivityReportCommandWork.fromJS(item));
            }
            if (Array.isArray(_data["activityReportTimeKeepings"])) {
                this.activityReportTimeKeepings = [];
                for (let item of _data["activityReportTimeKeepings"])
                    this.activityReportTimeKeepings.push(CreateActivityReportCommandTimeKeeping.fromJS(item));
            }
            if (Array.isArray(_data["activityReportProducts"])) {
                this.activityReportProducts = [];
                for (let item of _data["activityReportProducts"])
                    this.activityReportProducts.push(CreateActivityReportCommandProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["activityReportTypeId"] = this.activityReportTypeId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["weatherCondition"] = this.weatherCondition;
        data["workProgress"] = this.workProgress;
        data["lostWorkingHour"] = this.lostWorkingHour;
        data["workmanTimesheet"] = this.workmanTimesheet;
        data["subcontractors"] = this.subcontractors;
        data["machineryEquipment"] = this.machineryEquipment;
        data["aheadMilestones"] = this.aheadMilestones;
        data["hseLogs"] = this.hseLogs;
        data["qaqcLogs"] = this.qaqcLogs;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["incomingMaterial"] = this.incomingMaterial;
        data["activityReportStateId"] = this.activityReportStateId;
        data["isRiskPrecaution"] = this.isRiskPrecaution;
        data["riskPrecaution"] = this.riskPrecaution;
        if (Array.isArray(this.activityReportWorks)) {
            data["activityReportWorks"] = [];
            for (let item of this.activityReportWorks)
                data["activityReportWorks"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportTimeKeepings)) {
            data["activityReportTimeKeepings"] = [];
            for (let item of this.activityReportTimeKeepings)
                data["activityReportTimeKeepings"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportProducts)) {
            data["activityReportProducts"] = [];
            for (let item of this.activityReportProducts)
                data["activityReportProducts"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateActivityReportCommandWork {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.plotId = _data["plotId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportCommandWork();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["plotId"] = this.plotId;
        data["description"] = this.description;
        return data;
    }
}
export class CreateActivityReportCommandTimeKeeping {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.timeKeepingTemplateId = _data["timeKeepingTemplateId"];
            this.employeeCount = _data["employeeCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportCommandTimeKeeping();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timeKeepingTemplateId"] = this.timeKeepingTemplateId;
        data["employeeCount"] = this.employeeCount;
        return data;
    }
}
export class CreateActivityReportCommandProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportCommandProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}
export class GetActivityReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.activityReportTypeId = _data["activityReportTypeId"];
            this.activityReportTypeName = _data["activityReportTypeName"];
            this.activityReportStateId = _data["activityReportStateId"];
            this.activityReportStateName = _data["activityReportStateName"];
            this.isRiskPrecaution = _data["isRiskPrecaution"];
            this.riskPrecaution = _data["riskPrecaution"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.weatherCondition = _data["weatherCondition"];
            this.workProgress = _data["workProgress"];
            this.lostWorkingHour = _data["lostWorkingHour"];
            this.workmanTimesheet = _data["workmanTimesheet"];
            this.subcontractors = _data["subcontractors"];
            this.machineryEquipment = _data["machineryEquipment"];
            this.aheadMilestones = _data["aheadMilestones"];
            this.hseLogs = _data["hseLogs"];
            this.qaqcLogs = _data["qaqcLogs"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.incomingMaterial = _data["incomingMaterial"];
            this.totalContractorCount = _data["totalContractorCount"];
            this.totalSubcontractorCount = _data["totalSubcontractorCount"];
            if (Array.isArray(_data["activityReportWorks"])) {
                this.activityReportWorks = [];
                for (let item of _data["activityReportWorks"])
                    this.activityReportWorks.push(GetActivityReportQueryResponseWork.fromJS(item));
            }
            if (Array.isArray(_data["activityReportTimeKeepings"])) {
                this.activityReportTimeKeepings = [];
                for (let item of _data["activityReportTimeKeepings"])
                    this.activityReportTimeKeepings.push(GetActivityReportQueryResponseTimeKeeping.fromJS(item));
            }
            if (Array.isArray(_data["activityReportProducts"])) {
                this.activityReportProducts = [];
                for (let item of _data["activityReportProducts"])
                    this.activityReportProducts.push(GetActivityReportQueryResponseProduct.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["activityReportTypeId"] = this.activityReportTypeId;
        data["activityReportTypeName"] = this.activityReportTypeName;
        data["activityReportStateId"] = this.activityReportStateId;
        data["activityReportStateName"] = this.activityReportStateName;
        data["isRiskPrecaution"] = this.isRiskPrecaution;
        data["riskPrecaution"] = this.riskPrecaution;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["weatherCondition"] = this.weatherCondition;
        data["workProgress"] = this.workProgress;
        data["lostWorkingHour"] = this.lostWorkingHour;
        data["workmanTimesheet"] = this.workmanTimesheet;
        data["subcontractors"] = this.subcontractors;
        data["machineryEquipment"] = this.machineryEquipment;
        data["aheadMilestones"] = this.aheadMilestones;
        data["hseLogs"] = this.hseLogs;
        data["qaqcLogs"] = this.qaqcLogs;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["incomingMaterial"] = this.incomingMaterial;
        data["totalContractorCount"] = this.totalContractorCount;
        data["totalSubcontractorCount"] = this.totalSubcontractorCount;
        if (Array.isArray(this.activityReportWorks)) {
            data["activityReportWorks"] = [];
            for (let item of this.activityReportWorks)
                data["activityReportWorks"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportTimeKeepings)) {
            data["activityReportTimeKeepings"] = [];
            for (let item of this.activityReportTimeKeepings)
                data["activityReportTimeKeepings"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportProducts)) {
            data["activityReportProducts"] = [];
            for (let item of this.activityReportProducts)
                data["activityReportProducts"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetActivityReportQueryResponseWork {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityReportId = _data["activityReportId"];
            this.activityReportName = _data["activityReportName"];
            this.constructionId = _data["constructionId"];
            this.constructionName = _data["constructionName"];
            this.blockId = _data["blockId"];
            this.blockName = _data["blockName"];
            this.plotId = _data["plotId"];
            this.plotName = _data["plotName"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityReportQueryResponseWork();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityReportId"] = this.activityReportId;
        data["activityReportName"] = this.activityReportName;
        data["constructionId"] = this.constructionId;
        data["constructionName"] = this.constructionName;
        data["blockId"] = this.blockId;
        data["blockName"] = this.blockName;
        data["plotId"] = this.plotId;
        data["plotName"] = this.plotName;
        data["description"] = this.description;
        return data;
    }
}
export class GetActivityReportQueryResponseTimeKeeping {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityReportId = _data["activityReportId"];
            this.activityReportName = _data["activityReportName"];
            this.timeKeepingTemplateId = _data["timeKeepingTemplateId"];
            this.timeKeepingTemplateName = _data["timeKeepingTemplateName"];
            this.timeKeepingTemplateTypeId = _data["timeKeepingTemplateTypeId"];
            this.timeKeepingTemplateTypeName = _data["timeKeepingTemplateTypeName"];
            this.employeeCount = _data["employeeCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityReportQueryResponseTimeKeeping();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityReportId"] = this.activityReportId;
        data["activityReportName"] = this.activityReportName;
        data["timeKeepingTemplateId"] = this.timeKeepingTemplateId;
        data["timeKeepingTemplateName"] = this.timeKeepingTemplateName;
        data["timeKeepingTemplateTypeId"] = this.timeKeepingTemplateTypeId;
        data["timeKeepingTemplateTypeName"] = this.timeKeepingTemplateTypeName;
        data["employeeCount"] = this.employeeCount;
        return data;
    }
}
export class GetActivityReportQueryResponseProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityReportId = _data["activityReportId"];
            this.activityReportName = _data["activityReportName"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityReportQueryResponseProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityReportId"] = this.activityReportId;
        data["activityReportName"] = this.activityReportName;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}
export class GetAllTimeKeepingTemplateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.timeKeepingTypeId = _data["timeKeepingTypeId"];
            this.timeKeepingTypeName = _data["timeKeepingTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTimeKeepingTemplateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["timeKeepingTypeId"] = this.timeKeepingTypeId;
        data["timeKeepingTypeName"] = this.timeKeepingTypeName;
        return data;
    }
}
export class GetAllTimeKeepingTemplateQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTimeKeepingTemplateQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}
export class GetProjectInfoQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            if (Array.isArray(_data["activityReportWorks"])) {
                this.activityReportWorks = [];
                for (let item of _data["activityReportWorks"])
                    this.activityReportWorks.push(GetProjectInfoQueryResponseWork.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectInfoQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        if (Array.isArray(this.activityReportWorks)) {
            data["activityReportWorks"] = [];
            for (let item of this.activityReportWorks)
                data["activityReportWorks"].push(item.toJSON());
        }
        return data;
    }
}
export class GetProjectInfoQueryResponseWork {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.constructionId = _data["constructionId"];
            this.constructionName = _data["constructionName"];
            this.blockId = _data["blockId"];
            this.blockName = _data["blockName"];
            this.plotId = _data["plotId"];
            this.plotName = _data["plotName"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectInfoQueryResponseWork();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["constructionId"] = this.constructionId;
        data["constructionName"] = this.constructionName;
        data["blockId"] = this.blockId;
        data["blockName"] = this.blockName;
        data["plotId"] = this.plotId;
        data["plotName"] = this.plotName;
        data["description"] = this.description;
        return data;
    }
}
export class GetProjectInfoQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectInfoQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["reportDate"] = this.reportDate ? this.reportDate.toISOString() : undefined;
        return data;
    }
}
export class ReleaseActivityReportCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseActivityReportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedListOfSearchActivityReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchActivityReportQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchActivityReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchActivityReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityReportName = _data["activityReportName"];
            this.activityReportTypeName = _data["activityReportTypeName"];
            this.activityReportStateName = _data["activityReportStateName"];
            this.projectName = _data["projectName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchActivityReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityReportName"] = this.activityReportName;
        data["activityReportTypeName"] = this.activityReportTypeName;
        data["activityReportStateName"] = this.activityReportStateName;
        data["projectName"] = this.projectName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateActivityReportCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.activityReportTypeId = _data["activityReportTypeId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.weatherCondition = _data["weatherCondition"];
            this.workProgress = _data["workProgress"];
            this.lostWorkingHour = _data["lostWorkingHour"];
            this.workmanTimesheet = _data["workmanTimesheet"];
            this.subcontractors = _data["subcontractors"];
            this.machineryEquipment = _data["machineryEquipment"];
            this.aheadMilestones = _data["aheadMilestones"];
            this.hseLogs = _data["hseLogs"];
            this.qaqcLogs = _data["qaqcLogs"];
            this.projectLeader = _data["projectLeader"];
            this.technicalOfficeChief = _data["technicalOfficeChief"];
            this.siteResponsibility = _data["siteResponsibility"];
            this.incomingMaterial = _data["incomingMaterial"];
            this.activityReportStateId = _data["activityReportStateId"];
            this.isRiskPrecaution = _data["isRiskPrecaution"];
            this.riskPrecaution = _data["riskPrecaution"];
            if (Array.isArray(_data["activityReportWorks"])) {
                this.activityReportWorks = [];
                for (let item of _data["activityReportWorks"])
                    this.activityReportWorks.push(UpdateActivityReportCommandWork.fromJS(item));
            }
            if (Array.isArray(_data["activityReportTimeKeepings"])) {
                this.activityReportTimeKeepings = [];
                for (let item of _data["activityReportTimeKeepings"])
                    this.activityReportTimeKeepings.push(UpdateActivityReportCommandTimeKeeping.fromJS(item));
            }
            if (Array.isArray(_data["activityReportProducts"])) {
                this.activityReportProducts = [];
                for (let item of _data["activityReportProducts"])
                    this.activityReportProducts.push(UpdateActivityReportCommandProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityReportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["activityReportTypeId"] = this.activityReportTypeId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["weatherCondition"] = this.weatherCondition;
        data["workProgress"] = this.workProgress;
        data["lostWorkingHour"] = this.lostWorkingHour;
        data["workmanTimesheet"] = this.workmanTimesheet;
        data["subcontractors"] = this.subcontractors;
        data["machineryEquipment"] = this.machineryEquipment;
        data["aheadMilestones"] = this.aheadMilestones;
        data["hseLogs"] = this.hseLogs;
        data["qaqcLogs"] = this.qaqcLogs;
        data["projectLeader"] = this.projectLeader;
        data["technicalOfficeChief"] = this.technicalOfficeChief;
        data["siteResponsibility"] = this.siteResponsibility;
        data["incomingMaterial"] = this.incomingMaterial;
        data["activityReportStateId"] = this.activityReportStateId;
        data["isRiskPrecaution"] = this.isRiskPrecaution;
        data["riskPrecaution"] = this.riskPrecaution;
        if (Array.isArray(this.activityReportWorks)) {
            data["activityReportWorks"] = [];
            for (let item of this.activityReportWorks)
                data["activityReportWorks"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportTimeKeepings)) {
            data["activityReportTimeKeepings"] = [];
            for (let item of this.activityReportTimeKeepings)
                data["activityReportTimeKeepings"].push(item.toJSON());
        }
        if (Array.isArray(this.activityReportProducts)) {
            data["activityReportProducts"] = [];
            for (let item of this.activityReportProducts)
                data["activityReportProducts"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateActivityReportCommandWork {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.plotId = _data["plotId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityReportCommandWork();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plotId"] = this.plotId;
        data["description"] = this.description;
        return data;
    }
}
export class UpdateActivityReportCommandTimeKeeping {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.timeKeepingTemplateId = _data["timeKeepingTemplateId"];
            this.employeeCount = _data["employeeCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityReportCommandTimeKeeping();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeKeepingTemplateId"] = this.timeKeepingTemplateId;
        data["employeeCount"] = this.employeeCount;
        return data;
    }
}
export class UpdateActivityReportCommandProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityReportCommandProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}
export class DeleteOutgoingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOutgoingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetOutgoingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentDistrictName = _data["shipmentDistrictName"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.shipmentProvinceName = _data["shipmentProvinceName"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitDistrictName = _data["exitDistrictName"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.exitProvinceName = _data["exitProvinceName"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.shipmentTypeName = _data["shipmentTypeName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["outgoingWaybillItems"])) {
                this.outgoingWaybillItems = [];
                for (let item of _data["outgoingWaybillItems"])
                    this.outgoingWaybillItems.push(OutgoingWaybillItemModel.fromJS(item));
            }
            if (Array.isArray(_data["saleInvoices"])) {
                this.saleInvoices = [];
                for (let item of _data["saleInvoices"])
                    this.saleInvoices.push(SaleInvoiceModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutgoingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentDistrictName"] = this.shipmentDistrictName;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["shipmentProvinceName"] = this.shipmentProvinceName;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitDistrictName"] = this.exitDistrictName;
        data["exitProvinceId"] = this.exitProvinceId;
        data["exitProvinceName"] = this.exitProvinceName;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["shipmentTypeName"] = this.shipmentTypeName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.outgoingWaybillItems)) {
            data["outgoingWaybillItems"] = [];
            for (let item of this.outgoingWaybillItems)
                data["outgoingWaybillItems"].push(item.toJSON());
        }
        if (Array.isArray(this.saleInvoices)) {
            data["saleInvoices"] = [];
            for (let item of this.saleInvoices)
                data["saleInvoices"].push(item.toJSON());
        }
        return data;
    }
}
export class OutgoingWaybillItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingWaybillItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        return data;
    }
}
export class SaleInvoiceModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.saleInvoiceName = _data["saleInvoiceName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleInvoiceName"] = this.saleInvoiceName;
        return data;
    }
}
export class PagedListOfSearchOutgoingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchOutgoingWaybillQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchOutgoingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchOutgoingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.waybillNumber = _data["waybillNumber"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOutgoingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["waybillNumber"] = this.waybillNumber;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateOutgoingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            if (Array.isArray(_data["outgoingWaybillItems"])) {
                this.outgoingWaybillItems = [];
                for (let item of _data["outgoingWaybillItems"])
                    this.outgoingWaybillItems.push(UpdateOutgoingWaybillCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOutgoingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitProvinceId"] = this.exitProvinceId;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        if (Array.isArray(this.outgoingWaybillItems)) {
            data["outgoingWaybillItems"] = [];
            for (let item of this.outgoingWaybillItems)
                data["outgoingWaybillItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateOutgoingWaybillCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOutgoingWaybillCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        return data;
    }
}
export class DeleteIncomingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIncomingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetIncomingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentDistrictName = _data["shipmentDistrictName"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.shipmentProvinceName = _data["shipmentProvinceName"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitDistrictName = _data["exitDistrictName"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.exitProvinceName = _data["exitProvinceName"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.shipmentTypeName = _data["shipmentTypeName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["incomingWaybillItems"])) {
                this.incomingWaybillItems = [];
                for (let item of _data["incomingWaybillItems"])
                    this.incomingWaybillItems.push(IncomingWaybillItemModel.fromJS(item));
            }
            if (Array.isArray(_data["expenseInvoices"])) {
                this.expenseInvoices = [];
                for (let item of _data["expenseInvoices"])
                    this.expenseInvoices.push(ExpenseInvoiceModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentDistrictName"] = this.shipmentDistrictName;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["shipmentProvinceName"] = this.shipmentProvinceName;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitDistrictName"] = this.exitDistrictName;
        data["exitProvinceId"] = this.exitProvinceId;
        data["exitProvinceName"] = this.exitProvinceName;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["shipmentTypeName"] = this.shipmentTypeName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.incomingWaybillItems)) {
            data["incomingWaybillItems"] = [];
            for (let item of this.incomingWaybillItems)
                data["incomingWaybillItems"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseInvoices)) {
            data["expenseInvoices"] = [];
            for (let item of this.expenseInvoices)
                data["expenseInvoices"].push(item.toJSON());
        }
        return data;
    }
}
export class IncomingWaybillItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingWaybillItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        return data;
    }
}
export class ExpenseInvoiceModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        return data;
    }
}
export class PagedListOfSearchIncomingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchIncomingWaybillQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchIncomingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchIncomingWaybillQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.waybillNumber = _data["waybillNumber"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchIncomingWaybillQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["waybillNumber"] = this.waybillNumber;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateIncomingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            if (Array.isArray(_data["incomingWaybillItems"])) {
                this.incomingWaybillItems = [];
                for (let item of _data["incomingWaybillItems"])
                    this.incomingWaybillItems.push(UpdateIncomingWaybillCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncomingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitProvinceId"] = this.exitProvinceId;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        if (Array.isArray(this.incomingWaybillItems)) {
            data["incomingWaybillItems"] = [];
            for (let item of this.incomingWaybillItems)
                data["incomingWaybillItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateIncomingWaybillCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncomingWaybillCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        return data;
    }
}
export class ArchivingWarehouseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingWarehouseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateWarehouseCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateWarehouseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.projectId = _data["projectId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["projectId"] = this.projectId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        return data;
    }
}
export class DefaultWarehouseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultWarehouseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DeleteWarehouseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWarehouseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetWarehouseQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.isDefaultWareHouse = _data["isDefaultWareHouse"];
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [];
                for (let item of _data["stocks"])
                    this.stocks.push(StockModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["isDefaultWareHouse"] = this.isDefaultWareHouse;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        return data;
    }
}
export class Product extends BaseEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.productUnit = _data["productUnit"] ? ProductUnit.fromJS(_data["productUnit"]) : undefined;
            this.productUnitId = _data["productUnitId"];
            this.isFollowStock = _data["isFollowStock"];
            this.isRealEstate = _data["isRealEstate"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : undefined;
            this.taxId = _data["taxId"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.isTotalStockAlarm = _data["isTotalStockAlarm"];
            this.totalStockAlarmCount = _data["totalStockAlarmCount"];
            this.isArchived = _data["isArchived"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined;
            this.archivedBy = _data["archivedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined;
            this.deletedBy = _data["deletedBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["productUnit"] = this.productUnit ? this.productUnit.toJSON() : undefined;
        data["productUnitId"] = this.productUnitId;
        data["isFollowStock"] = this.isFollowStock;
        data["isRealEstate"] = this.isRealEstate;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["tax"] = this.tax ? this.tax.toJSON() : undefined;
        data["taxId"] = this.taxId;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["isTotalStockAlarm"] = this.isTotalStockAlarm;
        data["totalStockAlarmCount"] = this.totalStockAlarmCount;
        data["isArchived"] = this.isArchived;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined;
        data["archivedBy"] = this.archivedBy;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined;
        data["deletedBy"] = this.deletedBy;
        super.toJSON(data);
        return data;
    }
}
export class ProductUnit extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.unitCode = _data["unitCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUnit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        super.toJSON(data);
        return data;
    }
}
export class Tax extends LookupEntity {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        super.toJSON(data);
        return data;
    }
}
export class StockModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.stockProcessTypeName = _data["stockProcessTypeName"];
            this.stockTypeName = _data["stockTypeName"];
            this.processDate = _data["processDate"] ? new Date(_data["processDate"].toString()) : undefined;
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StockModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["stockProcessTypeName"] = this.stockProcessTypeName;
        data["stockTypeName"] = this.stockTypeName;
        data["processDate"] = this.processDate ? this.processDate.toISOString() : undefined;
        data["amount"] = this.amount;
        return data;
    }
}
export class PagedListOfSearchWarehouseQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchWarehouseQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchWarehouseQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchWarehouseQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.districtName = _data["districtName"];
            this.provinceName = _data["provinceName"];
            this.isDefaultWareHouse = _data["isDefaultWareHouse"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWarehouseQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["districtName"] = this.districtName;
        data["provinceName"] = this.provinceName;
        data["isDefaultWareHouse"] = this.isDefaultWareHouse;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateWarehouseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        return data;
    }
}
export class CreateWarehouseTransferCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseTransferCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateWarehouseTransferCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.departureWarehouseId = _data["departureWarehouseId"];
            this.entryWarehouseId = _data["entryWarehouseId"];
            this.deliveryPerson = _data["deliveryPerson"];
            this.receiverPerson = _data["receiverPerson"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            if (Array.isArray(_data["warehouseTransferItems"])) {
                this.warehouseTransferItems = [];
                for (let item of _data["warehouseTransferItems"])
                    this.warehouseTransferItems.push(CreateWarehouseTransferCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseTransferCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["departureWarehouseId"] = this.departureWarehouseId;
        data["entryWarehouseId"] = this.entryWarehouseId;
        data["deliveryPerson"] = this.deliveryPerson;
        data["receiverPerson"] = this.receiverPerson;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        if (Array.isArray(this.warehouseTransferItems)) {
            data["warehouseTransferItems"] = [];
            for (let item of this.warehouseTransferItems)
                data["warehouseTransferItems"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateWarehouseTransferCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseTransferCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        return data;
    }
}
export class DeleteWarehouseTransferCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWarehouseTransferCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetWarehouseTransferQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.departureWarehouseId = _data["departureWarehouseId"];
            this.departureWarehouseName = _data["departureWarehouseName"];
            this.entryWarehouseId = _data["entryWarehouseId"];
            this.entryWarehouseName = _data["entryWarehouseName"];
            this.deliveryPerson = _data["deliveryPerson"];
            this.receiverPerson = _data["receiverPerson"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["warehouseTransferItems"])) {
                this.warehouseTransferItems = [];
                for (let item of _data["warehouseTransferItems"])
                    this.warehouseTransferItems.push(GetWarehouseTransferQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseTransferQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["departureWarehouseId"] = this.departureWarehouseId;
        data["departureWarehouseName"] = this.departureWarehouseName;
        data["entryWarehouseId"] = this.entryWarehouseId;
        data["entryWarehouseName"] = this.entryWarehouseName;
        data["deliveryPerson"] = this.deliveryPerson;
        data["receiverPerson"] = this.receiverPerson;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.warehouseTransferItems)) {
            data["warehouseTransferItems"] = [];
            for (let item of this.warehouseTransferItems)
                data["warehouseTransferItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetWarehouseTransferQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseTransferQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        return data;
    }
}
export class PagedListOfSearchWarehouseTransferQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchWarehouseTransferQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchWarehouseTransferQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchWarehouseTransferQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.departureWarehouseName = _data["departureWarehouseName"];
            this.entryWarehouseName = _data["entryWarehouseName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWarehouseTransferQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["departureWarehouseName"] = this.departureWarehouseName;
        data["entryWarehouseName"] = this.entryWarehouseName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class CreateIncomingWaybillCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncomingWaybillCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateIncomingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.projectId = _data["projectId"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            if (Array.isArray(_data["incomingWaybillItems"])) {
                this.incomingWaybillItems = [];
                for (let item of _data["incomingWaybillItems"])
                    this.incomingWaybillItems.push(IncomingWaybillItemModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncomingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["projectId"] = this.projectId;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitProvinceId"] = this.exitProvinceId;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        if (Array.isArray(this.incomingWaybillItems)) {
            data["incomingWaybillItems"] = [];
            for (let item of this.incomingWaybillItems)
                data["incomingWaybillItems"].push(item.toJSON());
        }
        return data;
    }
}
export class IncomingWaybillItemModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingWaybillItemModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        return data;
    }
}
export class CreateOutgoingWaybillCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOutgoingWaybillCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateOutgoingWaybillCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.shipmentAddress = _data["shipmentAddress"];
            this.shipmentDistrictId = _data["shipmentDistrictId"];
            this.shipmentProvinceId = _data["shipmentProvinceId"];
            this.exitAddress = _data["exitAddress"];
            this.exitDistrictId = _data["exitDistrictId"];
            this.exitProvinceId = _data["exitProvinceId"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.carPlate = _data["carPlate"];
            this.driverName = _data["driverName"];
            this.cargoCompany = _data["cargoCompany"];
            this.cargoCompanyTaxNumber = _data["cargoCompanyTaxNumber"];
            if (Array.isArray(_data["outgoingWaybillItems"])) {
                this.outgoingWaybillItems = [];
                for (let item of _data["outgoingWaybillItems"])
                    this.outgoingWaybillItems.push(OutgoingWaybillItemModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOutgoingWaybillCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["shipmentAddress"] = this.shipmentAddress;
        data["shipmentDistrictId"] = this.shipmentDistrictId;
        data["shipmentProvinceId"] = this.shipmentProvinceId;
        data["exitAddress"] = this.exitAddress;
        data["exitDistrictId"] = this.exitDistrictId;
        data["exitProvinceId"] = this.exitProvinceId;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["carPlate"] = this.carPlate;
        data["driverName"] = this.driverName;
        data["cargoCompany"] = this.cargoCompany;
        data["cargoCompanyTaxNumber"] = this.cargoCompanyTaxNumber;
        if (Array.isArray(this.outgoingWaybillItems)) {
            data["outgoingWaybillItems"] = [];
            for (let item of this.outgoingWaybillItems)
                data["outgoingWaybillItems"].push(item.toJSON());
        }
        return data;
    }
}
export class OutgoingWaybillItemModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingWaybillItemModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        return data;
    }
}
export class ArchivingProductCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingProductCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateFastProductCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFastProductCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateFastProductCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFastProductCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class CreateProductCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProductCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.productUnitId = _data["productUnitId"];
            this.isFollowStock = _data["isFollowStock"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.isTotalStockAlarm = _data["isTotalStockAlarm"];
            this.totalStockAlarmCount = _data["totalStockAlarmCount"];
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["productUnitId"] = this.productUnitId;
        data["isFollowStock"] = this.isFollowStock;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["isTotalStockAlarm"] = this.isTotalStockAlarm;
        data["totalStockAlarmCount"] = this.totalStockAlarmCount;
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export class DeleteProductCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetProductQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.isFollowStock = _data["isFollowStock"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.isTotalStockAlarm = _data["isTotalStockAlarm"];
            this.totalStockAlarmCount = _data["totalStockAlarmCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["isFollowStock"] = this.isFollowStock;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["isTotalStockAlarm"] = this.isTotalStockAlarm;
        data["totalStockAlarmCount"] = this.totalStockAlarmCount;
        return data;
    }
}
export class GetProductInfoQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductInfoQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        return data;
    }
}
export class GetProductInfoQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductInfoQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetStockQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.currentStock = _data["currentStock"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["currentStock"] = this.currentStock;
        return data;
    }
}
export class GetStockQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class SearchExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.amount = _data["amount"];
            this.productUnitName = _data["productUnitName"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["amount"] = this.amount;
        data["productUnitName"] = this.productUnitName;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        return data;
    }
}
export class SearchExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedListOfSearchProductQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchProductQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchProductQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchProductQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stockCount = _data["stockCount"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.productUnitName = _data["productUnitName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stockCount"] = this.stockCount;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["productUnitName"] = this.productUnitName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class SearchSaleInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.saleInvoiceName = _data["saleInvoiceName"];
            this.amount = _data["amount"];
            this.productUnitName = _data["productUnitName"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSaleInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["saleInvoiceName"] = this.saleInvoiceName;
        data["amount"] = this.amount;
        data["productUnitName"] = this.productUnitName;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        return data;
    }
}
export class SearchSaleInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSaleInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class SearchStockQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
            this.productUnitName = _data["productUnitName"];
            this.stockProcessTypeId = _data["stockProcessTypeId"];
            this.stockProcessTypeName = _data["stockProcessTypeName"];
            this.processDate = _data["processDate"] ? new Date(_data["processDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStockQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        data["productUnitName"] = this.productUnitName;
        data["stockProcessTypeId"] = this.stockProcessTypeId;
        data["stockProcessTypeName"] = this.stockProcessTypeName;
        data["processDate"] = this.processDate ? this.processDate.toISOString() : undefined;
        return data;
    }
}
export class SearchStockQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStockQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class SearchWarehouseQueryResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
            this.productUnitName = _data["productUnitName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWarehouseQueryResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        data["productUnitName"] = this.productUnitName;
        return data;
    }
}
export class SearchWarehouseQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWarehouseQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class UpdateProductCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.productUnitId = _data["productUnitId"];
            this.isFollowStock = _data["isFollowStock"];
            this.basePurchasePrice = _data["basePurchasePrice"];
            this.baseSalePrice = _data["baseSalePrice"];
            this.taxId = _data["taxId"];
            this.purchasePriceWithTax = _data["purchasePriceWithTax"];
            this.salePriceWithTax = _data["salePriceWithTax"];
            this.isTotalStockAlarm = _data["isTotalStockAlarm"];
            this.totalStockAlarmCount = _data["totalStockAlarmCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["productUnitId"] = this.productUnitId;
        data["isFollowStock"] = this.isFollowStock;
        data["basePurchasePrice"] = this.basePurchasePrice;
        data["baseSalePrice"] = this.baseSalePrice;
        data["taxId"] = this.taxId;
        data["purchasePriceWithTax"] = this.purchasePriceWithTax;
        data["salePriceWithTax"] = this.salePriceWithTax;
        data["isTotalStockAlarm"] = this.isTotalStockAlarm;
        data["totalStockAlarmCount"] = this.totalStockAlarmCount;
        return data;
    }
}
export class UpdateWarehousesCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["stockModels"])) {
                this.stockModels = [];
                for (let item of _data["stockModels"])
                    this.stockModels.push(StockModel2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehousesCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stockModels)) {
            data["stockModels"] = [];
            for (let item of this.stockModels)
                data["stockModels"].push(item.toJSON());
        }
        return data;
    }
}
export class StockModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StockModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        return data;
    }
}
export class CompleteNotificationCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteNotificationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DashboardNotificationQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalNotificationCount = _data["totalNotificationCount"];
            this.successCount = _data["successCount"];
            if (Array.isArray(_data["successList"])) {
                this.successList = [];
                for (let item of _data["successList"])
                    this.successList.push(Success.fromJS(item));
            }
            this.warningCount = _data["warningCount"];
            if (Array.isArray(_data["warningList"])) {
                this.warningList = [];
                for (let item of _data["warningList"])
                    this.warningList.push(Warning.fromJS(item));
            }
            this.alertCount = _data["alertCount"];
            if (Array.isArray(_data["alertList"])) {
                this.alertList = [];
                for (let item of _data["alertList"])
                    this.alertList.push(Alert.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardNotificationQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalNotificationCount"] = this.totalNotificationCount;
        data["successCount"] = this.successCount;
        if (Array.isArray(this.successList)) {
            data["successList"] = [];
            for (let item of this.successList)
                data["successList"].push(item.toJSON());
        }
        data["warningCount"] = this.warningCount;
        if (Array.isArray(this.warningList)) {
            data["warningList"] = [];
            for (let item of this.warningList)
                data["warningList"].push(item.toJSON());
        }
        data["alertCount"] = this.alertCount;
        if (Array.isArray(this.alertList)) {
            data["alertList"] = [];
            for (let item of this.alertList)
                data["alertList"].push(item.toJSON());
        }
        return data;
    }
}
export class Success {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : undefined;
            this.sourcePath = _data["sourcePath"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Success();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined;
        data["sourcePath"] = this.sourcePath;
        return data;
    }
}
export class Warning {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : undefined;
            this.sourcePath = _data["sourcePath"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Warning();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined;
        data["sourcePath"] = this.sourcePath;
        return data;
    }
}
export class Alert {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : undefined;
            this.sourcePath = _data["sourcePath"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Alert();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined;
        data["sourcePath"] = this.sourcePath;
        return data;
    }
}
export class PagedListOfSearchNotificationQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchNotificationQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchNotificationQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchNotificationQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : undefined;
            this.notificationTypeId = _data["notificationTypeId"];
            this.notificationTypeName = _data["notificationTypeName"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.sourceRecordId = _data["sourceRecordId"];
            this.sourcePath = _data["sourcePath"];
            this.isCompleted = _data["isCompleted"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNotificationQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined;
        data["notificationTypeId"] = this.notificationTypeId;
        data["notificationTypeName"] = this.notificationTypeName;
        data["sourceTypeId"] = this.sourceTypeId;
        data["sourceRecordId"] = this.sourceRecordId;
        data["sourcePath"] = this.sourcePath;
        data["isCompleted"] = this.isCompleted;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : undefined;
        return data;
    }
}
export class GetApplicationInfoQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.version = _data["version"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationInfoQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        return data;
    }
}
export class DistrictLookupVm {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictLookupVm();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        return data;
    }
}
export class GetDistrictLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.provinceId = _data["provinceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["provinceId"] = this.provinceId;
        return data;
    }
}
export class BasicLookupVm {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BasicLookupVm();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllBasicLookupQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBasicLookupQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class ArchivingCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateCompanyCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyTypeId = _data["companyTypeId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.iban = _data["iban"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.commercialEnterpriseTypeId = _data["commercialEnterpriseTypeId"];
            this.identityNumber = _data["identityNumber"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
            this.gibInvoiceTypeId = _data["gibInvoiceTypeId"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["companyPeoples"])) {
                this.companyPeoples = [];
                for (let item of _data["companyPeoples"])
                    this.companyPeoples.push(CompanyPeopleModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyTypeId"] = this.companyTypeId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["iban"] = this.iban;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["commercialEnterpriseTypeId"] = this.commercialEnterpriseTypeId;
        data["identityNumber"] = this.identityNumber;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        data["gibInvoiceTypeId"] = this.gibInvoiceTypeId;
        data["invoiceEmail"] = this.invoiceEmail;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.companyPeoples)) {
            data["companyPeoples"] = [];
            for (let item of this.companyPeoples)
                data["companyPeoples"].push(item.toJSON());
        }
        return data;
    }
}
export class CompanyPeopleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPeopleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class DeleteCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["companyTypes"])) {
                this.companyTypes = [];
                for (let item of _data["companyTypes"])
                    this.companyTypes.push(CompanyTypeModel.fromJS(item));
            }
            this.name = _data["name"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.iban = _data["iban"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.provinceName = _data["provinceName"];
            this.provinceId = _data["provinceId"];
            this.districtName = _data["districtName"];
            this.districtId = _data["districtId"];
            this.commercialEnterpriseTypeName = _data["commercialEnterpriseTypeName"];
            this.commercialEnterpriseTypeId = _data["commercialEnterpriseTypeId"];
            this.identityNumber = _data["identityNumber"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            this.accountId = _data["accountId"];
            this.gibInvoiceTypeId = _data["gibInvoiceTypeId"];
            this.gibInvoiceTypeName = _data["gibInvoiceTypeName"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.balance = _data["balance"];
            this.balanceInformation = _data["balanceInformation"];
            this.totalSales = _data["totalSales"];
            this.totalSaleBalances = _data["totalSaleBalances"];
            this.totalExpenses = _data["totalExpenses"];
            this.totalExpenseBalances = _data["totalExpenseBalances"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalPayment = _data["totalPayment"];
            this.totalCollection = _data["totalCollection"];
            this.totalCheckPayment = _data["totalCheckPayment"];
            this.totalTaskWork = _data["totalTaskWork"];
            this.completedTaskWork = _data["completedTaskWork"];
            this.completionRateOfTaskWork = _data["completionRateOfTaskWork"];
            if (Array.isArray(_data["companyPeoples"])) {
                this.companyPeoples = [];
                for (let item of _data["companyPeoples"])
                    this.companyPeoples.push(CompanyPeopleModel2.fromJS(item));
            }
            if (Array.isArray(_data["saleInvoices"])) {
                this.saleInvoices = [];
                for (let item of _data["saleInvoices"])
                    this.saleInvoices.push(SaleInvoiceModel3.fromJS(item));
            }
            if (Array.isArray(_data["expenseInvoices"])) {
                this.expenseInvoices = [];
                for (let item of _data["expenseInvoices"])
                    this.expenseInvoices.push(ExpenseInvoiceModel3.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [];
                for (let item of _data["projects"])
                    this.projects.push(ProjectModel2.fromJS(item));
            }
            if (Array.isArray(_data["checkPayments"])) {
                this.checkPayments = [];
                for (let item of _data["checkPayments"])
                    this.checkPayments.push(CheckPaymentModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [];
                for (let item of _data["contracts"])
                    this.contracts.push(ContractModel.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [];
                for (let item of _data["tasks"])
                    this.tasks.push(TaskModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.companyTypes)) {
            data["companyTypes"] = [];
            for (let item of this.companyTypes)
                data["companyTypes"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["iban"] = this.iban;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["provinceName"] = this.provinceName;
        data["provinceId"] = this.provinceId;
        data["districtName"] = this.districtName;
        data["districtId"] = this.districtId;
        data["commercialEnterpriseTypeName"] = this.commercialEnterpriseTypeName;
        data["commercialEnterpriseTypeId"] = this.commercialEnterpriseTypeId;
        data["identityNumber"] = this.identityNumber;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["accountId"] = this.accountId;
        data["gibInvoiceTypeId"] = this.gibInvoiceTypeId;
        data["gibInvoiceTypeName"] = this.gibInvoiceTypeName;
        data["invoiceEmail"] = this.invoiceEmail;
        data["balance"] = this.balance;
        data["balanceInformation"] = this.balanceInformation;
        data["totalSales"] = this.totalSales;
        data["totalSaleBalances"] = this.totalSaleBalances;
        data["totalExpenses"] = this.totalExpenses;
        data["totalExpenseBalances"] = this.totalExpenseBalances;
        data["totalWitholding"] = this.totalWitholding;
        data["totalPayment"] = this.totalPayment;
        data["totalCollection"] = this.totalCollection;
        data["totalCheckPayment"] = this.totalCheckPayment;
        data["totalTaskWork"] = this.totalTaskWork;
        data["completedTaskWork"] = this.completedTaskWork;
        data["completionRateOfTaskWork"] = this.completionRateOfTaskWork;
        if (Array.isArray(this.companyPeoples)) {
            data["companyPeoples"] = [];
            for (let item of this.companyPeoples)
                data["companyPeoples"].push(item.toJSON());
        }
        if (Array.isArray(this.saleInvoices)) {
            data["saleInvoices"] = [];
            for (let item of this.saleInvoices)
                data["saleInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseInvoices)) {
            data["expenseInvoices"] = [];
            for (let item of this.expenseInvoices)
                data["expenseInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.checkPayments)) {
            data["checkPayments"] = [];
            for (let item of this.checkPayments)
                data["checkPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}
export class CompanyTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyTypeId = _data["companyTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyTypeId"] = this.companyTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class CompanyPeopleModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPeopleModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class SaleInvoiceModel3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.salePaymentStatusName = _data["salePaymentStatusName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceModel3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["salePaymentStatusName"] = this.salePaymentStatusName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        return data;
    }
}
export class ExpenseInvoiceModel3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.totalPrice = _data["totalPrice"];
            this.balance = _data["balance"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalPricePlusWithHolding = _data["totalPricePlusWithHolding"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoiceModel3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["totalPrice"] = this.totalPrice;
        data["balance"] = this.balance;
        data["totalWitholding"] = this.totalWitholding;
        data["totalPricePlusWithHolding"] = this.totalPricePlusWithHolding;
        data["expenseTypeId"] = this.expenseTypeId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        return data;
    }
}
export class ProjectModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expenseTotal = _data["expenseTotal"];
            this.expenseBalanceTotal = _data["expenseBalanceTotal"];
            this.saleTotal = _data["saleTotal"];
            this.saleBalanceTotal = _data["saleBalanceTotal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expenseTotal"] = this.expenseTotal;
        data["expenseBalanceTotal"] = this.expenseBalanceTotal;
        data["saleTotal"] = this.saleTotal;
        data["saleBalanceTotal"] = this.saleBalanceTotal;
        return data;
    }
}
export class CheckPaymentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.checkId = _data["checkId"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.projectName = _data["projectName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPaymentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["checkId"] = this.checkId;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["projectName"] = this.projectName;
        return data;
    }
}
export class ContractModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.contractTypeName = _data["contractTypeName"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStateName = _data["contractStateName"];
            this.contractStateId = _data["contractStateId"];
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.duration = _data["duration"];
            this.importantItem = _data["importantItem"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContractModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["contractTypeName"] = this.contractTypeName;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStateName"] = this.contractStateName;
        data["contractStateId"] = this.contractStateId;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["duration"] = this.duration;
        data["importantItem"] = this.importantItem;
        data["relatedStaffName"] = this.relatedStaffName;
        data["relatedStaffId"] = this.relatedStaffId;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class TaskModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.rootTaskName = _data["rootTaskName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
            this.remainingDay = _data["remainingDay"];
            this.taskStateName = _data["taskStateName"];
            this.staffName = _data["staffName"];
            this.description = _data["description"];
            this.completionRate = _data["completionRate"];
            this.constructionSiteName = _data["constructionSiteName"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.blockName = _data["blockName"];
            this.blockId = _data["blockId"];
            this.plotName = _data["plotName"];
            this.plotId = _data["plotId"];
            this.totalWork = _data["totalWork"];
            this.totalPersonDay = _data["totalPersonDay"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TaskModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["rootTaskName"] = this.rootTaskName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["remainingDay"] = this.remainingDay;
        data["taskStateName"] = this.taskStateName;
        data["staffName"] = this.staffName;
        data["description"] = this.description;
        data["completionRate"] = this.completionRate;
        data["constructionSiteName"] = this.constructionSiteName;
        data["constructionSiteId"] = this.constructionSiteId;
        data["blockName"] = this.blockName;
        data["blockId"] = this.blockId;
        data["plotName"] = this.plotName;
        data["plotId"] = this.plotId;
        data["totalWork"] = this.totalWork;
        data["totalPersonDay"] = this.totalPersonDay;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchCompanyQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            this.identityNumber = _data["identityNumber"];
            this.balance = _data["balance"];
            this.balanceInformation = _data["balanceInformation"];
            this.categoryName = _data["categoryName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["identityNumber"] = this.identityNumber;
        data["balance"] = this.balance;
        data["balanceInformation"] = this.balanceInformation;
        data["categoryName"] = this.categoryName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateCompanyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.companyTypeIds = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["companyTypeIds"])) {
                this.companyTypeIds = [];
                for (let item of _data["companyTypeIds"])
                    this.companyTypeIds.push(item);
            }
            this.name = _data["name"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.iban = _data["iban"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.commercialEnterpriseTypeId = _data["commercialEnterpriseTypeId"];
            this.identityNumber = _data["identityNumber"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
            this.gibInvoiceTypeId = _data["gibInvoiceTypeId"];
            this.invoiceEmail = _data["invoiceEmail"];
            if (Array.isArray(_data["companyPeoples"])) {
                this.companyPeoples = [];
                for (let item of _data["companyPeoples"])
                    this.companyPeoples.push(UpdateCompanyCommandPeople.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.companyTypeIds)) {
            data["companyTypeIds"] = [];
            for (let item of this.companyTypeIds)
                data["companyTypeIds"].push(item);
        }
        data["name"] = this.name;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["iban"] = this.iban;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["commercialEnterpriseTypeId"] = this.commercialEnterpriseTypeId;
        data["identityNumber"] = this.identityNumber;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        data["gibInvoiceTypeId"] = this.gibInvoiceTypeId;
        data["invoiceEmail"] = this.invoiceEmail;
        if (Array.isArray(this.companyPeoples)) {
            data["companyPeoples"] = [];
            for (let item of this.companyPeoples)
                data["companyPeoples"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateCompanyCommandPeople {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.nameSurname = _data["nameSurname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommandPeople();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameSurname"] = this.nameSurname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["description"] = this.description;
        return data;
    }
}
export class CompleteUserTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteUserTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateUserTaskCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTaskCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateUserTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            this.taskDate = _data["taskDate"] ? new Date(_data["taskDate"].toString()) : undefined;
            this.taskPriorityId = _data["taskPriorityId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["taskDate"] = this.taskDate ? this.taskDate.toISOString() : undefined;
        data["taskPriorityId"] = this.taskPriorityId;
        return data;
    }
}
export class DeleteUserTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetUserTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.userNameSurname = _data["userNameSurname"];
            this.requestedUserId = _data["requestedUserId"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.taskDate = _data["taskDate"] ? new Date(_data["taskDate"].toString()) : undefined;
            this.userTaskStatusId = _data["userTaskStatusId"];
            this.userTaskStatusName = _data["userTaskStatusName"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : undefined;
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskPriorityName = _data["taskPriorityName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["userNameSurname"] = this.userNameSurname;
        data["requestedUserId"] = this.requestedUserId;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["taskDate"] = this.taskDate ? this.taskDate.toISOString() : undefined;
        data["userTaskStatusId"] = this.userTaskStatusId;
        data["userTaskStatusName"] = this.userTaskStatusName;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : undefined;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskPriorityName"] = this.taskPriorityName;
        return data;
    }
}
export class PagedListOfSearchUserTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchUserTaskQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchUserTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchUserTaskQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userNameSurname = _data["userNameSurname"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.taskDate = _data["taskDate"] ? new Date(_data["taskDate"].toString()) : undefined;
            this.userTaskStatusName = _data["userTaskStatusName"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : undefined;
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskPriorityName = _data["taskPriorityName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUserTaskQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userNameSurname"] = this.userNameSurname;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["taskDate"] = this.taskDate ? this.taskDate.toISOString() : undefined;
        data["userTaskStatusName"] = this.userTaskStatusName;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : undefined;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskPriorityName"] = this.taskPriorityName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateUserTaskCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taskDate = _data["taskDate"] ? new Date(_data["taskDate"].toString()) : undefined;
            this.userTaskStatusId = _data["userTaskStatusId"];
            this.taskPriorityId = _data["taskPriorityId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTaskCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taskDate"] = this.taskDate ? this.taskDate.toISOString() : undefined;
        data["userTaskStatusId"] = this.userTaskStatusId;
        data["taskPriorityId"] = this.taskPriorityId;
        return data;
    }
}
export class GetTenantCompanyQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.address = _data["address"];
            this.provinceId = _data["provinceId"];
            this.provinceName = _data["provinceName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            this.registerNumber = _data["registerNumber"];
            this.email = _data["email"];
            this.logoUrl = _data["logoUrl"];
            this.iban = _data["iban"];
            this.mersisNo = _data["mersisNo"];
            this.postalCode = _data["postalCode"];
            this.ticariSicilNo = _data["ticariSicilNo"];
            this.webSite = _data["webSite"];
            this.sealSignatureUrl = _data["sealSignatureUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantCompanyQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["address"] = this.address;
        data["provinceId"] = this.provinceId;
        data["provinceName"] = this.provinceName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["registerNumber"] = this.registerNumber;
        data["email"] = this.email;
        data["logoUrl"] = this.logoUrl;
        data["iban"] = this.iban;
        data["mersisNo"] = this.mersisNo;
        data["postalCode"] = this.postalCode;
        data["ticariSicilNo"] = this.ticariSicilNo;
        data["webSite"] = this.webSite;
        data["sealSignatureUrl"] = this.sealSignatureUrl;
        return data;
    }
}
export class SearchCalendarQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.title = _data["title"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.description = _data["description"];
            this.url = _data["url"];
            this.authorizedUserIds = _data["authorizedUserIds"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCalendarQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["sourceTypeName"] = this.sourceTypeName;
        data["title"] = this.title;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["description"] = this.description;
        data["url"] = this.url;
        data["authorizedUserIds"] = this.authorizedUserIds;
        return data;
    }
}
export class SearchCalendarQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCalendarQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        return data;
    }
}
export class GetAllRecordHistoryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.recordDate = _data["recordDate"] ? new Date(_data["recordDate"].toString()) : undefined;
            this.userNameSurname = _data["userNameSurname"];
            this.recordProcessTypeId = _data["recordProcessTypeId"];
            this.recordProcessTypeName = _data["recordProcessTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecordHistoryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["recordDate"] = this.recordDate ? this.recordDate.toISOString() : undefined;
        data["userNameSurname"] = this.userNameSurname;
        data["recordProcessTypeId"] = this.recordProcessTypeId;
        data["recordProcessTypeName"] = this.recordProcessTypeName;
        return data;
    }
}
export class GetAllRecordHistoryQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecordHistoryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class CreateRecordCategoryCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecordCategoryCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateRecordCategoryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecordCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class GetRecordCategoryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordCategoryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetRecordCategoryQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordCategoryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class UpdateRecordCategoryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.categoryId = _data["categoryId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecordCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["categoryId"] = this.categoryId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class CreateNoteCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DeleteNoteCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNoteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["id"] = this.id;
        return data;
    }
}
export class GetAllNoteBySourceIdAndSourceTypeIdQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.noteDate = _data["noteDate"] ? new Date(_data["noteDate"].toString()) : undefined;
            this.displayName = _data["displayName"];
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNoteBySourceIdAndSourceTypeIdQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["noteDate"] = this.noteDate ? this.noteDate.toISOString() : undefined;
        data["displayName"] = this.displayName;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}
export class GetAllNoteBySourceIdAndSourceTypeIdQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNoteBySourceIdAndSourceTypeIdQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class GetAllNoteImagesQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.noteDate = _data["noteDate"] ? new Date(_data["noteDate"].toString()) : undefined;
            this.displayName = _data["displayName"];
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
            this.fileBytes = _data["fileBytes"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNoteImagesQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["noteDate"] = this.noteDate ? this.noteDate.toISOString() : undefined;
        data["displayName"] = this.displayName;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        data["fileBytes"] = this.fileBytes;
        return data;
    }
}
export class GetAllNoteImagesQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNoteImagesQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class GlobalSearchQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.sourceTypeLink = _data["sourceTypeLink"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sourceTypeId"] = this.sourceTypeId;
        data["sourceTypeName"] = this.sourceTypeName;
        data["sourceTypeLink"] = this.sourceTypeLink;
        return data;
    }
}
export class GlobalSearchQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class CreateFileCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class AssignFileFolderPermissionCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.permissionsCreated = _data["permissionsCreated"];
            this.permissionsRemoved = _data["permissionsRemoved"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFileFolderPermissionCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["permissionsCreated"] = this.permissionsCreated;
        data["permissionsRemoved"] = this.permissionsRemoved;
        return data;
    }
}
export class AssignFileFolderPermissionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.userIds = [];
        }
    }
    init(_data) {
        if (_data) {
            this.fileFolderId = _data["fileFolderId"];
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFileFolderPermissionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileFolderId"] = this.fileFolderId;
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}
export class CreateFileFolderCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFolderCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateFileFolderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.name = _data["name"];
            this.rootFileFolderId = _data["rootFileFolderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFolderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["name"] = this.name;
        data["rootFileFolderId"] = this.rootFileFolderId;
        return data;
    }
}
export class DeleteFileFolderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileFolderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["id"] = this.id;
        return data;
    }
}
export class GetAllFolderWithFilesQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.rootFileFolderId = _data["rootFileFolderId"];
            this.name = _data["name"];
            this.fileUrl = _data["fileUrl"];
            this.path = _data["path"];
            this.contentLengthName = _data["contentLengthName"];
            this.isSecure = _data["isSecure"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFolderWithFilesQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceTypeId"] = this.sourceTypeId;
        data["rootFileFolderId"] = this.rootFileFolderId;
        data["name"] = this.name;
        data["fileUrl"] = this.fileUrl;
        data["path"] = this.path;
        data["contentLengthName"] = this.contentLengthName;
        data["isSecure"] = this.isSecure;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetAllFolderWithFilesQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.rootFileFolderId = _data["rootFileFolderId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFolderWithFilesQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["rootFileFolderId"] = this.rootFileFolderId;
        data["name"] = this.name;
        return data;
    }
}
export class GetFileFolderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.rootFileFolderId = _data["rootFileFolderId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.isSecure = _data["isSecure"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileFolderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceTypeId"] = this.sourceTypeId;
        data["rootFileFolderId"] = this.rootFileFolderId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["isSecure"] = this.isSecure;
        return data;
    }
}
export class GetFileFolderQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileFolderQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class GetFileFolderPermissionQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(UserItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileFolderPermissionQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item.toJSON());
        }
        return data;
    }
}
export class UserItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetRootFileFolderIdQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rootFileFolderId = _data["rootFileFolderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRootFileFolderIdQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rootFileFolderId"] = this.rootFileFolderId;
        return data;
    }
}
export class GetRootFileFolderIdQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRootFileFolderIdQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class RenameFileFolderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFileFolderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class UpdateFileFolderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rootFileFolderId = _data["rootFileFolderId"];
            this.id = _data["id"];
            this.newRootFileFolderId = _data["newRootFileFolderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileFolderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rootFileFolderId"] = this.rootFileFolderId;
        data["id"] = this.id;
        data["newRootFileFolderId"] = this.newRootFileFolderId;
        return data;
    }
}
export class GetAllFeatureFlagsQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
            this.route = _data["route"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFeatureFlagsQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        data["route"] = this.route;
        data["value"] = this.value;
        return data;
    }
}
export class BankCashDashboardQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["paymentPlansExpenses"])) {
                this.paymentPlansExpenses = [];
                for (let item of _data["paymentPlansExpenses"])
                    this.paymentPlansExpenses.push(PaymentPlanModel2.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansSales"])) {
                this.paymentPlansSales = [];
                for (let item of _data["paymentPlansSales"])
                    this.paymentPlansSales.push(PaymentPlanModel2.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlyExpenses"])) {
                this.paymentPlansMonthlyExpenses = [];
                for (let item of _data["paymentPlansMonthlyExpenses"])
                    this.paymentPlansMonthlyExpenses.push(PaymentPlanMonthlyModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlySales"])) {
                this.paymentPlansMonthlySales = [];
                for (let item of _data["paymentPlansMonthlySales"])
                    this.paymentPlansMonthlySales.push(PaymentPlanMonthlyModel.fromJS(item));
            }
            if (Array.isArray(_data["checks"])) {
                this.checks = [];
                for (let item of _data["checks"])
                    this.checks.push(CheckModel.fromJS(item));
            }
            this.cashFlows = _data["cashFlows"] ? CashFlow.fromJS(_data["cashFlows"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BankCashDashboardQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentPlansExpenses)) {
            data["paymentPlansExpenses"] = [];
            for (let item of this.paymentPlansExpenses)
                data["paymentPlansExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansSales)) {
            data["paymentPlansSales"] = [];
            for (let item of this.paymentPlansSales)
                data["paymentPlansSales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlyExpenses)) {
            data["paymentPlansMonthlyExpenses"] = [];
            for (let item of this.paymentPlansMonthlyExpenses)
                data["paymentPlansMonthlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlySales)) {
            data["paymentPlansMonthlySales"] = [];
            for (let item of this.paymentPlansMonthlySales)
                data["paymentPlansMonthlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        data["cashFlows"] = this.cashFlows ? this.cashFlows.toJSON() : undefined;
        return data;
    }
}
export class PaymentPlanModel2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paymentPlanTypeId = _data["paymentPlanTypeId"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.salaryId = _data["salaryId"];
            this.checkId = _data["checkId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.defermenDate = _data["defermenDate"] ? new Date(_data["defermenDate"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanModel2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentPlanTypeId"] = this.paymentPlanTypeId;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["salaryId"] = this.salaryId;
        data["checkId"] = this.checkId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseTypeId"] = this.expenseTypeId;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["defermenDate"] = this.defermenDate ? this.defermenDate.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}
export class PaymentPlanMonthlyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlanMonthlyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class CheckModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.checkStateName = _data["checkStateName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["checkStateName"] = this.checkStateName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}
export class CashFlow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalDefaultCurrencyAmount = _data["totalDefaultCurrencyAmount"];
            this.totalOtherCurrenciesAmount = _data["totalOtherCurrenciesAmount"];
            this.totalAllCurrenciesAmount = _data["totalAllCurrenciesAmount"];
            if (Array.isArray(_data["currenctBankCashAccounts"])) {
                this.currenctBankCashAccounts = [];
                for (let item of _data["currenctBankCashAccounts"])
                    this.currenctBankCashAccounts.push(CurrentBankCashAccount.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlyExpenses"])) {
                this.paymentPlansMonthlyExpenses = [];
                for (let item of _data["paymentPlansMonthlyExpenses"])
                    this.paymentPlansMonthlyExpenses.push(PaymentPlanMonthlyModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansMonthlySales"])) {
                this.paymentPlansMonthlySales = [];
                for (let item of _data["paymentPlansMonthlySales"])
                    this.paymentPlansMonthlySales.push(PaymentPlanMonthlyModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlansCashFlows"])) {
                this.paymentPlansCashFlows = [];
                for (let item of _data["paymentPlansCashFlows"])
                    this.paymentPlansCashFlows.push(PaymentPlansCashFlowModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashFlow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalDefaultCurrencyAmount"] = this.totalDefaultCurrencyAmount;
        data["totalOtherCurrenciesAmount"] = this.totalOtherCurrenciesAmount;
        data["totalAllCurrenciesAmount"] = this.totalAllCurrenciesAmount;
        if (Array.isArray(this.currenctBankCashAccounts)) {
            data["currenctBankCashAccounts"] = [];
            for (let item of this.currenctBankCashAccounts)
                data["currenctBankCashAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlyExpenses)) {
            data["paymentPlansMonthlyExpenses"] = [];
            for (let item of this.paymentPlansMonthlyExpenses)
                data["paymentPlansMonthlyExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansMonthlySales)) {
            data["paymentPlansMonthlySales"] = [];
            for (let item of this.paymentPlansMonthlySales)
                data["paymentPlansMonthlySales"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlansCashFlows)) {
            data["paymentPlansCashFlows"] = [];
            for (let item of this.paymentPlansCashFlows)
                data["paymentPlansCashFlows"].push(item.toJSON());
        }
        return data;
    }
}
export class CurrentBankCashAccount {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.totalAmount = _data["totalAmount"];
            this.defaultCurrenctAmount = _data["defaultCurrenctAmount"];
            this.currentRate = _data["currentRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentBankCashAccount();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["totalAmount"] = this.totalAmount;
        data["defaultCurrenctAmount"] = this.defaultCurrenctAmount;
        data["currentRate"] = this.currentRate;
        return data;
    }
}
export class PaymentPlansCashFlowModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            this.cashFlow = _data["cashFlow"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPlansCashFlowModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        data["cashFlow"] = this.cashFlow;
        return data;
    }
}
export class BankCashDashboardQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BankCashDashboardQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GeneralDashboardQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projects = _data["projects"];
            this.staffs = _data["staffs"];
            this.soldRealEstates = _data["soldRealEstates"];
            this.realEstatesForSale = _data["realEstatesForSale"];
            this.totalUserTaskCount = _data["totalUserTaskCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDashboardQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projects"] = this.projects;
        data["staffs"] = this.staffs;
        data["soldRealEstates"] = this.soldRealEstates;
        data["realEstatesForSale"] = this.realEstatesForSale;
        data["totalUserTaskCount"] = this.totalUserTaskCount;
        return data;
    }
}
export class GeneralDashboardQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDashboardQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class CreateCategoryCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateCategoryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceTypeId = _data["sourceTypeId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceTypeId"] = this.sourceTypeId;
        data["name"] = this.name;
        return data;
    }
}
export class DeleteCategoryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class GetAllCategoryQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCategoryQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllCategoryQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCategoryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}
export class UpdateCategoryCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetAllActivityQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.sourceTypeLink = _data["sourceTypeLink"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActivityQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sourceTypeName"] = this.sourceTypeName;
        data["sourceTypeLink"] = this.sourceTypeLink;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        return data;
    }
}
export class GetAllActivityQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActivityQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class CreateUserCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.azureObjectIdentifier = _data["azureObjectIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["azureObjectIdentifier"] = this.azureObjectIdentifier;
        return data;
    }
}
export class CreateUserCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
            if (Array.isArray(_data["dynamicReportIds"])) {
                this.dynamicReportIds = [];
                for (let item of _data["dynamicReportIds"])
                    this.dynamicReportIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.dynamicReportIds)) {
            data["dynamicReportIds"] = [];
            for (let item of this.dynamicReportIds)
                data["dynamicReportIds"].push(item);
        }
        return data;
    }
}
export class GetUserQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
            if (Array.isArray(_data["rolesWithName"])) {
                this.rolesWithName = [];
                for (let item of _data["rolesWithName"])
                    this.rolesWithName.push(IdName2.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [];
                for (let item of _data["projects"])
                    this.projects.push(ProjectModel3.fromJS(item));
            }
            if (Array.isArray(_data["dynamicReports"])) {
                this.dynamicReports = [];
                for (let item of _data["dynamicReports"])
                    this.dynamicReports.push(DynamicReportModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.rolesWithName)) {
            data["rolesWithName"] = [];
            for (let item of this.rolesWithName)
                data["rolesWithName"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.dynamicReports)) {
            data["dynamicReports"] = [];
            for (let item of this.dynamicReports)
                data["dynamicReports"].push(item.toJSON());
        }
        return data;
    }
}
export class IdName2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IdName2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class ProjectModel3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class DynamicReportModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicReportModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class PagedListOfSearchUserQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchUserQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchUserQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchUserQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUserQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateUserCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [];
                for (let item of _data["projectIds"])
                    this.projectIds.push(item);
            }
            if (Array.isArray(_data["dynamicReportIds"])) {
                this.dynamicReportIds = [];
                for (let item of _data["dynamicReportIds"])
                    this.dynamicReportIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.dynamicReportIds)) {
            data["dynamicReportIds"] = [];
            for (let item of this.dynamicReportIds)
                data["dynamicReportIds"].push(item);
        }
        return data;
    }
}
export class UpdateUserRolesCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRolesCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}
export class UpdateUserRolesCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRolesCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}
export class GetAuditQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.type = _data["type"];
            this.tableName = _data["tableName"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined;
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.affectedColumns = _data["affectedColumns"];
            this.primaryKey = _data["primaryKey"];
            this.uniqueIdentifierReference = _data["uniqueIdentifierReference"];
            this.idReference = _data["idReference"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["affectedColumns"] = this.affectedColumns;
        data["primaryKey"] = this.primaryKey;
        data["uniqueIdentifierReference"] = this.uniqueIdentifierReference;
        data["idReference"] = this.idReference;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class ListByGuidCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.type = _data["type"];
            this.tableName = _data["tableName"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined;
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.affectedColumns = _data["affectedColumns"];
            this.primaryKey = _data["primaryKey"];
            this.uniqueIdentifierReference = _data["uniqueIdentifierReference"];
            this.idReference = _data["idReference"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListByGuidCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["affectedColumns"] = this.affectedColumns;
        data["primaryKey"] = this.primaryKey;
        data["uniqueIdentifierReference"] = this.uniqueIdentifierReference;
        data["idReference"] = this.idReference;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchAuditQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchAuditQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchAuditQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchAuditQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.type = _data["type"];
            this.tableName = _data["tableName"];
            this.fullName = _data["fullName"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined;
            this.uniqueIdentifierReference = _data["uniqueIdentifierReference"];
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAuditQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["fullName"] = this.fullName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined;
        data["uniqueIdentifierReference"] = this.uniqueIdentifierReference;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        return data;
    }
}
export class DeletePurchaseProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePurchaseProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class ArchivingPurchaseOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingPurchaseOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DeletePurchaseOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePurchaseOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class UpdatePurchaseOrderStatusCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseOrderStatusId = _data["purchaseOrderStatusId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderStatusCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseOrderStatusId"] = this.purchaseOrderStatusId;
        return data;
    }
}
export class ArchivingSaleInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingSaleInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSaleInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSaleInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSaleInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.invoiceTypeId = _data["invoiceTypeId"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalPrice = _data["totalPrice"];
            this.salePaymentStatusId = _data["salePaymentStatusId"];
            this.toAccountId = _data["toAccountId"];
            this.checkoutName = _data["checkoutName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.categoryId = _data["categoryId"];
            this.invoiceKindId = _data["invoiceKindId"];
            if (Array.isArray(_data["saleInvoiceItems"])) {
                this.saleInvoiceItems = [];
                for (let item of _data["saleInvoiceItems"])
                    this.saleInvoiceItems.push(CreateSaleInvoiceCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSaleInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["invoiceTypeId"] = this.invoiceTypeId;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["totalPrice"] = this.totalPrice;
        data["salePaymentStatusId"] = this.salePaymentStatusId;
        data["toAccountId"] = this.toAccountId;
        data["checkoutName"] = this.checkoutName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["categoryId"] = this.categoryId;
        data["invoiceKindId"] = this.invoiceKindId;
        if (Array.isArray(this.saleInvoiceItems)) {
            data["saleInvoiceItems"] = [];
            for (let item of this.saleInvoiceItems)
                data["saleInvoiceItems"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateSaleInvoiceCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSaleInvoiceCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class DeleteSaleInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSaleInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetSaleInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.invoiceTypeId = _data["invoiceTypeId"];
            this.invoiceTypeName = _data["invoiceTypeName"];
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalPrice = _data["totalPrice"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.salePaymentStatusId = _data["salePaymentStatusId"];
            this.salePaymentStatusName = _data["salePaymentStatusName"];
            this.balance = _data["balance"];
            this.gibInvoiceTypeId = _data["gibInvoiceTypeId"];
            this.gibInvoiceStatusId = _data["gibInvoiceStatusId"];
            this.waybillDate = _data["waybillDate"] ? new Date(_data["waybillDate"].toString()) : undefined;
            this.waybillNumber = _data["waybillNumber"];
            this.gibInvoiceNumber = _data["gibInvoiceNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["saleInvoiceItemModels"])) {
                this.saleInvoiceItemModels = [];
                for (let item of _data["saleInvoiceItemModels"])
                    this.saleInvoiceItemModels.push(GetSaleInvoiceQueryResponseItem.fromJS(item));
            }
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetSaleInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetSaleInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["invoiceTypeId"] = this.invoiceTypeId;
        data["invoiceTypeName"] = this.invoiceTypeName;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["invoiceNumber"] = this.invoiceNumber;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalPrice"] = this.totalPrice;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["salePaymentStatusId"] = this.salePaymentStatusId;
        data["salePaymentStatusName"] = this.salePaymentStatusName;
        data["balance"] = this.balance;
        data["gibInvoiceTypeId"] = this.gibInvoiceTypeId;
        data["gibInvoiceStatusId"] = this.gibInvoiceStatusId;
        data["waybillDate"] = this.waybillDate ? this.waybillDate.toISOString() : undefined;
        data["waybillNumber"] = this.waybillNumber;
        data["gibInvoiceNumber"] = this.gibInvoiceNumber;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.saleInvoiceItemModels)) {
            data["saleInvoiceItemModels"] = [];
            for (let item of this.saleInvoiceItemModels)
                data["saleInvoiceItemModels"].push(item.toJSON());
        }
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        return data;
    }
}
export class GetSaleInvoiceQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleInvoiceQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class GetSaleInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.toAccountName = _data["toAccountName"];
            this.payment = _data["payment"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.name = _data["name"];
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["toAccountName"] = this.toAccountName;
        data["payment"] = this.payment;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["name"] = this.name;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetSaleInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class PagedListOfSearchSaleInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchSaleInvoiceQueryResponse2.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchSaleInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchSaleInvoiceQueryResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.salePaymentStatusName = _data["salePaymentStatusName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.balance = _data["balance"];
            this.categoryName = _data["categoryName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSaleInvoiceQueryResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["salePaymentStatusName"] = this.salePaymentStatusName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["balance"] = this.balance;
        data["categoryName"] = this.categoryName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateSaleInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalTax = _data["totalTax"];
            this.totalPrice = _data["totalPrice"];
            this.invoiceKindId = _data["invoiceKindId"];
            if (Array.isArray(_data["saleInvoiceItems"])) {
                this.saleInvoiceItems = [];
                for (let item of _data["saleInvoiceItems"])
                    this.saleInvoiceItems.push(UpdateSaleInvoiceCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSaleInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["totalTax"] = this.totalTax;
        data["totalPrice"] = this.totalPrice;
        data["invoiceKindId"] = this.invoiceKindId;
        if (Array.isArray(this.saleInvoiceItems)) {
            data["saleInvoiceItems"] = [];
            for (let item of this.saleInvoiceItems)
                data["saleInvoiceItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateSaleInvoiceCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSaleInvoiceCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class ArchivingProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProposalCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.terms = _data["terms"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["proposalItems"])) {
                this.proposalItems = [];
                for (let item of _data["proposalItems"])
                    this.proposalItems.push(CreateProposalCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["terms"] = this.terms;
        data["relatedStaffId"] = this.relatedStaffId;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.proposalItems)) {
            data["proposalItems"] = [];
            for (let item of this.proposalItems)
                data["proposalItems"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateProposalCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class DeleteProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetProposalQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.terms = _data["terms"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalPrice = _data["totalPrice"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.proposalStatusId = _data["proposalStatusId"];
            this.proposalStatusName = _data["proposalStatusName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["proposalItems"])) {
                this.proposalItems = [];
                for (let item of _data["proposalItems"])
                    this.proposalItems.push(GetProposalQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProposalQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["terms"] = this.terms;
        data["relatedStaffId"] = this.relatedStaffId;
        data["relatedStaffName"] = this.relatedStaffName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalPrice"] = this.totalPrice;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["proposalStatusId"] = this.proposalStatusId;
        data["proposalStatusName"] = this.proposalStatusName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.proposalItems)) {
            data["proposalItems"] = [];
            for (let item of this.proposalItems)
                data["proposalItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetProposalQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProposalQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class PagedListOfSearchProposalQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchProposalQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchProposalQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchProposalQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.proposalStatusName = _data["proposalStatusName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProposalQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["proposalStatusName"] = this.proposalStatusName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateProposalCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.terms = _data["terms"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalTax = _data["totalTax"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["proposalItems"])) {
                this.proposalItems = [];
                for (let item of _data["proposalItems"])
                    this.proposalItems.push(UpdateProposalCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposalCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["terms"] = this.terms;
        data["relatedStaffId"] = this.relatedStaffId;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["totalTax"] = this.totalTax;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.proposalItems)) {
            data["proposalItems"] = [];
            for (let item of this.proposalItems)
                data["proposalItems"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateProposalCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposalCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class UpdateProposalStatusCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.proposalStatusId = _data["proposalStatusId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposalStatusCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proposalStatusId"] = this.proposalStatusId;
        return data;
    }
}
export class CreatePaymentRequestCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentRequestCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePaymentRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.companyBalance = _data["companyBalance"];
            this.identityNumber = _data["identityNumber"];
            this.taxNumber = _data["taxNumber"];
            this.iban = _data["iban"];
            this.requestedPayment = _data["requestedPayment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined;
            this.paymentRequestTypeId = _data["paymentRequestTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["companyBalance"] = this.companyBalance;
        data["identityNumber"] = this.identityNumber;
        data["taxNumber"] = this.taxNumber;
        data["iban"] = this.iban;
        data["requestedPayment"] = this.requestedPayment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined;
        data["paymentRequestTypeId"] = this.paymentRequestTypeId;
        return data;
    }
}
export class DeletePaymentRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePaymentRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetAvailablePaymentsQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.companyBalance = _data["companyBalance"];
            this.requestedPayment = _data["requestedPayment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined;
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.approvedPayment = _data["approvedPayment"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailablePaymentsQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["companyBalance"] = this.companyBalance;
        data["requestedPayment"] = this.requestedPayment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["approvedPayment"] = this.approvedPayment;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined;
        return data;
    }
}
export class GetAvailablePaymentsQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailablePaymentsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetConfirmationStateQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
            this.lastStateName = _data["lastStateName"];
            this.canUserApprove = _data["canUserApprove"];
            this.lastConfirmationLevel = _data["lastConfirmationLevel"];
            this.nextConfirmationLevelId = _data["nextConfirmationLevelId"];
            this.nextConfirmationLevelName = _data["nextConfirmationLevelName"];
            if (Array.isArray(_data["nextUserList"])) {
                this.nextUserList = [];
                for (let item of _data["nextUserList"])
                    this.nextUserList.push(GetConfirmationStateQueryResponseUser.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfirmationStateQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        data["lastStateName"] = this.lastStateName;
        data["canUserApprove"] = this.canUserApprove;
        data["lastConfirmationLevel"] = this.lastConfirmationLevel;
        data["nextConfirmationLevelId"] = this.nextConfirmationLevelId;
        data["nextConfirmationLevelName"] = this.nextConfirmationLevelName;
        if (Array.isArray(this.nextUserList)) {
            data["nextUserList"] = [];
            for (let item of this.nextUserList)
                data["nextUserList"].push(item.toJSON());
        }
        return data;
    }
}
export class GetConfirmationStateQueryResponseUser {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfirmationStateQueryResponseUser();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetConfirmationStateQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfirmationStateQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        return data;
    }
}
export class GetPaymentRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.identityNumber = _data["identityNumber"];
            this.taxNumber = _data["taxNumber"];
            this.iban = _data["iban"];
            this.companyBalance = _data["companyBalance"];
            this.requestedPayment = _data["requestedPayment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined;
            this.requestedUserId = _data["requestedUserId"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.approvedPayment = _data["approvedPayment"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined;
            this.firstApprovedUserId = _data["firstApprovedUserId"];
            this.firstApprovedUserNameSurname = _data["firstApprovedUserNameSurname"];
            this.firstApprovedDate = _data["firstApprovedDate"] ? new Date(_data["firstApprovedDate"].toString()) : undefined;
            this.secondApprovedUserId = _data["secondApprovedUserId"];
            this.secondApprovedUserNameSurname = _data["secondApprovedUserNameSurname"];
            this.secondApprovedDate = _data["secondApprovedDate"] ? new Date(_data["secondApprovedDate"].toString()) : undefined;
            this.thirdApprovedUserId = _data["thirdApprovedUserId"];
            this.thirdApprovedUserNameSurname = _data["thirdApprovedUserNameSurname"];
            this.thirdApprovedDate = _data["thirdApprovedDate"] ? new Date(_data["thirdApprovedDate"].toString()) : undefined;
            this.paymentRequestTypeId = _data["paymentRequestTypeId"];
            this.paymentRequestTypeName = _data["paymentRequestTypeName"];
            this.paymentRequestStateId = _data["paymentRequestStateId"];
            this.paymentRequestStateName = _data["paymentRequestStateName"];
            this.canUserUpdate = _data["canUserUpdate"];
            this.canUserUpdateOnConfirmation = _data["canUserUpdateOnConfirmation"];
            if (Array.isArray(_data["paymentRequestConfirmations"])) {
                this.paymentRequestConfirmations = [];
                for (let item of _data["paymentRequestConfirmations"])
                    this.paymentRequestConfirmations.push(GetPaymentRequestQueryResponseConfirmation.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["identityNumber"] = this.identityNumber;
        data["taxNumber"] = this.taxNumber;
        data["iban"] = this.iban;
        data["companyBalance"] = this.companyBalance;
        data["requestedPayment"] = this.requestedPayment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined;
        data["requestedUserId"] = this.requestedUserId;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["approvedPayment"] = this.approvedPayment;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined;
        data["firstApprovedUserId"] = this.firstApprovedUserId;
        data["firstApprovedUserNameSurname"] = this.firstApprovedUserNameSurname;
        data["firstApprovedDate"] = this.firstApprovedDate ? this.firstApprovedDate.toISOString() : undefined;
        data["secondApprovedUserId"] = this.secondApprovedUserId;
        data["secondApprovedUserNameSurname"] = this.secondApprovedUserNameSurname;
        data["secondApprovedDate"] = this.secondApprovedDate ? this.secondApprovedDate.toISOString() : undefined;
        data["thirdApprovedUserId"] = this.thirdApprovedUserId;
        data["thirdApprovedUserNameSurname"] = this.thirdApprovedUserNameSurname;
        data["thirdApprovedDate"] = this.thirdApprovedDate ? this.thirdApprovedDate.toISOString() : undefined;
        data["paymentRequestTypeId"] = this.paymentRequestTypeId;
        data["paymentRequestTypeName"] = this.paymentRequestTypeName;
        data["paymentRequestStateId"] = this.paymentRequestStateId;
        data["paymentRequestStateName"] = this.paymentRequestStateName;
        data["canUserUpdate"] = this.canUserUpdate;
        data["canUserUpdateOnConfirmation"] = this.canUserUpdateOnConfirmation;
        if (Array.isArray(this.paymentRequestConfirmations)) {
            data["paymentRequestConfirmations"] = [];
            for (let item of this.paymentRequestConfirmations)
                data["paymentRequestConfirmations"].push(item.toJSON());
        }
        return data;
    }
}
export class GetPaymentRequestQueryResponseConfirmation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestConfirmationId = _data["paymentRequestConfirmationId"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.approveUserNameSurname = _data["approveUserNameSurname"];
            this.paymentRequestConfirmationStateName = _data["paymentRequestConfirmationStateName"];
            this.paymentRequestConfirmationLevelName = _data["paymentRequestConfirmationLevelName"];
            this.paymentRequestDescription = _data["paymentRequestDescription"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentRequestQueryResponseConfirmation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestConfirmationId"] = this.paymentRequestConfirmationId;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["approveUserNameSurname"] = this.approveUserNameSurname;
        data["paymentRequestConfirmationStateName"] = this.paymentRequestConfirmationStateName;
        data["paymentRequestConfirmationLevelName"] = this.paymentRequestConfirmationLevelName;
        data["paymentRequestDescription"] = this.paymentRequestDescription;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfGetWaitingConfirmationQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(GetWaitingConfirmationQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetWaitingConfirmationQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class GetWaitingConfirmationQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.requestedUserId = _data["requestedUserId"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.approveUserId = _data["approveUserId"];
            this.approveUserNameSurname = _data["approveUserNameSurname"];
            this.paymentRequestConfirmationStateId = _data["paymentRequestConfirmationStateId"];
            this.paymentRequestConfirmationStateName = _data["paymentRequestConfirmationStateName"];
            this.paymentRequestConfirmationLevelId = _data["paymentRequestConfirmationLevelId"];
            this.paymentRequestConfirmationLevelName = _data["paymentRequestConfirmationLevelName"];
            this.paymentRequestId = _data["paymentRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetWaitingConfirmationQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["requestedUserId"] = this.requestedUserId;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["approveUserId"] = this.approveUserId;
        data["approveUserNameSurname"] = this.approveUserNameSurname;
        data["paymentRequestConfirmationStateId"] = this.paymentRequestConfirmationStateId;
        data["paymentRequestConfirmationStateName"] = this.paymentRequestConfirmationStateName;
        data["paymentRequestConfirmationLevelId"] = this.paymentRequestConfirmationLevelId;
        data["paymentRequestConfirmationLevelName"] = this.paymentRequestConfirmationLevelName;
        data["paymentRequestId"] = this.paymentRequestId;
        return data;
    }
}
export class PagedListOfSearchPaymentRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPaymentRequestQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPaymentRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPaymentRequestQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.paymentRequestTypeName = _data["paymentRequestTypeName"];
            this.paymentRequestTypeId = _data["paymentRequestTypeId"];
            this.paymentRequestStateName = _data["paymentRequestStateName"];
            this.requestedPayment = _data["requestedPayment"];
            this.approvedPayment = _data["approvedPayment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPaymentRequestQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["paymentRequestTypeName"] = this.paymentRequestTypeName;
        data["paymentRequestTypeId"] = this.paymentRequestTypeId;
        data["paymentRequestStateName"] = this.paymentRequestStateName;
        data["requestedPayment"] = this.requestedPayment;
        data["approvedPayment"] = this.approvedPayment;
        return data;
    }
}
export class UpdateOnConfirmationStateCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyBalance = _data["companyBalance"];
            this.approvedPayment = _data["approvedPayment"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOnConfirmationStateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyBalance"] = this.companyBalance;
        data["approvedPayment"] = this.approvedPayment;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdatePaymentRequestConfirmationCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
            this.nextConfirmationLevelId = _data["nextConfirmationLevelId"];
            this.lastConfirmationLevel = _data["lastConfirmationLevel"];
            this.nextUserId = _data["nextUserId"];
            this.confirmationStateId = _data["confirmationStateId"];
            this.confirmationNote = _data["confirmationNote"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentRequestConfirmationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        data["nextConfirmationLevelId"] = this.nextConfirmationLevelId;
        data["lastConfirmationLevel"] = this.lastConfirmationLevel;
        data["nextUserId"] = this.nextUserId;
        data["confirmationStateId"] = this.confirmationStateId;
        data["confirmationNote"] = this.confirmationNote;
        return data;
    }
}
export class UpdatePaymentRequestCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyTitle = _data["companyTitle"];
            this.identityNumber = _data["identityNumber"];
            this.taxNumber = _data["taxNumber"];
            this.iban = _data["iban"];
            this.companyBalance = _data["companyBalance"];
            this.requestedPayment = _data["requestedPayment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined;
            this.paymentRequestTypeId = _data["paymentRequestTypeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentRequestCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyTitle"] = this.companyTitle;
        data["identityNumber"] = this.identityNumber;
        data["taxNumber"] = this.taxNumber;
        data["iban"] = this.iban;
        data["companyBalance"] = this.companyBalance;
        data["requestedPayment"] = this.requestedPayment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined;
        data["paymentRequestTypeId"] = this.paymentRequestTypeId;
        return data;
    }
}
export class UpdatePaymentPlanCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentPlanCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        return data;
    }
}
export class CreateExpensePaymentPlanCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpensePaymentPlanCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateExpensePaymentPlanCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpensePaymentPlanCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export class CreatePaymentPlanCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentPlanCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreatePaymentPlanCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.salaryId = _data["salaryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentPlanCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["salaryId"] = this.salaryId;
        return data;
    }
}
export class CreateSalePaymentPlanCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalePaymentPlanCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSalePaymentPlanCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalePaymentPlanCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export class DeletePaymentPlanCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePaymentPlanCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetPaymentPlanQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.paymentPlanTypeId = _data["paymentPlanTypeId"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.checkName = _data["checkName"];
            this.checkId = _data["checkId"];
            this.saleInvoiceName = _data["saleInvoiceName"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseTypeName = _data["expenseTypeName"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.salaryName = _data["salaryName"];
            this.salaryId = _data["salaryId"];
            this.description = _data["description"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentPlanQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["paymentPlanTypeId"] = this.paymentPlanTypeId;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["checkName"] = this.checkName;
        data["checkId"] = this.checkId;
        data["saleInvoiceName"] = this.saleInvoiceName;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseTypeName"] = this.expenseTypeName;
        data["expenseTypeId"] = this.expenseTypeId;
        data["salaryName"] = this.salaryName;
        data["salaryId"] = this.salaryId;
        data["description"] = this.description;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class PagedListOfSearchPaymentPlanForExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPaymentPlanForExpenseInvoiceQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPaymentPlanForExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPaymentPlanForExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseTypeName = _data["expenseTypeName"];
            this.paymentPlanTypeId = _data["paymentPlanTypeId"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.invoiceName = _data["invoiceName"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPaymentPlanForExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseTypeName"] = this.expenseTypeName;
        data["paymentPlanTypeId"] = this.paymentPlanTypeId;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["invoiceName"] = this.invoiceName;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchPaymentPlanForSaleInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPaymentPlanForSaleInvoiceQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPaymentPlanForSaleInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPaymentPlanForSaleInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.paymentPlanTypeId = _data["paymentPlanTypeId"];
            this.paymentPlanTypeName = _data["paymentPlanTypeName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.totalPrice = _data["totalPrice"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.invoiceName = _data["invoiceName"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPaymentPlanForSaleInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["paymentPlanTypeId"] = this.paymentPlanTypeId;
        data["paymentPlanTypeName"] = this.paymentPlanTypeName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["totalPrice"] = this.totalPrice;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["invoiceName"] = this.invoiceName;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchPaymentPlanUnscheduledQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchPaymentPlanUnscheduledQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchPaymentPlanUnscheduledQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchPaymentPlanUnscheduledQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseInvoiceTypeId = _data["expenseInvoiceTypeId"];
            this.expenseInvoiceTypeName = _data["expenseInvoiceTypeName"];
            this.name = _data["name"];
            this.totalPrice = _data["totalPrice"];
            this.unscheduledPrice = _data["unscheduledPrice"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.invoiceTypeName = _data["invoiceTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPaymentPlanUnscheduledQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseInvoiceTypeId"] = this.expenseInvoiceTypeId;
        data["expenseInvoiceTypeName"] = this.expenseInvoiceTypeName;
        data["name"] = this.name;
        data["totalPrice"] = this.totalPrice;
        data["unscheduledPrice"] = this.unscheduledPrice;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["invoiceTypeName"] = this.invoiceTypeName;
        return data;
    }
}
export class CreateOfficialExpenseCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfficialExpenseCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class DeleteOfficialExpenseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOfficialExpenseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class GetOfficialExpenseByExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfficialExpenseByExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetOfficialExpenseByExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfficialExpenseByExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class GetOfficialExpenseQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfficialExpenseQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetOfficialExpenseQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfficialExpenseQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class UpdateOfficialExpenseCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficialExpenseCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        return data;
    }
}
export class CreateGuaranteeLetterCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGuaranteeLetterCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateGuaranteeLetterCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.bankId = _data["bankId"];
            this.branch = _data["branch"];
            this.name = _data["name"];
            this.guaranteeLetterTypeId = _data["guaranteeLetterTypeId"];
            this.guaranteeLetterStateId = _data["guaranteeLetterStateId"];
            this.guaranteeLetterNo = _data["guaranteeLetterNo"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.commissionDate = _data["commissionDate"] ? new Date(_data["commissionDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.beneficiary = _data["beneficiary"];
            this.originalAmount = _data["originalAmount"];
            this.bankCommission = _data["bankCommission"];
            this.balance = _data["balance"];
            this.financialRate = _data["financialRate"];
            this.guaranteeLetterExistenceId = _data["guaranteeLetterExistenceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGuaranteeLetterCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["bankId"] = this.bankId;
        data["branch"] = this.branch;
        data["name"] = this.name;
        data["guaranteeLetterTypeId"] = this.guaranteeLetterTypeId;
        data["guaranteeLetterStateId"] = this.guaranteeLetterStateId;
        data["guaranteeLetterNo"] = this.guaranteeLetterNo;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["commissionDate"] = this.commissionDate ? this.commissionDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["beneficiary"] = this.beneficiary;
        data["originalAmount"] = this.originalAmount;
        data["bankCommission"] = this.bankCommission;
        data["balance"] = this.balance;
        data["financialRate"] = this.financialRate;
        data["guaranteeLetterExistenceId"] = this.guaranteeLetterExistenceId;
        return data;
    }
}
export class DeleteGuaranteeLetterCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGuaranteeLetterCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetGuaranteeLetterQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.bankName = _data["bankName"];
            this.bankId = _data["bankId"];
            this.branch = _data["branch"];
            this.guaranteeLetterTypeName = _data["guaranteeLetterTypeName"];
            this.guaranteeLetterTypeId = _data["guaranteeLetterTypeId"];
            this.guaranteeLetterStateName = _data["guaranteeLetterStateName"];
            this.guaranteeLetterStateId = _data["guaranteeLetterStateId"];
            this.guaranteeLetterExistenceName = _data["guaranteeLetterExistenceName"];
            this.guaranteeLetterExistenceId = _data["guaranteeLetterExistenceId"];
            this.guaranteeLetterNo = _data["guaranteeLetterNo"];
            this.name = _data["name"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.commissionDate = _data["commissionDate"] ? new Date(_data["commissionDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.beneficiary = _data["beneficiary"];
            this.originalAmount = _data["originalAmount"];
            this.balance = _data["balance"];
            this.bankCommission = _data["bankCommission"];
            this.financialRate = _data["financialRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuaranteeLetterQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["bankName"] = this.bankName;
        data["bankId"] = this.bankId;
        data["branch"] = this.branch;
        data["guaranteeLetterTypeName"] = this.guaranteeLetterTypeName;
        data["guaranteeLetterTypeId"] = this.guaranteeLetterTypeId;
        data["guaranteeLetterStateName"] = this.guaranteeLetterStateName;
        data["guaranteeLetterStateId"] = this.guaranteeLetterStateId;
        data["guaranteeLetterExistenceName"] = this.guaranteeLetterExistenceName;
        data["guaranteeLetterExistenceId"] = this.guaranteeLetterExistenceId;
        data["guaranteeLetterNo"] = this.guaranteeLetterNo;
        data["name"] = this.name;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["commissionDate"] = this.commissionDate ? this.commissionDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["beneficiary"] = this.beneficiary;
        data["originalAmount"] = this.originalAmount;
        data["balance"] = this.balance;
        data["bankCommission"] = this.bankCommission;
        data["financialRate"] = this.financialRate;
        return data;
    }
}
export class PagedListOfSearchGuaranteeLetterQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchGuaranteeLetterQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchGuaranteeLetterQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchGuaranteeLetterQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.bankName = _data["bankName"];
            this.bankId = _data["bankId"];
            this.branch = _data["branch"];
            this.guaranteeLetterTypeName = _data["guaranteeLetterTypeName"];
            this.guaranteeLetterTypeId = _data["guaranteeLetterTypeId"];
            this.guaranteeLetterStateName = _data["guaranteeLetterStateName"];
            this.guaranteeLetterStateId = _data["guaranteeLetterStateId"];
            this.guaranteeLetterExistenceName = _data["guaranteeLetterExistenceName"];
            this.guaranteeLetterExistenceId = _data["guaranteeLetterExistenceId"];
            this.guaranteeLetterNo = _data["guaranteeLetterNo"];
            this.name = _data["name"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.commissionDate = _data["commissionDate"] ? new Date(_data["commissionDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.beneficiary = _data["beneficiary"];
            this.originalAmount = _data["originalAmount"];
            this.balance = _data["balance"];
            this.bankCommission = _data["bankCommission"];
            this.financialRate = _data["financialRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchGuaranteeLetterQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["bankName"] = this.bankName;
        data["bankId"] = this.bankId;
        data["branch"] = this.branch;
        data["guaranteeLetterTypeName"] = this.guaranteeLetterTypeName;
        data["guaranteeLetterTypeId"] = this.guaranteeLetterTypeId;
        data["guaranteeLetterStateName"] = this.guaranteeLetterStateName;
        data["guaranteeLetterStateId"] = this.guaranteeLetterStateId;
        data["guaranteeLetterExistenceName"] = this.guaranteeLetterExistenceName;
        data["guaranteeLetterExistenceId"] = this.guaranteeLetterExistenceId;
        data["guaranteeLetterNo"] = this.guaranteeLetterNo;
        data["name"] = this.name;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["commissionDate"] = this.commissionDate ? this.commissionDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["beneficiary"] = this.beneficiary;
        data["originalAmount"] = this.originalAmount;
        data["balance"] = this.balance;
        data["bankCommission"] = this.bankCommission;
        data["financialRate"] = this.financialRate;
        return data;
    }
}
export class UpdateGuaranteeLetterCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.bankId = _data["bankId"];
            this.branch = _data["branch"];
            this.name = _data["name"];
            this.guaranteeLetterTypeId = _data["guaranteeLetterTypeId"];
            this.guaranteeLetterStateId = _data["guaranteeLetterStateId"];
            this.guaranteeLetterExistenceId = _data["guaranteeLetterExistenceId"];
            this.guaranteeLetterNo = _data["guaranteeLetterNo"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.commissionDate = _data["commissionDate"] ? new Date(_data["commissionDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.beneficiary = _data["beneficiary"];
            this.originalAmount = _data["originalAmount"];
            this.bankCommission = _data["bankCommission"];
            this.balance = _data["balance"];
            this.financialRate = _data["financialRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGuaranteeLetterCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["bankId"] = this.bankId;
        data["branch"] = this.branch;
        data["name"] = this.name;
        data["guaranteeLetterTypeId"] = this.guaranteeLetterTypeId;
        data["guaranteeLetterStateId"] = this.guaranteeLetterStateId;
        data["guaranteeLetterExistenceId"] = this.guaranteeLetterExistenceId;
        data["guaranteeLetterNo"] = this.guaranteeLetterNo;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["commissionDate"] = this.commissionDate ? this.commissionDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["beneficiary"] = this.beneficiary;
        data["originalAmount"] = this.originalAmount;
        data["bankCommission"] = this.bankCommission;
        data["balance"] = this.balance;
        data["financialRate"] = this.financialRate;
        return data;
    }
}
export class GetInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.ublVersionId = _data["ublVersionId"];
            this.customizationId = _data["customizationId"];
            this.profileId = _data["profileId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.copyIndicator = _data["copyIndicator"];
            this.uuid = _data["uuid"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.issueTime = _data["issueTime"];
            this.invoiceTypeCode = _data["invoiceTypeCode"];
            this.note = _data["note"];
            this.documentCurrencyCode = _data["documentCurrencyCode"];
            this.lineCountNumeric = _data["lineCountNumeric"];
            this.supplierWebsiteURI = _data["supplierWebsiteURI"];
            this.supplierTCKN = _data["supplierTCKN"];
            this.supplierVKN = _data["supplierVKN"];
            this.supplierName = _data["supplierName"];
            this.supplierAddressStreet = _data["supplierAddressStreet"];
            this.supplierAddressCitySubdivisionName = _data["supplierAddressCitySubdivisionName"];
            this.supplierAddressCityName = _data["supplierAddressCityName"];
            this.supplierAddressPostalZone = _data["supplierAddressPostalZone"];
            this.supplierCountryCode = _data["supplierCountryCode"];
            this.supplierCountryName = _data["supplierCountryName"];
            this.supplierTaxName = _data["supplierTaxName"];
            this.supplierContactPhone = _data["supplierContactPhone"];
            this.supplierContactFax = _data["supplierContactFax"];
            this.supplierContactEmail = _data["supplierContactEmail"];
            this.supplierPersonFirstName = _data["supplierPersonFirstName"];
            this.supplierPersonLastName = _data["supplierPersonLastName"];
            this.customerWebsiteURI = _data["customerWebsiteURI"];
            this.customerTCKN = _data["customerTCKN"];
            this.customerVKN = _data["customerVKN"];
            this.customerName = _data["customerName"];
            this.customerAddressStreet = _data["customerAddressStreet"];
            this.customerAddressCitySubdivisionName = _data["customerAddressCitySubdivisionName"];
            this.customerAddressCityName = _data["customerAddressCityName"];
            this.customerAddressPostalZone = _data["customerAddressPostalZone"];
            this.customerCountryCode = _data["customerCountryCode"];
            this.customerCountryName = _data["customerCountryName"];
            this.customerTaxName = _data["customerTaxName"];
            this.customerContactPhone = _data["customerContactPhone"];
            this.customerContactFax = _data["customerContactFax"];
            this.customerContactEmail = _data["customerContactEmail"];
            this.customerPersonFirstName = _data["customerPersonFirstName"];
            this.customerPersonLastName = _data["customerPersonLastName"];
            this.lineExtensionAmount = _data["lineExtensionAmount"];
            this.lineExtensionAmountCurrencyId = _data["lineExtensionAmountCurrencyId"];
            this.taxExclusiveAmount = _data["taxExclusiveAmount"];
            this.taxExclusiveAmountCurrencyId = _data["taxExclusiveAmountCurrencyId"];
            this.taxInclusiveAmount = _data["taxInclusiveAmount"];
            this.taxInclusiveAmountCurrencyId = _data["taxInclusiveAmountCurrencyId"];
            this.allowanceTotalAmount = _data["allowanceTotalAmount"];
            this.allowanceTotalAmountCurrencyId = _data["allowanceTotalAmountCurrencyId"];
            this.chargeTotalAmount = _data["chargeTotalAmount"];
            this.chargeTotalAmountCurrencyId = _data["chargeTotalAmountCurrencyId"];
            this.payableAmount = _data["payableAmount"];
            this.payableAmountCurrencyId = _data["payableAmountCurrencyId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["invoiceItemModels"])) {
                this.invoiceItemModels = [];
                for (let item of _data["invoiceItemModels"])
                    this.invoiceItemModels.push(GetInvoiceQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ublVersionId"] = this.ublVersionId;
        data["customizationId"] = this.customizationId;
        data["profileId"] = this.profileId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["copyIndicator"] = this.copyIndicator;
        data["uuid"] = this.uuid;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["issueTime"] = this.issueTime;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["note"] = this.note;
        data["documentCurrencyCode"] = this.documentCurrencyCode;
        data["lineCountNumeric"] = this.lineCountNumeric;
        data["supplierWebsiteURI"] = this.supplierWebsiteURI;
        data["supplierTCKN"] = this.supplierTCKN;
        data["supplierVKN"] = this.supplierVKN;
        data["supplierName"] = this.supplierName;
        data["supplierAddressStreet"] = this.supplierAddressStreet;
        data["supplierAddressCitySubdivisionName"] = this.supplierAddressCitySubdivisionName;
        data["supplierAddressCityName"] = this.supplierAddressCityName;
        data["supplierAddressPostalZone"] = this.supplierAddressPostalZone;
        data["supplierCountryCode"] = this.supplierCountryCode;
        data["supplierCountryName"] = this.supplierCountryName;
        data["supplierTaxName"] = this.supplierTaxName;
        data["supplierContactPhone"] = this.supplierContactPhone;
        data["supplierContactFax"] = this.supplierContactFax;
        data["supplierContactEmail"] = this.supplierContactEmail;
        data["supplierPersonFirstName"] = this.supplierPersonFirstName;
        data["supplierPersonLastName"] = this.supplierPersonLastName;
        data["customerWebsiteURI"] = this.customerWebsiteURI;
        data["customerTCKN"] = this.customerTCKN;
        data["customerVKN"] = this.customerVKN;
        data["customerName"] = this.customerName;
        data["customerAddressStreet"] = this.customerAddressStreet;
        data["customerAddressCitySubdivisionName"] = this.customerAddressCitySubdivisionName;
        data["customerAddressCityName"] = this.customerAddressCityName;
        data["customerAddressPostalZone"] = this.customerAddressPostalZone;
        data["customerCountryCode"] = this.customerCountryCode;
        data["customerCountryName"] = this.customerCountryName;
        data["customerTaxName"] = this.customerTaxName;
        data["customerContactPhone"] = this.customerContactPhone;
        data["customerContactFax"] = this.customerContactFax;
        data["customerContactEmail"] = this.customerContactEmail;
        data["customerPersonFirstName"] = this.customerPersonFirstName;
        data["customerPersonLastName"] = this.customerPersonLastName;
        data["lineExtensionAmount"] = this.lineExtensionAmount;
        data["lineExtensionAmountCurrencyId"] = this.lineExtensionAmountCurrencyId;
        data["taxExclusiveAmount"] = this.taxExclusiveAmount;
        data["taxExclusiveAmountCurrencyId"] = this.taxExclusiveAmountCurrencyId;
        data["taxInclusiveAmount"] = this.taxInclusiveAmount;
        data["taxInclusiveAmountCurrencyId"] = this.taxInclusiveAmountCurrencyId;
        data["allowanceTotalAmount"] = this.allowanceTotalAmount;
        data["allowanceTotalAmountCurrencyId"] = this.allowanceTotalAmountCurrencyId;
        data["chargeTotalAmount"] = this.chargeTotalAmount;
        data["chargeTotalAmountCurrencyId"] = this.chargeTotalAmountCurrencyId;
        data["payableAmount"] = this.payableAmount;
        data["payableAmountCurrencyId"] = this.payableAmountCurrencyId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.invoiceItemModels)) {
            data["invoiceItemModels"] = [];
            for (let item of this.invoiceItemModels)
                data["invoiceItemModels"].push(item.toJSON());
        }
        return data;
    }
}
export class GetInvoiceQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.order = _data["order"];
            this.note = _data["note"];
            this.invoicedQuantityUnitCode = _data["invoicedQuantityUnitCode"];
            this.amount = _data["amount"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.lineExtensionAmountCurrencyId = _data["lineExtensionAmountCurrencyId"];
            this.taxTotalAmountCurrencyId = _data["taxTotalAmountCurrencyId"];
            this.totalTax = _data["totalTax"];
            this.taxSubtotalTaxAmountCurrencyId = _data["taxSubtotalTaxAmountCurrencyId"];
            this.taxSubtotalTaxAmount = _data["taxSubtotalTaxAmount"];
            this.taxSubtotalTaxableAmountCurrencyId = _data["taxSubtotalTaxableAmountCurrencyId"];
            this.taxSubtotalTaxableAmount = _data["taxSubtotalTaxableAmount"];
            this.taxSubtotalPercent = _data["taxSubtotalPercent"];
            this.totalPrice = _data["totalPrice"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.taxSubtotalTaxCategoryTaxSchemeName = _data["taxSubtotalTaxCategoryTaxSchemeName"];
            this.taxSubtotalTaxCategoryTaxSchemeTaxTypeCode = _data["taxSubtotalTaxCategoryTaxSchemeTaxTypeCode"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.itemSellersItemIdentificationId = _data["itemSellersItemIdentificationId"];
            this.priceAmountCurrencyId = _data["priceAmountCurrencyId"];
            this.unitPrice = _data["unitPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["order"] = this.order;
        data["note"] = this.note;
        data["invoicedQuantityUnitCode"] = this.invoicedQuantityUnitCode;
        data["amount"] = this.amount;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["subTotalPrice"] = this.subTotalPrice;
        data["lineExtensionAmountCurrencyId"] = this.lineExtensionAmountCurrencyId;
        data["taxTotalAmountCurrencyId"] = this.taxTotalAmountCurrencyId;
        data["totalTax"] = this.totalTax;
        data["taxSubtotalTaxAmountCurrencyId"] = this.taxSubtotalTaxAmountCurrencyId;
        data["taxSubtotalTaxAmount"] = this.taxSubtotalTaxAmount;
        data["taxSubtotalTaxableAmountCurrencyId"] = this.taxSubtotalTaxableAmountCurrencyId;
        data["taxSubtotalTaxableAmount"] = this.taxSubtotalTaxableAmount;
        data["taxSubtotalPercent"] = this.taxSubtotalPercent;
        data["totalPrice"] = this.totalPrice;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["taxSubtotalTaxCategoryTaxSchemeName"] = this.taxSubtotalTaxCategoryTaxSchemeName;
        data["taxSubtotalTaxCategoryTaxSchemeTaxTypeCode"] = this.taxSubtotalTaxCategoryTaxSchemeTaxTypeCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["itemSellersItemIdentificationId"] = this.itemSellersItemIdentificationId;
        data["priceAmountCurrencyId"] = this.priceAmountCurrencyId;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}
export class PagedListOfSearchInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchInvoiceQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.ublVersionId = _data["ublVersionId"];
            this.customizationId = _data["customizationId"];
            this.profileId = _data["profileId"];
            this.gibInvoiceNumber = _data["gibInvoiceNumber"];
            this.copyIndicator = _data["copyIndicator"];
            this.uuid = _data["uuid"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined;
            this.issueTime = _data["issueTime"];
            this.invoiceTypeCode = _data["invoiceTypeCode"];
            this.note = _data["note"];
            this.documentCurrencyCode = _data["documentCurrencyCode"];
            this.lineCountNumeric = _data["lineCountNumeric"];
            this.supplierWebsiteURI = _data["supplierWebsiteURI"];
            this.supplierTCKN = _data["supplierTCKN"];
            this.supplierVKN = _data["supplierVKN"];
            this.supplierName = _data["supplierName"];
            this.supplierAddressStreet = _data["supplierAddressStreet"];
            this.supplierAddressCitySubdivisionName = _data["supplierAddressCitySubdivisionName"];
            this.supplierAddressCityName = _data["supplierAddressCityName"];
            this.supplierAddressPostalZone = _data["supplierAddressPostalZone"];
            this.supplierCountryCode = _data["supplierCountryCode"];
            this.supplierCountryName = _data["supplierCountryName"];
            this.supplierTaxName = _data["supplierTaxName"];
            this.supplierContactPhone = _data["supplierContactPhone"];
            this.supplierContactFax = _data["supplierContactFax"];
            this.supplierContactEmail = _data["supplierContactEmail"];
            this.supplierPersonFirstName = _data["supplierPersonFirstName"];
            this.supplierPersonLastName = _data["supplierPersonLastName"];
            this.customerWebsiteURI = _data["customerWebsiteURI"];
            this.customerTCKN = _data["customerTCKN"];
            this.customerVKN = _data["customerVKN"];
            this.customerName = _data["customerName"];
            this.customerAddressStreet = _data["customerAddressStreet"];
            this.customerAddressCitySubdivisionName = _data["customerAddressCitySubdivisionName"];
            this.customerAddressCityName = _data["customerAddressCityName"];
            this.customerAddressPostalZone = _data["customerAddressPostalZone"];
            this.customerCountryCode = _data["customerCountryCode"];
            this.customerCountryName = _data["customerCountryName"];
            this.customerTaxName = _data["customerTaxName"];
            this.customerContactPhone = _data["customerContactPhone"];
            this.customerContactFax = _data["customerContactFax"];
            this.customerContactEmail = _data["customerContactEmail"];
            this.customerPersonFirstName = _data["customerPersonFirstName"];
            this.customerPersonLastName = _data["customerPersonLastName"];
            this.lineExtensionAmount = _data["lineExtensionAmount"];
            this.lineExtensionAmountCurrencyId = _data["lineExtensionAmountCurrencyId"];
            this.taxExclusiveAmount = _data["taxExclusiveAmount"];
            this.taxExclusiveAmountCurrencyId = _data["taxExclusiveAmountCurrencyId"];
            this.taxInclusiveAmount = _data["taxInclusiveAmount"];
            this.taxInclusiveAmountCurrencyId = _data["taxInclusiveAmountCurrencyId"];
            this.allowanceTotalAmount = _data["allowanceTotalAmount"];
            this.allowanceTotalAmountCurrencyId = _data["allowanceTotalAmountCurrencyId"];
            this.chargeTotalAmount = _data["chargeTotalAmount"];
            this.chargeTotalAmountCurrencyId = _data["chargeTotalAmountCurrencyId"];
            this.payableAmount = _data["payableAmount"];
            this.payableAmountCurrencyId = _data["payableAmountCurrencyId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ublVersionId"] = this.ublVersionId;
        data["customizationId"] = this.customizationId;
        data["profileId"] = this.profileId;
        data["gibInvoiceNumber"] = this.gibInvoiceNumber;
        data["copyIndicator"] = this.copyIndicator;
        data["uuid"] = this.uuid;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined;
        data["issueTime"] = this.issueTime;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["note"] = this.note;
        data["documentCurrencyCode"] = this.documentCurrencyCode;
        data["lineCountNumeric"] = this.lineCountNumeric;
        data["supplierWebsiteURI"] = this.supplierWebsiteURI;
        data["supplierTCKN"] = this.supplierTCKN;
        data["supplierVKN"] = this.supplierVKN;
        data["supplierName"] = this.supplierName;
        data["supplierAddressStreet"] = this.supplierAddressStreet;
        data["supplierAddressCitySubdivisionName"] = this.supplierAddressCitySubdivisionName;
        data["supplierAddressCityName"] = this.supplierAddressCityName;
        data["supplierAddressPostalZone"] = this.supplierAddressPostalZone;
        data["supplierCountryCode"] = this.supplierCountryCode;
        data["supplierCountryName"] = this.supplierCountryName;
        data["supplierTaxName"] = this.supplierTaxName;
        data["supplierContactPhone"] = this.supplierContactPhone;
        data["supplierContactFax"] = this.supplierContactFax;
        data["supplierContactEmail"] = this.supplierContactEmail;
        data["supplierPersonFirstName"] = this.supplierPersonFirstName;
        data["supplierPersonLastName"] = this.supplierPersonLastName;
        data["customerWebsiteURI"] = this.customerWebsiteURI;
        data["customerTCKN"] = this.customerTCKN;
        data["customerVKN"] = this.customerVKN;
        data["customerName"] = this.customerName;
        data["customerAddressStreet"] = this.customerAddressStreet;
        data["customerAddressCitySubdivisionName"] = this.customerAddressCitySubdivisionName;
        data["customerAddressCityName"] = this.customerAddressCityName;
        data["customerAddressPostalZone"] = this.customerAddressPostalZone;
        data["customerCountryCode"] = this.customerCountryCode;
        data["customerCountryName"] = this.customerCountryName;
        data["customerTaxName"] = this.customerTaxName;
        data["customerContactPhone"] = this.customerContactPhone;
        data["customerContactFax"] = this.customerContactFax;
        data["customerContactEmail"] = this.customerContactEmail;
        data["customerPersonFirstName"] = this.customerPersonFirstName;
        data["customerPersonLastName"] = this.customerPersonLastName;
        data["lineExtensionAmount"] = this.lineExtensionAmount;
        data["lineExtensionAmountCurrencyId"] = this.lineExtensionAmountCurrencyId;
        data["taxExclusiveAmount"] = this.taxExclusiveAmount;
        data["taxExclusiveAmountCurrencyId"] = this.taxExclusiveAmountCurrencyId;
        data["taxInclusiveAmount"] = this.taxInclusiveAmount;
        data["taxInclusiveAmountCurrencyId"] = this.taxInclusiveAmountCurrencyId;
        data["allowanceTotalAmount"] = this.allowanceTotalAmount;
        data["allowanceTotalAmountCurrencyId"] = this.allowanceTotalAmountCurrencyId;
        data["chargeTotalAmount"] = this.chargeTotalAmount;
        data["chargeTotalAmountCurrencyId"] = this.chargeTotalAmountCurrencyId;
        data["payableAmount"] = this.payableAmount;
        data["payableAmountCurrencyId"] = this.payableAmountCurrencyId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class SendInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}
export class ArchivingExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBankExpenseInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankExpenseInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBankExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.fromAccountId = _data["fromAccountId"];
            this.checkoutName = _data["checkoutName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.categoryId = _data["categoryId"];
            this.bankId = _data["bankId"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["fromAccountId"] = this.fromAccountId;
        data["checkoutName"] = this.checkoutName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["categoryId"] = this.categoryId;
        data["bankId"] = this.bankId;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class CreateExpenseInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateExpenseInvoiceCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseInvoiceCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class CreateFastExpenseInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFastExpenseInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSundryExpenseInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSundryExpenseInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateSundryExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.fromAccountId = _data["fromAccountId"];
            this.checkoutName = _data["checkoutName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.categoryId = _data["categoryId"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSundryExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["fromAccountId"] = this.fromAccountId;
        data["checkoutName"] = this.checkoutName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["categoryId"] = this.categoryId;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class CreateTaxExpenseInvoiceCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxExpenseInvoiceCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateTaxExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.fromAccountId = _data["fromAccountId"];
            this.checkoutName = _data["checkoutName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.categoryId = _data["categoryId"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["fromAccountId"] = this.fromAccountId;
        data["checkoutName"] = this.checkoutName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["categoryId"] = this.categoryId;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class DeleteExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetBankExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.balance = _data["balance"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetBankExpenseInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetBankExpenseInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
            this.totalOfficalExpense = _data["totalOfficalExpense"];
            if (Array.isArray(_data["officialExpenses"])) {
                this.officialExpenses = [];
                for (let item of _data["officialExpenses"])
                    this.officialExpenses.push(GetBankExpenseInvoiceQueryResponseOfficialExpense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["balance"] = this.balance;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        data["totalOfficalExpense"] = this.totalOfficalExpense;
        if (Array.isArray(this.officialExpenses)) {
            data["officialExpenses"] = [];
            for (let item of this.officialExpenses)
                data["officialExpenses"].push(item.toJSON());
        }
        return data;
    }
}
export class GetBankExpenseInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountName = _data["fromAccountName"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankExpenseInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountName"] = this.fromAccountName;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetBankExpenseInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankExpenseInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class GetBankExpenseInvoiceQueryResponseOfficialExpense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankExpenseInvoiceQueryResponseOfficialExpense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetBankExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.invoiceTypeId = _data["invoiceTypeId"];
            this.invoiceTypeName = _data["invoiceTypeName"];
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalDiscount = _data["totalDiscount"];
            this.grossTotalPrice = _data["grossTotalPrice"];
            this.totalWitholding = _data["totalWitholding"];
            this.totalPricePlusWithHolding = _data["totalPricePlusWithHolding"];
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.balance = _data["balance"];
            this.fileUrl = _data["fileUrl"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.isGibInvoice = _data["isGibInvoice"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            if (Array.isArray(_data["expenseInvoiceItemModels"])) {
                this.expenseInvoiceItemModels = [];
                for (let item of _data["expenseInvoiceItemModels"])
                    this.expenseInvoiceItemModels.push(GetExpenseInvoiceQueryResponseItem.fromJS(item));
            }
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetExpenseInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetExpenseInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
            this.totalOfficalExpense = _data["totalOfficalExpense"];
            if (Array.isArray(_data["officialExpenses"])) {
                this.officialExpenses = [];
                for (let item of _data["officialExpenses"])
                    this.officialExpenses.push(GetExpenseInvoiceQueryResponseOfficialExpense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["invoiceTypeId"] = this.invoiceTypeId;
        data["invoiceTypeName"] = this.invoiceTypeName;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["invoiceNumber"] = this.invoiceNumber;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalDiscount"] = this.totalDiscount;
        data["grossTotalPrice"] = this.grossTotalPrice;
        data["totalWitholding"] = this.totalWitholding;
        data["totalPricePlusWithHolding"] = this.totalPricePlusWithHolding;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["balance"] = this.balance;
        data["fileUrl"] = this.fileUrl;
        data["relatedStaffId"] = this.relatedStaffId;
        data["relatedStaffName"] = this.relatedStaffName;
        data["isGibInvoice"] = this.isGibInvoice;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        if (Array.isArray(this.expenseInvoiceItemModels)) {
            data["expenseInvoiceItemModels"] = [];
            for (let item of this.expenseInvoiceItemModels)
                data["expenseInvoiceItemModels"].push(item.toJSON());
        }
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        data["totalOfficalExpense"] = this.totalOfficalExpense;
        if (Array.isArray(this.officialExpenses)) {
            data["officialExpenses"] = [];
            for (let item of this.officialExpenses)
                data["officialExpenses"].push(item.toJSON());
        }
        return data;
    }
}
export class GetExpenseInvoiceQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.productUnitName = _data["productUnitName"];
            this.taxId = _data["taxId"];
            this.taxName = _data["taxName"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["productUnitName"] = this.productUnitName;
        data["taxId"] = this.taxId;
        data["taxName"] = this.taxName;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class GetExpenseInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountName = _data["fromAccountName"];
            this.payment = _data["payment"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountName"] = this.fromAccountName;
        data["payment"] = this.payment;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetExpenseInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class GetExpenseInvoiceQueryResponseOfficialExpense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQueryResponseOfficialExpense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetFastExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.balance = _data["balance"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.relatedStaffId = _data["relatedStaffId"];
            this.relatedStaffName = _data["relatedStaffName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetFastExpenseInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetFastExpenseInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
            this.totalOfficalExpense = _data["totalOfficalExpense"];
            if (Array.isArray(_data["officialExpenses"])) {
                this.officialExpenses = [];
                for (let item of _data["officialExpenses"])
                    this.officialExpenses.push(GetFastExpenseInvoiceQueryResponseOfficialExpense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFastExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalTax"] = this.totalTax;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["balance"] = this.balance;
        data["fileUrl"] = this.fileUrl;
        data["invoiceNumber"] = this.invoiceNumber;
        data["relatedStaffId"] = this.relatedStaffId;
        data["relatedStaffName"] = this.relatedStaffName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        data["totalOfficalExpense"] = this.totalOfficalExpense;
        if (Array.isArray(this.officialExpenses)) {
            data["officialExpenses"] = [];
            for (let item of this.officialExpenses)
                data["officialExpenses"].push(item.toJSON());
        }
        return data;
    }
}
export class GetFastExpenseInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountName = _data["fromAccountName"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFastExpenseInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountName"] = this.fromAccountName;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetFastExpenseInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFastExpenseInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class GetFastExpenseInvoiceQueryResponseOfficialExpense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFastExpenseInvoiceQueryResponseOfficialExpense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetFastExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFastExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetSundryExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.balance = _data["balance"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetSundryExpenseInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetSundryExpenseInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
            this.totalOfficalExpense = _data["totalOfficalExpense"];
            if (Array.isArray(_data["officialExpenses"])) {
                this.officialExpenses = [];
                for (let item of _data["officialExpenses"])
                    this.officialExpenses.push(GetSundryExpenseInvoiceQueryResponseOfficialExpense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSundryExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["balance"] = this.balance;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        data["totalOfficalExpense"] = this.totalOfficalExpense;
        if (Array.isArray(this.officialExpenses)) {
            data["officialExpenses"] = [];
            for (let item of this.officialExpenses)
                data["officialExpenses"].push(item.toJSON());
        }
        return data;
    }
}
export class GetSundryExpenseInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountName = _data["fromAccountName"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSundryExpenseInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountName"] = this.fromAccountName;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetSundryExpenseInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSundryExpenseInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class GetSundryExpenseInvoiceQueryResponseOfficialExpense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSundryExpenseInvoiceQueryResponseOfficialExpense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetSundryExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSundryExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetTaxExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusId = _data["expensePaymentStatusId"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.balance = _data["balance"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.invoiceKindId = _data["invoiceKindId"];
            this.invoiceKindName = _data["invoiceKindName"];
            if (Array.isArray(_data["checkoutModels"])) {
                this.checkoutModels = [];
                for (let item of _data["checkoutModels"])
                    this.checkoutModels.push(GetTaxExpenseInvoiceQueryResponseCheckout.fromJS(item));
            }
            if (Array.isArray(_data["paymentPlans"])) {
                this.paymentPlans = [];
                for (let item of _data["paymentPlans"])
                    this.paymentPlans.push(GetTaxExpenseInvoiceQueryResponsePaymentPlan.fromJS(item));
            }
            this.totalOfficalExpense = _data["totalOfficalExpense"];
            if (Array.isArray(_data["officialExpenses"])) {
                this.officialExpenses = [];
                for (let item of _data["officialExpenses"])
                    this.officialExpenses.push(GetTaxExpenseInvoiceQueryResponseOfficialExpense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusId"] = this.expensePaymentStatusId;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["balance"] = this.balance;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["invoiceKindId"] = this.invoiceKindId;
        data["invoiceKindName"] = this.invoiceKindName;
        if (Array.isArray(this.checkoutModels)) {
            data["checkoutModels"] = [];
            for (let item of this.checkoutModels)
                data["checkoutModels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentPlans)) {
            data["paymentPlans"] = [];
            for (let item of this.paymentPlans)
                data["paymentPlans"].push(item.toJSON());
        }
        data["totalOfficalExpense"] = this.totalOfficalExpense;
        if (Array.isArray(this.officialExpenses)) {
            data["officialExpenses"] = [];
            for (let item of this.officialExpenses)
                data["officialExpenses"].push(item.toJSON());
        }
        return data;
    }
}
export class GetTaxExpenseInvoiceQueryResponseCheckout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountName = _data["fromAccountName"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxExpenseInvoiceQueryResponseCheckout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountName"] = this.fromAccountName;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetTaxExpenseInvoiceQueryResponsePaymentPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxExpenseInvoiceQueryResponsePaymentPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}
export class GetTaxExpenseInvoiceQueryResponseOfficialExpense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.name = _data["name"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.totalWithHolding = _data["totalWithHolding"];
            this.fileId = _data["fileId"];
            this.fileUrl = _data["fileUrl"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxExpenseInvoiceQueryResponseOfficialExpense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["name"] = this.name;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["totalWithHolding"] = this.totalWithHolding;
        data["fileId"] = this.fileId;
        data["fileUrl"] = this.fileUrl;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class GetTaxExpenseInvoiceQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxExpenseInvoiceQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedListOfSearchExpenseInvoiceQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchExpenseInvoiceQueryResponse2.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchExpenseInvoiceQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchExpenseInvoiceQueryResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.delayDay = _data["delayDay"];
            this.totalPrice = _data["totalPrice"];
            this.expensePaymentStatusName = _data["expensePaymentStatusName"];
            this.invoiceKindName = _data["invoiceKindName"];
            this.balance = _data["balance"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseTypeName = _data["expenseTypeName"];
            this.categoryName = _data["categoryName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchExpenseInvoiceQueryResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["delayDay"] = this.delayDay;
        data["totalPrice"] = this.totalPrice;
        data["expensePaymentStatusName"] = this.expensePaymentStatusName;
        data["invoiceKindName"] = this.invoiceKindName;
        data["balance"] = this.balance;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseTypeName"] = this.expenseTypeName;
        data["categoryName"] = this.categoryName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateBankExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.totalTax = _data["totalTax"];
            this.bankId = _data["bankId"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["totalTax"] = this.totalTax;
        data["bankId"] = this.bankId;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class UpdateExpenseInvoiceCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.warehouseId = _data["warehouseId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.productUnitId = _data["productUnitId"];
            this.taxId = _data["taxId"];
            this.totalTax = _data["totalTax"];
            this.subTotalPrice = _data["subTotalPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.discountTypeId = _data["discountTypeId"];
            this.discountRate = _data["discountRate"];
            this.discount = _data["discount"];
            this.witholdingRateId = _data["witholdingRateId"];
            this.witholding = _data["witholding"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseInvoiceCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["warehouseId"] = this.warehouseId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["productUnitId"] = this.productUnitId;
        data["taxId"] = this.taxId;
        data["totalTax"] = this.totalTax;
        data["subTotalPrice"] = this.subTotalPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["discountTypeId"] = this.discountTypeId;
        data["discountRate"] = this.discountRate;
        data["discount"] = this.discount;
        data["witholdingRateId"] = this.witholdingRateId;
        data["witholding"] = this.witholding;
        return data;
    }
}
export class UpdateSundryExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSundryExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class UpdateTaxExpenseInvoiceCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.invoiceKindId = _data["invoiceKindId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxExpenseInvoiceCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["invoiceKindId"] = this.invoiceKindId;
        return data;
    }
}
export class CheckAddCollectionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.checkId = _data["checkId"];
            this.toAccountId = _data["toAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAddCollectionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["checkId"] = this.checkId;
        data["toAccountId"] = this.toAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["description"] = this.description;
        return data;
    }
}
export class CheckAddPaymentCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.checkId = _data["checkId"];
            this.fromAccountId = _data["fromAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAddPaymentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["checkId"] = this.checkId;
        data["fromAccountId"] = this.fromAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["description"] = this.description;
        return data;
    }
}
export class GetCheckQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.usedAmount = _data["usedAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.fromCompanyId = _data["fromCompanyId"];
            this.fromCompanyName = _data["fromCompanyName"];
            this.toCompanyId = _data["toCompanyId"];
            this.toCompanyName = _data["toCompanyName"];
            this.checkTypeId = _data["checkTypeId"];
            this.checkTypeName = _data["checkTypeName"];
            this.checkStateId = _data["checkStateId"];
            this.checkStateName = _data["checkStateName"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.saleInvoiceName = _data["saleInvoiceName"];
            this.saleInvoiceCompanyId = _data["saleInvoiceCompanyId"];
            this.saleInvoiceCompanyName = _data["saleInvoiceCompanyName"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.expenseInvoiceCompanyId = _data["expenseInvoiceCompanyId"];
            this.expenseInvoiceCompanyName = _data["expenseInvoiceCompanyName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            if (Array.isArray(_data["expenseInvoices"])) {
                this.expenseInvoices = [];
                for (let item of _data["expenseInvoices"])
                    this.expenseInvoices.push(GetCheckQueryResponseExpenseInvoice.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["usedAmount"] = this.usedAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["fromCompanyId"] = this.fromCompanyId;
        data["fromCompanyName"] = this.fromCompanyName;
        data["toCompanyId"] = this.toCompanyId;
        data["toCompanyName"] = this.toCompanyName;
        data["checkTypeId"] = this.checkTypeId;
        data["checkTypeName"] = this.checkTypeName;
        data["checkStateId"] = this.checkStateId;
        data["checkStateName"] = this.checkStateName;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["saleInvoiceName"] = this.saleInvoiceName;
        data["saleInvoiceCompanyId"] = this.saleInvoiceCompanyId;
        data["saleInvoiceCompanyName"] = this.saleInvoiceCompanyName;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["expenseInvoiceCompanyId"] = this.expenseInvoiceCompanyId;
        data["expenseInvoiceCompanyName"] = this.expenseInvoiceCompanyName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        if (Array.isArray(this.expenseInvoices)) {
            data["expenseInvoices"] = [];
            for (let item of this.expenseInvoices)
                data["expenseInvoices"].push(item.toJSON());
        }
        return data;
    }
}
export class GetCheckQueryResponseExpenseInvoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.expenseInvoiceName = _data["expenseInvoiceName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckQueryResponseExpenseInvoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["expenseInvoiceName"] = this.expenseInvoiceName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["amount"] = this.amount;
        return data;
    }
}
export class PagedListOfSearchCheckQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchCheckQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchCheckQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchCheckQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.usedAmount = _data["usedAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.fromCompanyId = _data["fromCompanyId"];
            this.fromCompanyName = _data["fromCompanyName"];
            this.toCompanyId = _data["toCompanyId"];
            this.toCompanyName = _data["toCompanyName"];
            this.checkTypeId = _data["checkTypeId"];
            this.checkTypeName = _data["checkTypeName"];
            this.checkStateId = _data["checkStateId"];
            this.checkStateName = _data["checkStateName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCheckQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["usedAmount"] = this.usedAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["fromCompanyId"] = this.fromCompanyId;
        data["fromCompanyName"] = this.fromCompanyName;
        data["toCompanyId"] = this.toCompanyId;
        data["toCompanyName"] = this.toCompanyName;
        data["checkTypeId"] = this.checkTypeId;
        data["checkTypeName"] = this.checkTypeName;
        data["checkStateId"] = this.checkStateId;
        data["checkStateName"] = this.checkStateName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateAdvanceCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdvanceCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class UpdateCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        return data;
    }
}
export class AccountToAccountTransactionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fromAccountId = _data["fromAccountId"];
            this.toAccountId = _data["toAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountToAccountTransactionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fromAccountId"] = this.fromAccountId;
        data["toAccountId"] = this.toAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class CompanyCollectionCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCollectionCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CompanyCollectionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.toAccountId = _data["toAccountId"];
            this.companyId = _data["companyId"];
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCollectionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["toAccountId"] = this.toAccountId;
        data["companyId"] = this.companyId;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class CompanyPayCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.checkId = _data["checkId"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPayCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["checkId"] = this.checkId;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class CompanyPaymentCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPaymentCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CompanyPaymentCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.fromAccountId = _data["fromAccountId"];
            this.companyId = _data["companyId"];
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPaymentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["fromAccountId"] = this.fromAccountId;
        data["companyId"] = this.companyId;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class CompanyPayNewCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.toCompanyId = _data["toCompanyId"];
            this.isOfficial = _data["isOfficial"];
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPayNewCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["toCompanyId"] = this.toCompanyId;
        data["isOfficial"] = this.isOfficial;
        data["projectId"] = this.projectId;
        return data;
    }
}
export class CreditTransactionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fromAccountId = _data["fromAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.isOfficial = _data["isOfficial"];
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTransactionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fromAccountId"] = this.fromAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["isOfficial"] = this.isOfficial;
        data["projectId"] = this.projectId;
        return data;
    }
}
export class DebitTransactionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.toAccountId = _data["toAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.isOfficial = _data["isOfficial"];
            this.projectId = _data["projectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DebitTransactionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["toAccountId"] = this.toAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["isOfficial"] = this.isOfficial;
        data["projectId"] = this.projectId;
        return data;
    }
}
export class ExpenseInvoicePayCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.checkId = _data["checkId"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoicePayCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["checkId"] = this.checkId;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class ExpenseInvoicePayMoneyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.fromAccountId = _data["fromAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoicePayMoneyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["fromAccountId"] = this.fromAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class ExpenseInvoicePayNewCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expenseInvoiceId = _data["expenseInvoiceId"];
            this.bankId = _data["bankId"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseInvoicePayNewCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        data["bankId"] = this.bankId;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class GetCheckoutQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountId = _data["fromAccountId"];
            this.fromAccountName = _data["fromAccountName"];
            this.relationId = _data["relationId"];
            this.toAccountId = _data["toAccountId"];
            this.toAccountName = _data["toAccountName"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.processTypeName = _data["processTypeName"];
            this.staffId = _data["staffId"];
            this.currencyId = _data["currencyId"];
            this.rate = _data["rate"];
            this.currencyName = _data["currencyName"];
            this.currencyCode = _data["currencyCode"];
            this.staffNameSurname = _data["staffNameSurname"];
            this.checkId = _data["checkId"];
            this.checkNo = _data["checkNo"];
            this.salaryId = _data["salaryId"];
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.expenseInvoiceId = _data["expenseInvoiceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckoutQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountId"] = this.fromAccountId;
        data["fromAccountName"] = this.fromAccountName;
        data["relationId"] = this.relationId;
        data["toAccountId"] = this.toAccountId;
        data["toAccountName"] = this.toAccountName;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["processTypeName"] = this.processTypeName;
        data["staffId"] = this.staffId;
        data["currencyId"] = this.currencyId;
        data["rate"] = this.rate;
        data["currencyName"] = this.currencyName;
        data["currencyCode"] = this.currencyCode;
        data["staffNameSurname"] = this.staffNameSurname;
        data["checkId"] = this.checkId;
        data["checkNo"] = this.checkNo;
        data["salaryId"] = this.salaryId;
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["expenseInvoiceId"] = this.expenseInvoiceId;
        return data;
    }
}
export class GetCollectionReceiptQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionReceiptQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}
export class GetCollectionReceiptQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.checkoutId = _data["checkoutId"];
            this.exportTypeName = _data["exportTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionReceiptQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["checkoutId"] = this.checkoutId;
        data["exportTypeName"] = this.exportTypeName;
        return data;
    }
}
export class SalaryPaymentCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryPaymentCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class SalaryPaymentCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.salaryId = _data["salaryId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.fromAccountId = _data["fromAccountId"];
            this.toAccountId = _data["toAccountId"];
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryPaymentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["salaryId"] = this.salaryId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["fromAccountId"] = this.fromAccountId;
        data["toAccountId"] = this.toAccountId;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["staffId"] = this.staffId;
        return data;
    }
}
export class SaleInvoiceReceiveCheckCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.bankId = _data["bankId"];
            this.checkNo = _data["checkNo"];
            this.description = _data["description"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : undefined;
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.totalPrice = _data["totalPrice"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceReceiveCheckCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["bankId"] = this.bankId;
        data["checkNo"] = this.checkNo;
        data["description"] = this.description;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : undefined;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["totalPrice"] = this.totalPrice;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class SaleInvoiceReceiveMoneyCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.saleInvoiceId = _data["saleInvoiceId"];
            this.toAccountId = _data["toAccountId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.payment = _data["payment"];
            this.name = _data["name"];
            this.isOfficial = _data["isOfficial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvoiceReceiveMoneyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["saleInvoiceId"] = this.saleInvoiceId;
        data["toAccountId"] = this.toAccountId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["payment"] = this.payment;
        data["name"] = this.name;
        data["isOfficial"] = this.isOfficial;
        return data;
    }
}
export class SearchCheckoutByStaffIdQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.name = _data["name"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCheckoutByStaffIdQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["name"] = this.name;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["amount"] = this.amount;
        return data;
    }
}
export class SearchCheckoutByStaffIdQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.staffAccountId = _data["staffAccountId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCheckoutByStaffIdQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["staffAccountId"] = this.staffAccountId;
        return data;
    }
}
export class PagedListOfSearchTransactionsQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchTransactionsQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchTransactionsQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchTransactionsQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.toAccountName = _data["toAccountName"];
            this.fromAccountName = _data["fromAccountName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.checkoutProcessTypeName = _data["checkoutProcessTypeName"];
            this.amount = _data["amount"];
            this.currencyName = _data["currencyName"];
            this.currencySymbol = _data["currencySymbol"];
            this.currencyCode = _data["currencyCode"];
            this.rate = _data["rate"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTransactionsQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["toAccountName"] = this.toAccountName;
        data["fromAccountName"] = this.fromAccountName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["checkoutProcessTypeName"] = this.checkoutProcessTypeName;
        data["amount"] = this.amount;
        data["currencyName"] = this.currencyName;
        data["currencySymbol"] = this.currencySymbol;
        data["currencyCode"] = this.currencyCode;
        data["rate"] = this.rate;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class StaffPaymentCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffPaymentCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class StaffPaymentCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.fromAccountId = _data["fromAccountId"];
            this.toAccountId = _data["toAccountId"];
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.staffId = _data["staffId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffPaymentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["fromAccountId"] = this.fromAccountId;
        data["toAccountId"] = this.toAccountId;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["staffId"] = this.staffId;
        return data;
    }
}
export class UpdateCheckoutDescriptionCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckoutDescriptionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}
export class PagedListOfSearchCheckoutApproveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchCheckoutApproveQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchCheckoutApproveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchCheckoutApproveQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.checkoutId = _data["checkoutId"];
            this.payment = _data["payment"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.checkoutUserNameSurname = _data["checkoutUserNameSurname"];
            this.approvedUserNameSurname = _data["approvedUserNameSurname"];
            this.checkoutApproveStateName = _data["checkoutApproveStateName"];
            this.fromAccountName = _data["fromAccountName"];
            this.toAccountName = _data["toAccountName"];
            this.invoiceName = _data["invoiceName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCheckoutApproveQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["checkoutId"] = this.checkoutId;
        data["payment"] = this.payment;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["checkoutUserNameSurname"] = this.checkoutUserNameSurname;
        data["approvedUserNameSurname"] = this.approvedUserNameSurname;
        data["checkoutApproveStateName"] = this.checkoutApproveStateName;
        data["fromAccountName"] = this.fromAccountName;
        data["toAccountName"] = this.toAccountName;
        data["invoiceName"] = this.invoiceName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateCheckoutApproveConfirmationCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.checkoutId = _data["checkoutId"];
            this.checkoutApproveStateId = _data["checkoutApproveStateId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckoutApproveConfirmationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkoutId"] = this.checkoutId;
        data["checkoutApproveStateId"] = this.checkoutApproveStateId;
        return data;
    }
}
export class CompleteBankPaymentOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bankPaymentOrderId = _data["bankPaymentOrderId"];
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["bankPaymentOrderItemIds"])) {
                this.bankPaymentOrderItemIds = [];
                for (let item of _data["bankPaymentOrderItemIds"])
                    this.bankPaymentOrderItemIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteBankPaymentOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bankPaymentOrderId"] = this.bankPaymentOrderId;
        data["accountId"] = this.accountId;
        if (Array.isArray(this.bankPaymentOrderItemIds)) {
            data["bankPaymentOrderItemIds"] = [];
            for (let item of this.bankPaymentOrderItemIds)
                data["bankPaymentOrderItemIds"].push(item);
        }
        return data;
    }
}
export class CreateBankPaymentOrderCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankPaymentOrderCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBankPaymentOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            if (Array.isArray(_data["paymentRequestList"])) {
                this.paymentRequestList = [];
                for (let item of _data["paymentRequestList"])
                    this.paymentRequestList.push(CreateBankPaymentOrderCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankPaymentOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        if (Array.isArray(this.paymentRequestList)) {
            data["paymentRequestList"] = [];
            for (let item of this.paymentRequestList)
                data["paymentRequestList"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateBankPaymentOrderCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankPaymentOrderCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        return data;
    }
}
export class DeleteBankPaymentOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBankPaymentOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetPaymentRequestForExcelReportQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentRequestForExcelReportQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}
export class GetPaymentRequestForExcelReportQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bankPaymentOrderId = _data["bankPaymentOrderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentRequestForExcelReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bankPaymentOrderId"] = this.bankPaymentOrderId;
        return data;
    }
}
export class GetBankPaymentOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.requestedUserId = _data["requestedUserId"];
            this.requestedUserNameSurname = _data["requestedUserNameSurname"];
            this.requestedPayment = _data["requestedPayment"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.approvedPayment = _data["approvedPayment"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined;
            this.approvedUserId = _data["approvedUserId"];
            this.approvedUserNameSurname = _data["approvedUserNameSurname"];
            this.bankPaymentOrderStateId = _data["bankPaymentOrderStateId"];
            this.bankPaymentOrderStateName = _data["bankPaymentOrderStateName"];
            this.canUpdate = _data["canUpdate"];
            this.canApprove = _data["canApprove"];
            this.canSendConfirmation = _data["canSendConfirmation"];
            this.canCompleteBankOrder = _data["canCompleteBankOrder"];
            this.bankCashAccountId = _data["bankCashAccountId"];
            this.bankCashAccountName = _data["bankCashAccountName"];
            if (Array.isArray(_data["bankPaymentOrderUsers"])) {
                this.bankPaymentOrderUsers = [];
                for (let item of _data["bankPaymentOrderUsers"])
                    this.bankPaymentOrderUsers.push(GetBankPaymentOrderQueryResponseUser.fromJS(item));
            }
            if (Array.isArray(_data["bankPaymentOrderItems"])) {
                this.bankPaymentOrderItems = [];
                for (let item of _data["bankPaymentOrderItems"])
                    this.bankPaymentOrderItems.push(GetBankPaymentOrderQueryResponseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankPaymentOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["requestedUserId"] = this.requestedUserId;
        data["requestedUserNameSurname"] = this.requestedUserNameSurname;
        data["requestedPayment"] = this.requestedPayment;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["approvedPayment"] = this.approvedPayment;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined;
        data["approvedUserId"] = this.approvedUserId;
        data["approvedUserNameSurname"] = this.approvedUserNameSurname;
        data["bankPaymentOrderStateId"] = this.bankPaymentOrderStateId;
        data["bankPaymentOrderStateName"] = this.bankPaymentOrderStateName;
        data["canUpdate"] = this.canUpdate;
        data["canApprove"] = this.canApprove;
        data["canSendConfirmation"] = this.canSendConfirmation;
        data["canCompleteBankOrder"] = this.canCompleteBankOrder;
        data["bankCashAccountId"] = this.bankCashAccountId;
        data["bankCashAccountName"] = this.bankCashAccountName;
        if (Array.isArray(this.bankPaymentOrderUsers)) {
            data["bankPaymentOrderUsers"] = [];
            for (let item of this.bankPaymentOrderUsers)
                data["bankPaymentOrderUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.bankPaymentOrderItems)) {
            data["bankPaymentOrderItems"] = [];
            for (let item of this.bankPaymentOrderItems)
                data["bankPaymentOrderItems"].push(item.toJSON());
        }
        return data;
    }
}
export class GetBankPaymentOrderQueryResponseUser {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankPaymentOrderQueryResponseUser();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class GetBankPaymentOrderQueryResponseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paymentRequestId = _data["paymentRequestId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.companyTitle = _data["companyTitle"];
            this.companyBalance = _data["companyBalance"];
            this.requestedPayment = _data["requestedPayment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined;
            this.approvedPayment = _data["approvedPayment"];
            this.accountName = _data["accountName"];
            this.accountId = _data["accountId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankPaymentOrderQueryResponseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentRequestId"] = this.paymentRequestId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["companyTitle"] = this.companyTitle;
        data["companyBalance"] = this.companyBalance;
        data["requestedPayment"] = this.requestedPayment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined;
        data["approvedPayment"] = this.approvedPayment;
        data["accountName"] = this.accountName;
        data["accountId"] = this.accountId;
        return data;
    }
}
export class PagedListOfSearchBankPaymentOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchBankPaymentOrderQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchBankPaymentOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchBankPaymentOrderQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.requestedPayment = _data["requestedPayment"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.approvedPayment = _data["approvedPayment"];
            this.bankPaymentOrderStateId = _data["bankPaymentOrderStateId"];
            this.bankPaymentOrderStateName = _data["bankPaymentOrderStateName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBankPaymentOrderQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["requestedPayment"] = this.requestedPayment;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["approvedPayment"] = this.approvedPayment;
        data["bankPaymentOrderStateId"] = this.bankPaymentOrderStateId;
        data["bankPaymentOrderStateName"] = this.bankPaymentOrderStateName;
        return data;
    }
}
export class UpdateBankPaymentOrderConfirmationCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bankPaymentOrderId = _data["bankPaymentOrderId"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined;
            this.approved = _data["approved"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankPaymentOrderConfirmationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bankPaymentOrderId"] = this.bankPaymentOrderId;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined;
        data["approved"] = this.approved;
        return data;
    }
}
export class UpdateBankPaymentOrderCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            if (Array.isArray(_data["paymentRequestList"])) {
                this.paymentRequestList = [];
                for (let item of _data["paymentRequestList"])
                    this.paymentRequestList.push(UpdateBankPaymentOrderCommandItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankPaymentOrderCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        if (Array.isArray(this.paymentRequestList)) {
            data["paymentRequestList"] = [];
            for (let item of this.paymentRequestList)
                data["paymentRequestList"].push(item.toJSON());
        }
        return data;
    }
}
export class UpdateBankPaymentOrderCommandItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankPaymentOrderCommandItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        return data;
    }
}
export class UpdateSendToConfirmationCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.approvedUserId = _data["approvedUserId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSendToConfirmationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvedUserId"] = this.approvedUserId;
        return data;
    }
}
export class ArchivingAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBankAccountCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankAccountCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateBankAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accountTypeId = _data["accountTypeId"];
            this.name = _data["name"];
            this.bankName = _data["bankName"];
            this.branch = _data["branch"];
            this.accountNumber = _data["accountNumber"];
            this.iban = _data["iban"];
            this.projectId = _data["projectId"];
            this.currencyId = _data["currencyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accountTypeId"] = this.accountTypeId;
        data["name"] = this.name;
        data["bankName"] = this.bankName;
        data["branch"] = this.branch;
        data["accountNumber"] = this.accountNumber;
        data["iban"] = this.iban;
        data["projectId"] = this.projectId;
        data["currencyId"] = this.currencyId;
        return data;
    }
}
export class CreateCashAccountCommandResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashAccountCommandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class CreateCashAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.currencyId = _data["currencyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["currencyId"] = this.currencyId;
        return data;
    }
}
export class CurrentAccountStatementQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentAccountStatementQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}
export class CurrentAccountStatementQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.exportTypeName = _data["exportTypeName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentAccountStatementQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["exportTypeName"] = this.exportTypeName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        return data;
    }
}
export class DeleteAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetAccountQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accountTypeId = _data["accountTypeId"];
            this.accountTypeName = _data["accountTypeName"];
            this.bankName = _data["bankName"];
            this.branch = _data["branch"];
            this.accountNumber = _data["accountNumber"];
            this.iban = _data["iban"];
            this.balance = _data["balance"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accountTypeId"] = this.accountTypeId;
        data["accountTypeName"] = this.accountTypeName;
        data["bankName"] = this.bankName;
        data["branch"] = this.branch;
        data["accountNumber"] = this.accountNumber;
        data["iban"] = this.iban;
        data["balance"] = this.balance;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class PagedListOfSearchAccountQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SearchAccountQueryResponse.fromJS(item));
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfSearchAccountQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
export class SearchAccountQueryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.accountTypeName = _data["accountTypeName"];
            this.name = _data["name"];
            this.iban = _data["iban"];
            this.bankBranchName = _data["bankBranchName"];
            this.balance = _data["balance"];
            this.currencyId = _data["currencyId"];
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.currencyName = _data["currencyName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAccountQueryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountTypeName"] = this.accountTypeName;
        data["name"] = this.name;
        data["iban"] = this.iban;
        data["bankBranchName"] = this.bankBranchName;
        data["balance"] = this.balance;
        data["currencyId"] = this.currencyId;
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["currencyName"] = this.currencyName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class SearchTransactionsQueryResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fromAccountId = _data["fromAccountId"];
            this.fromAccountName = _data["fromAccountName"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined;
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.processTypeId = _data["processTypeId"];
            this.currencyId = _data["currencyId"];
            this.currencySymbol = _data["currencySymbol"];
            this.currencyCode = _data["currencyCode"];
            this.rate = _data["rate"];
            this.processTypeName = _data["processTypeName"];
            this.balance = _data["balance"];
            this.isOfficial = _data["isOfficial"];
            this.isOfficialName = _data["isOfficialName"];
            this.createdBy = _data["createdBy"];
            this.defermentDate = _data["defermentDate"] ? new Date(_data["defermentDate"].toString()) : undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTransactionsQueryResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAccountId"] = this.fromAccountId;
        data["fromAccountName"] = this.fromAccountName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["processTypeId"] = this.processTypeId;
        data["currencyId"] = this.currencyId;
        data["currencySymbol"] = this.currencySymbol;
        data["currencyCode"] = this.currencyCode;
        data["rate"] = this.rate;
        data["processTypeName"] = this.processTypeName;
        data["balance"] = this.balance;
        data["isOfficial"] = this.isOfficial;
        data["isOfficialName"] = this.isOfficialName;
        data["createdBy"] = this.createdBy;
        data["defermentDate"] = this.defermentDate ? this.defermentDate.toISOString() : undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined;
        return data;
    }
}
export class SearchTransactionsQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTransactionsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class UpdateBankAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bankName = _data["bankName"];
            this.branch = _data["branch"];
            this.accountNumber = _data["accountNumber"];
            this.iban = _data["iban"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bankName"] = this.bankName;
        data["branch"] = this.branch;
        data["accountNumber"] = this.accountNumber;
        data["iban"] = this.iban;
        return data;
    }
}
export class UpdateCashAccountCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCashAccountCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class DeleteCheckoutCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCheckoutCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
  let responseJson = JSON.parse(response);
  let errorMessage = "";

  if (responseJson["errors"] != null && responseJson["errors"]["title"] != null) {
    errorMessage = responseJson["errors"]["title"][0];
  }
  else if (responseJson["detail"] != null) {
    errorMessage = responseJson["detail"];
  }
  else if (responseJson["title"] != null) {
    errorMessage = responseJson["title"];
  }

  if (errorMessage != "") {
    //alert(errorMessage);
    toast.error(errorMessage, { autoClose: 5000, theme: "colored" })
  }


  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

